import React from 'react';
import { IProps, IState } from './types';
import { Formik, Form, Field, FieldArray, ErrorMessage, getIn } from 'formik';
import { DatePicker } from 'formik-antd';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType as InsTypeEnum, InsType } from 'constants/enums/insType.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import service from 'bff/services/carProductService';
import { InprocessSelectState, InprocessSelectFormValue } from 'constants/models/components/insureProcessCar/inprocessSelect';
import { ValidVehiclePolicyPeriodRes, VehiclePlanContent, PlanItemListContent, ValidVehicleInsContentReq, ValidVehicleInsFailItem, EvalCarReq, EvalCarResPolicyItemContent, RenewalPremContent, VehiclePlan } from 'bff/models/product';
import { VehiclePolicyStatus } from 'constants/enums/vehiclePolicyStatus.enum';
import { VehiclePolicyType } from 'constants/enums/vehiclePolicyType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import _ from 'lodash';
import { PolicyItemListContent, PolicyBaseItemContent, PolicyBaseItemOptContent, PolicyBaseItemOptAmtContent, ItemRelativeBaseContent, AffectedItemContent, ConstrainContent, CriteriaContent, LimitationContent } from 'bff/models/product/vehicleItemList';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import { IVehicleOwnerInfoFormValue } from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
import { IVehicleInfoFormValue, IVehicleInfoState } from 'constants/models/components/insureProcessCar/vehicleInfo';
import { setRuleValidErrorModalVisible, setInfoModalVisibleAction } from 'redux/actions/modal.action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { NationalType } from 'constants/enums/nationalType.enum';
import environment from 'constants/environments';
import Fold from 'components/Fold';
import { SysOption } from 'bff/models/info';
import InputWithRegex from 'components/InputWithRegex';
import { NumAndEnglishDashRegex } from 'utils/commonValidations';
import { ApplyType } from 'constants/enums/applyType.enum';
import { RootReducersState } from 'redux/reducers';
import { PlanType } from 'constants/enums/travelPlanType.enum';
import { VehiclePowerType } from 'constants/enums/vehiclePowerType.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import FormikFocusError from 'components/FormikFocusError';
import { VehiclePowerValidationExpressionSymbols } from 'constants/enums/vehiclePowerValidationExpressionSymbols.enum';
import apiCommonService from 'bff/services/commonService';
import { VehicleItemTypeMatchesText } from 'constants/models/vehicleItemTypeMatchesText';
import { ContractType } from 'constants/enums/contractType.enum';
import { PolicyItemMandatory } from 'constants/enums/policyItemMandatory.enum';
import { YesNo } from 'constants/enums/yesNo.enum';
import { Rule } from 'utils/types';
import VehicleReg from '../VehicleReg/VehicleReg';
import { VehRegResp } from 'bff/models/info/infoVehregdata';
import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';

const initFormVal: InprocessSelectFormValue = {
  ENGINE_NUMBER: '',
  VEHICAL_BODY_NUMBER: '',
  COMPULSORY_INS_YEAR: '',
  COMPULSORY_INS_EFFECTIVE_DATE: '',
  ARBITRARY_INS_EFFECTIVE_DATE: '',
  POLICY_ITEM: new Array(0),
  COMPULSORY_INS_EFFECTIVE_DATE_CHECK_TIME: 0
};

const initState: IState = {
  vehicleItemList: {
    INS_TYPE_ID: '',
    POLICY_ITEM: new Array(0)
  },
  policyItem: new Array(0),
  activePlan: '',
  activeProdId: '',
  activePlanName: '',
  disableProduct: false,
  isCompulsoryDateError: false,
  isArbitraryDateError: false,
  showCalcBtn: false,
  freePlanId: '',
  replacementPrice: '',
  evalCarRes: {
    STARTDATE: '',
    ENDDATE: '',
    SUMPREMIUM: new Array(0),
    PROGRAM_ID: '',
    VEHICLE_DATA: {
      LICENSENO: '',
      CARKINDCODE: '',
      ENROLLDATE: '',
      MAKEDATE: '',
      MODELCODE: '',
      SEATCOUNT: 0,
      EXHAUSTSCALE: 0,
      PURCHASEPRICE: '',
      ACTUALVALUE: ''
    },
    POLICY_ITEM_LIST: new Array(0)
  },
  validVehicleInsRuleRes: {
    FORCE_BCTYPE_B: false,
    FORCE_BCTYPE_C: false,
    REQUIRE_CAR_SURVEY: false
  },
  vehicleInfoDetailsOpen: true,
  attachedContractFoldsOpen: [],
  vehicleOwnerInfoFixedVisible: false,
  motoCoprdSysOpts: new Array(0),
  constrainErrors: new Array(0),
  isRenewalAndUnEdit: false,
  extenCode: new Array(0),
  depreciateAmt: 0,
  hasWebInsuredItem: false,
  isReplanementPriceError: false,
  sysTime: 0,
  planChange: false,
  isTeslaPlan: false,
  isEcarPlan: false,
};

let formInitialValues: InprocessSelectFormValue = initFormVal;

class InsureProcessSelect extends React.Component<IProps, IState> {
  private vehicalInfoRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private formikRef: any = React.createRef();
  private vehicleInfoDetailsRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private productAreaRef: any = React.createRef();
  private inputAreaRef: any = React.createRef();
  private isUseEcarPlan: boolean = this.props.tempVehicleInfo.tempVehicleInfoState?.isUseEcarPlan ?? false;
  // 前端擴充：主、附約勾選規則
  private selectRule = commonService.getFrontendRule('33A_33B_SELECTION');
  private selectRules: Rule[] = this.selectRule ? [this.selectRule] : [];

  state: IState = initState;

  componentDidMount = async () => {
    commonService.scrollToTop();
    this.addWindowScrollEvent();

    const { tempSelectFormValue, tempSelectState } = this.props.tempSelect;
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    const { tempVehicleInfoFormValue, tempVehicleInfoState } = this.props.tempVehicleInfo;
    const fetchedIsTeslaPlanValue = await service.fetchIsTeslaPlan() === '0' ? true : false;

    this.setState({
      isTeslaPlan: fetchedIsTeslaPlanValue,
      isEcarPlan: fetchedIsTeslaPlanValue && this.isUseEcarPlan,
    });
    
    // 解密 F14-079 上行電文
    let regdata: VehRegResp[] = [];
    const ciphertext = storageService.getItem(storageKeys.Vehregdata);
    if (ciphertext) {
      const bytes = AES.decrypt(ciphertext, 'vehicle core protection');
      const dataItem = JSON.parse(bytes.toString(encUtf8));
      if (dataItem) {
        const response = await service.infoVehregdata({ DATA: [dataItem] });
        if (response) {
          regdata = response;
        }
      }
    }
    const coredata = regdata.find(it => it.ID === tempVehicleOwnerInfoFormValue?.MEMBER_ID && it.ISSUCCESS === YesNo.Yes);

    // 有暫存的資料、且有商品資料，為資料填寫頁返回來的
    if (
      tempVehicleOwnerInfoFormValue &&
      tempSelectFormValue &&
      tempSelectState &&
      tempSelectState.policyItem.length > 0) {
      this.handleInitTempData(regdata, tempSelectFormValue, tempSelectState, tempVehicleOwnerInfoFormValue);
      // this.setInitAttachedContractFoldsOpen();
      return;
    }

    // 有暫存的表單資料，為重新進到頁面
    if (this.props.tempSelect && this.props.tempSelect.tempSelectFormValue) {
      formInitialValues = {
        ...formInitialValues,
        ...this.props.tempSelect.tempSelectFormValue
      };
    }

    // 初始化強制險、任意險預定生效日，並提示相關訊息
    await this.handleInitEffectiveDate();

    const brandCode = this.props.tempVehicleInfo.tempVehicleInfoState?.activeBrand;
    const isEcarPlate = this.props.tempVehicleInfo.tempVehicleInfoState?.isEcarPlate;
    const initSetting = !this.state.isEcarPlan
      // 取得初始資料 (一般方案，非電動車方案)
      ? await service.fetchInitSelect(
        this.props.insTypeId,
        brandCode || '',
        this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.VEHICLE_TYPE || '',
        this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '',
        isEcarPlate
      )
      // 取得初始資料 (電動車方案)
      : await service.fetchInitSelectForEcar(this.props.insTypeId);

    // 車險方案 (含保障內容)
    let vehiclePlan = await service.fetchVehiclePlan(
      this.props.insTypeId,
      brandCode || '',
      this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '',
      brandCode || '',
      this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.VEHICLE_TYPE || '',
      isEcarPlate
    );

    // 若使用「電動車專屬方案」，組合保障內容資料格式
    if (this.state.isEcarPlan && vehiclePlan) {
      // 將「電動車車險保障內容」資料組合成「原車險保障內容」資料格式
      const defaultPlanIndex = 0;
      initSetting.vehicleItemList.POLICY_ITEM = this.handleCombineVehicleItemListForEcar(vehiclePlan.VEHICLE_PLAN[defaultPlanIndex]);
    }

    let freePlanId = '';
    let disableProduct = true;
    let activePlan = this.props.prodId;
    if (vehiclePlan) {
      vehiclePlan = this.handleFilterVehiclePlan(vehiclePlan);
      freePlanId = this.handleGetFreePlanId(vehiclePlan);
      const planIndex = _.findIndex(vehiclePlan.VEHICLE_PLAN, (plan: VehiclePlanContent) => plan.PLAN_ID === activePlan);
      if (planIndex === -1) {
        activePlan = '';
      }

      if (vehiclePlan && vehiclePlan.VEHICLE_PLAN && vehiclePlan.VEHICLE_PLAN.length === 1) {
        activePlan = freePlanId;
        disableProduct = false;
      }

      disableProduct = activePlan !== freePlanId;
    }

    // 設定保障項目預設值
    let policyItems = this.handleSetPolicyItemDefult(initSetting.vehicleItemList.POLICY_ITEM);
    // 取得 折舊金額
    const depreciateAmt = await this.handleGetDepreciateAmt(policyItems, activePlan, activePlan, vehiclePlan?.VEHICLE_PLAN);

    if (activePlan === freePlanId) {
      policyItems = this.handleFilterPolicyItem(policyItems, depreciateAmt);
    }

    let formPolicyItemsVal = [...policyItems];

    // 若有商品 ID 預設選取
    if (activePlan && vehiclePlan) {
      formPolicyItemsVal = this.handleSetPlanCheck(activePlan, vehiclePlan.VEHICLE_PLAN, formPolicyItemsVal);
    }

    // 預設欄位展開為關閉
    let attachedContractFoldsArr = this.handleGetAttachedContractFolds(formPolicyItemsVal, false);
    this.setState(prevState => {
      return {
        ...prevState,
        attachedContractFoldsOpen: [...attachedContractFoldsArr]
      };
    });

    let enginNum: string = this.props.tempSelect.tempSelectFormValue?.ENGINE_NUMBER || '';
    let vehicleNum: string = this.props.tempSelect.tempSelectFormValue?.VEHICAL_BODY_NUMBER || '';
    let isRenewalAndUnEdit = false;

    // 若有核心資料，則覆蓋至表單 (不處理車身號碼)
    if (coredata) {
      enginNum = coredata.ENGINENO;
      vehicleNum = coredata.FRAMENO;
    }

    // if (coredata) {
    //   vehicleNum = coredata.FRAMENO;
    // }

    // 若有續保件，則以「續保件」為主 (續保件優先權最高，不可覆蓋)
    if (
      this.props.tempVehicleInfo.tempVehicleInfoState &&
      this.props.tempVehicleInfo.tempVehicleInfoState.renewVehicle &&
      Object.keys(this.props.tempVehicleInfo.tempVehicleInfoState.renewVehicle).length > 0
    ) {
      const renewal = { ...this.props.tempVehicleInfo.tempVehicleInfoState.renewVehicle };

      enginNum = renewal.IENGINE ?? '';
      vehicleNum = renewal.IBODY ?? '';
      isRenewalAndUnEdit = true;

      if (activePlan === freePlanId) {
        if (!this.state.isEcarPlan) {
          // 一般方案，非電動車方案
          formPolicyItemsVal = this.handleSetRenewalVal(renewal.Prem, formPolicyItemsVal);
          // 核續保資料與當前保障項目是否有停賣、保額調整項目
          this.handleCheckRenewalContent(this.state.isEcarPlan, renewal.Prem, formPolicyItemsVal);
          formPolicyItemsVal = this.handleSetAffectiveItem(formPolicyItemsVal, policyItems);
          attachedContractFoldsArr = this.handleGetAttachedContractFolds(formPolicyItemsVal, true);
        } else {
          // 電動車方案
          // 核續保資料與當前保障項目是否有停賣、保額調整項目
          this.handleCheckRenewalContent(this.state.isEcarPlan, renewal.Prem, formPolicyItemsVal);
        }
      }
    }

    if (activePlan && activePlan !== freePlanId) {
      formPolicyItemsVal = this.handleFilterCheckItem(formPolicyItemsVal);

      attachedContractFoldsArr = this.handleGetAttachedContractFolds(formPolicyItemsVal, true);
    }

    formInitialValues = {
      ...formInitialValues,
      POLICY_ITEM: [...formPolicyItemsVal],
      ENGINE_NUMBER: enginNum,
      VEHICAL_BODY_NUMBER: vehicleNum
    };

    // 查詢重置價格
    let replacementPrice;
    let replacementPriceError = false;

    if (this.props.insTypeId === InsType.Car && tempVehicleInfoState && !tempVehicleInfoState.isMidday && moment().hour() >= 12) {
      replacementPrice = await this.handleGetReplacementPrice();
      replacementPriceError = !replacementPrice;
    }

    if (!replacementPrice) {
      replacementPrice = tempVehicleInfoFormValue?.REPLACEMENT_PRICE || '';
    }

    let planName = '';
    if (vehiclePlan && vehiclePlan.VEHICLE_PLAN) {
      planName = _.find(vehiclePlan.VEHICLE_PLAN, (plan: VehiclePlanContent) => plan.PLAN_ID === activePlan)?.PLAN_NAME || '';
    }

    this.setState({
      activePlan: activePlan,
      activeProdId: activePlan,
      activePlanName: planName,
      vehiclePlan: vehiclePlan,
      vehicleItemList: { ...initSetting.vehicleItemList },
      policyItem: [...policyItems],
      freePlanId: freePlanId,
      motoCoprdSysOpts: [...initSetting.motoCoprdSysOpts],
      disableProduct: disableProduct,
      showCalcBtn: true,
      isRenewalAndUnEdit: isRenewalAndUnEdit,
      extenCode: [...initSetting.extenCodes],
      attachedContractFoldsOpen: [...attachedContractFoldsArr],
      depreciateAmt: depreciateAmt,
      replacementPrice: replacementPrice,
      isReplanementPriceError: replacementPriceError,
    });

    // this.setInitAttachedContractFoldsOpen();
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;
    this.props.onUnmount(formVal, this.state);

    this.removeWindowScrollEvent();
    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得進入頁面過中午的重置價格
   */
  handleGetReplacementPrice = async () => {
    const { tempVehicleInfoFormValue, tempVehicleInfoState } = this.props.tempVehicleInfo;
    const { tempVehicleOwnerInfoState } = this.props.tempVehicleOwnerInfo;

    if (
      !tempVehicleOwnerInfoState ||
      !tempVehicleInfoState ||
      !tempVehicleInfoFormValue ||
      !tempVehicleInfoFormValue.VEHICAL_MODEL ||
      tempVehicleInfoFormValue.VEHICAL_MODEL.indexOf(',') === -1
    ) return;

    const typeCode = tempVehicleInfoFormValue.VEHICAL_MODEL.split(',');

    // 預設為系統日加 1 天
    let momentVal = moment().add(1, 'd');
    let showMsg = true;

    const policyPeriod = tempVehicleOwnerInfoState.policyPeriodRes as ValidVehiclePolicyPeriodRes;

    // 任意險狀態為小於 60  = 1，且到期日與系統不符，帶入到期日
    if (
      tempVehicleInfoState.renewVehicle &&
      Object.keys(tempVehicleInfoState.renewVehicle).length > 0 &&
      policyPeriod.VOLUNTARY_EXP_STATUS === VehiclePolicyStatus.UnExpiredMin &&
      moment().format('YYYYMMDD') !== moment(policyPeriod.VOLUNTARY_EDATE).format('YYYYMMDD')
    ) {
      showMsg = false;
      momentVal = moment(policyPeriod.VOLUNTARY_EDATE);
    }

    const res = await service.fetchVehicleReplacePrice(this.props.insTypeId, typeCode, moment(momentVal).format('YYYYMMDD'), moment(tempVehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).format('YYYYMM'));
    if (!res || isNaN(+res) || +res === 0) return;

    if (showMsg) {
      let msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W065);
      if (msg.indexOf('{#P}') !== -1) {
        msg = msg.replace('{#P}', commonService.thousandFormat(res));
      };

      this.props.setInfoModalVisible(true, '', msg);
    }

    return res;
  }

  /**
   * @description 新增 window scroll 事件監聽
   */
  addWindowScrollEvent = () => {
    window.addEventListener('scroll', this.toggleVehicleOwnerInfoFixedVisible, false);
  }

  /**
   * @description 移除 window scroll 事件監聽
   */
  removeWindowScrollEvent = () => {
    window.removeEventListener('scroll', this.toggleVehicleOwnerInfoFixedVisible, false);
  }

  /**
   * @description 視窗滾動至「車籍資料」區塊時，顯示「車主資料」Fixed 區塊 (Fixed 在 Header 下方)
   */
  toggleVehicleOwnerInfoFixedVisible = () => {
    if (this.vehicalInfoRef.current) {
      const headerHeight = document.getElementsByTagName('header')[0].offsetHeight;
      const vehicalInfoOffsetTop = (window.pageYOffset + this.vehicalInfoRef.current.getBoundingClientRect().top) - headerHeight;
      const scrollTopPosition = window.pageYOffset;

      this.setState(state => ({
        ...state,
        vehicleOwnerInfoFixedVisible: (scrollTopPosition > vehicalInfoOffsetTop)
      }));
    }
  }

  /**
   * @description 寫入暫存資料
   */
  handleInitTempData = (regdata: VehRegResp[], formVal: InprocessSelectFormValue, state: InprocessSelectState, tempVehicleOwnerInfoFormValue: IVehicleOwnerInfoFormValue) => {
    const coredata = regdata.find(it => it.ID === tempVehicleOwnerInfoFormValue?.MEMBER_ID && it.ISSUCCESS === YesNo.Yes);
    formInitialValues = {
      ...formInitialValues,
      ...this.handleResetWebInsuredItem(formVal, tempVehicleOwnerInfoFormValue.MEMBER_ID, state.hasWebInsuredItem)
    };

    // 若有核心資料，則覆蓋至表單 (不處理車身號碼)
    if (coredata) {
      formInitialValues = {
        ...formInitialValues,
        ENGINE_NUMBER: coredata.ENGINENO,
        VEHICAL_BODY_NUMBER: coredata.FRAMENO
      };
    }

    this.setState({ ...state });
  }

  /**
   * @description 重置限網投項目為未勾選
   */
  handleResetWebInsuredItem = (formVal: InprocessSelectFormValue, ownerId: string, hasWebInsuredItem: boolean) => {
    const memberId = storageService.getItem(storageKeys.MemberId);

    // 判斷限網投項目是否可以維持勾選
    const unCheckWebInsuredItem = (!this.props.fetchFavoriteComplete ||
      memberId !== ownerId) && hasWebInsuredItem;

    if (!unCheckWebInsuredItem) return formVal;

    return {
      ...formVal,
      POLICY_ITEM: _.map(formVal.POLICY_ITEM, (policyItem: PolicyItemListContent) => {
        return {
          ...policyItem,
          MAIN_ITEMS: _.map(policyItem.MAIN_ITEMS, (mainItem: any) => {
            if (mainItem.CHECKED && mainItem.CONSTRAIN && mainItem.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured) {
              return {
                ...mainItem,
                CHECKED: false
              };
            }

            return mainItem;
          }),
          SUB_ITEMS: _.map(policyItem.SUB_ITEMS, (subItem: any) => {
            if (subItem.CHECKED && subItem.CONSTRAIN && subItem.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured) {
              return {
                ...subItem,
                CHECKED: false
              };
            }
            return subItem;
          })
        };
      })
    };
  }

  /**
   * @description 取得自由選方案 ID
   */
  handleGetFreePlanId = (vehiclePlan: VehiclePlan) => {
    const plan = _.find(vehiclePlan.VEHICLE_PLAN, (planInfo: VehiclePlanContent) => planInfo.PLAN_TYPE === PlanType.FreePlan);
    if (!plan) return '';

    return plan.PLAN_ID;
  }

  /**
   * @description 取得折舊金額
   */
  handleGetDepreciateAmt = async (policyItems: PolicyItemListContent[], prodId: string, planId: string, vehiclePlans?: VehiclePlanContent[]) => {
    if (policyItems.length === 0) return 0;
    let prodIdVal = prodId;
    let planIdVal = planId;

    if (!planIdVal && vehiclePlans && vehiclePlans.length > 0) {
      prodIdVal = vehiclePlans[0].PROD_ID;
      planIdVal = vehiclePlans[0].PLAN_ID;
    }

    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    const { tempVehicleInfoFormValue, tempVehicleInfoState } = this.props.tempVehicleInfo;
    if (!tempVehicleOwnerInfoFormValue || !tempVehicleInfoFormValue || !tempVehicleInfoState) return 0;

    // 若不投保車體、竊盜險，不取得折舊金額
    if (!tempVehicleInfoFormValue.VEHICAL_LOSS_THEFT) return 0;

    const policyItem = { ...policyItems[0] };
    if (!policyItem || !policyItem.MAIN_ITEMS || policyItem.MAIN_ITEMS.length === 0) return 0;

    const mainItem: any = { ...policyItem.MAIN_ITEMS[0] };
    if (!mainItem) return 0;

    const insureds = [{
      ...mainItem,
      ITEM_TYPE: policyItem.ITEM_TYPE
    }];

    const formVal: InprocessSelectFormValue = {
      ...initFormVal,
      COMPULSORY_INS_EFFECTIVE_DATE: moment()
    };

    const evalRes = await this.handleEvalCar(formVal, tempVehicleOwnerInfoFormValue, tempVehicleInfoFormValue, tempVehicleInfoState, insureds, planIdVal, prodIdVal);
    if (!evalRes || evalRes.IS_MODEL_CODE_ERROR) return 0;

    return +evalRes.VEHICLE_DATA.ACTUALVALUE || 0;
  }

  // #region 設定強制險、任意險預定生效日 相關方法

  /**
   * @description 初始化強制險、任意險預定生效日，並提示相關訊息
   */
  handleInitEffectiveDate = async () => {
    if (!this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState) return;

    const policyPeriod =
      this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState.policyPeriodRes as ValidVehiclePolicyPeriodRes;

    // 顯示檢核結果提示訊息
    this.handleShowEffectiveDateInfo(policyPeriod.COMPULSORY_EXP_STATUS, policyPeriod.VOLUNTARY_EXP_STATUS, policyPeriod.COMPULSORY_EDATE, policyPeriod.VOLUNTARY_EDATE);

    const compulsoryInsEffectiveDate =
      await this.handleGetEffectiveDate(policyPeriod.COMPULSORY_EXP_STATUS, policyPeriod.COMPULSORY_EDATE);
    const arbitraryInsEffectiveDate =
      await this.handleGetEffectiveDate(policyPeriod.VOLUNTARY_EXP_STATUS, policyPeriod.VOLUNTARY_EDATE);

    formInitialValues = {
      ...formInitialValues,
      COMPULSORY_INS_EFFECTIVE_DATE: compulsoryInsEffectiveDate,
      ARBITRARY_INS_EFFECTIVE_DATE: arbitraryInsEffectiveDate
    };
  }

  /**
   * @description 顯示檢核結果提示訊息
   * @param compulsoryStatus 強制險保單狀態
   * @param arbitraryStatus 任意險保單狀態
   * @param arbitraryDate 任意險生效日
   */
  handleShowEffectiveDateInfo = (compulsoryStatus: string, arbitraryStatus: string, compulsoryDate: string, arbitraryDate: string) => {
    let compulsoryMsg = '';
    let arbitraryMsg = '';

    // 強制險 狀態 2 提示訊息
    if (compulsoryStatus === VehiclePolicyStatus.UnExpiredMax) {
      compulsoryMsg = commonService.getCodeMsg(this.props.UICodes, CodeId.W023).replace('{0}', moment(compulsoryDate).format('YYYY/MM/DD'));
    }

    // 強制險 狀態 3 提示訊息
    if (compulsoryStatus === VehiclePolicyStatus.Expired) {
      let msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W036);
      if (this.props.insTypeId === InsType.Moto) {
        msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W067);
      }
      compulsoryMsg = msg.replace('{0}', moment(compulsoryDate).format('YYYY/MM/DD'));
    }

    // 任意險 狀態 2 提示訊息
    if (arbitraryStatus === VehiclePolicyStatus.UnExpiredMax) {
      arbitraryMsg = commonService.getCodeMsg(this.props.UICodes, CodeId.W024).replace('{0}', moment(arbitraryDate).format('YYYY/MM/DD'));
    }

    // 任意險 狀態 3 提示訊息
    if (arbitraryStatus === VehiclePolicyStatus.Expired) {
      let msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W037);
      if (this.props.insTypeId === InsType.Moto) {
        msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W068);
      }
      arbitraryMsg = msg.replace('{0}', moment(arbitraryDate).format('YYYY/MM/DD'));
    }

    if (compulsoryMsg && arbitraryMsg) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: compulsoryMsg
      }).then(() => {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: arbitraryMsg
        });
      });

      return;
    }

    if (compulsoryMsg || arbitraryMsg) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: compulsoryMsg || arbitraryMsg
      });
    }
  }

  /**
   * @description 取得強制險、任意險預設日期
   * @param status 保單狀態
   * @param date 保險生效終止日期
   */
  handleGetEffectiveDate = async (status: string, date: string) => {
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const sysTime = serverTimeMs ? moment.unix(Math.ceil(serverTimeMs / 1000)) : moment();
    switch (status) {
      // 未到期且保期90天內
      case VehiclePolicyStatus.UnExpiredMin:
        // 強制險、任意險預定生效日分別設定為所查詢到的強制險、任意險預定生效日
        return date && moment(date).isValid() ? moment(date) : moment(sysTime).hour() >= 12 ? moment(sysTime).add(1, 'd') : moment(sysTime);
      // 新保，未到期, 且大於90天才到期
      case VehiclePolicyStatus.UnExpiredMax:
      case VehiclePolicyStatus.Expired:
      default:
        // 強制險及任意險生效日預設系統日
        return moment(sysTime).hour() >= 12 ? moment(sysTime).add(1, 'd') : moment(sysTime);
    }
  }

  /**
   * @description 任意險日期更動，重新查詢重置價格
   */
  handleUpdareReplacePrice = async (val: any) => {
    const { tempVehicleInfoFormValue } = this.props.tempVehicleInfo;
    if (
      !val ||
      !tempVehicleInfoFormValue ||
      !tempVehicleInfoFormValue.VEHICAL_MODEL ||
      tempVehicleInfoFormValue.VEHICAL_MODEL.indexOf(',') === -1
    ) return;

    const typeCode = tempVehicleInfoFormValue.VEHICAL_MODEL.split(',');

    const res = await service.fetchVehicleReplacePrice(this.props.insTypeId, typeCode, moment(val).format('YYYYMMDD'), moment(tempVehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).format('YYYYMM'));
    if (!res || isNaN(+res) || +res === 0) {
      this.setState({ replacementPrice: tempVehicleInfoFormValue.REPLACEMENT_PRICE, isReplanementPriceError: true });
      return;
    }

    let msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W064);
    if (msg.indexOf('{#P}') !== -1) {
      msg = msg.replace('{#P}', commonService.thousandFormat(res));
    };

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: msg
    });

    this.setState({ replacementPrice: res, isReplanementPriceError: false });
  }

  /**
   * @description 強制險、任意險有效日期 Change 事件
   */
  handleEffectiveDateChange = async (val: any, effectiveType: string, effectiveStatus: string, originalDate: any, setFieldValue: any, values: any) => {
    // 無值，清除對應日期項目限制
    if (!val) {
      if (effectiveType === VehiclePolicyType.Compulsory && effectiveStatus === VehiclePolicyStatus.Expired) {
        this.setState({ isCompulsoryDateError: false });
      }

      if (effectiveType === VehiclePolicyType.Arbitrary && effectiveStatus === VehiclePolicyStatus.Expired) {
        this.setState({ isArbitraryDateError: false });
      }
      return;
    }

    // // 商品區塊項目資料
    // const planItems = [...values.POLICY_ITEM];

    // // 取得有投保的項目
    // const insuredPolicys = this.handleFetchInsuredPolicys(planItems);

    // // 是否包含強制險項目
    // const hasCompulsory = _.findIndex(insuredPolicys, (insuredPolicy:any) =>
    //   insuredPolicy.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO) !== -1;

    // // 是否包含任意險項目
    // const hasArbitrary = _.findIndex(insuredPolicys, (insuredPolicy:any) =>
    //   insuredPolicy.ITEM_TYPE !== VehicleItemType.ITEM_TYPE_CO) !== -1;

    // // 判斷填寫日期有無投保對應項目，若無就提示訊息
    // const showInfo = (effectiveType === VehiclePolicyType.Compulsory && !hasCompulsory) ||
    // (effectiveType === VehiclePolicyType.Arbitrary && !hasArbitrary);

    // if (showInfo) {
    //   await sweetAlertService.modal({
    //     html: commonService.getCodeMsg(this.props.UICodes, CodeId.W035)
    //   });
    // }

    // 判斷保單狀態設定限制投保天數， 新保 跟 已過期 為 60 ，續保為 89
    const limitDay = effectiveStatus === VehiclePolicyStatus.None || effectiveStatus === VehiclePolicyStatus.Expired
      ? 60
      : 89;

    // 判斷輸入日期是否小於等於 系統日 + 限制投保天數
    const isLimit = moment(val).isAfter(moment.unix(this.state.sysTime).add(limitDay, 'd'));

    // 通過檢核
    if (!isLimit) {
      if (effectiveType === VehiclePolicyType.Arbitrary) {
        this.setState({
          isArbitraryDateError: false
        });

        return;
      }

      // 強制險、狀態為 1 時，修改預定生效日，提示訊息，並記錄修改時間
      if (effectiveType === VehiclePolicyType.Compulsory && effectiveStatus === VehiclePolicyStatus.UnExpiredMin && originalDate) {
        const sameDate = moment(val).isSame(originalDate);
        let checkTime = 0;
        if (!sameDate) {
          const isAfter = moment(val).isAfter(originalDate);
          let msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W023).replace('{0}', moment(originalDate).format('YYYY/MM/DD'));
          if (isAfter) {
            msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W036);
            if (this.props.insTypeId === InsType.Moto) {
              msg = commonService.getCodeMsg(this.props.UICodes, CodeId.W067);
            }
            msg = msg.replace('{0}', moment(originalDate).format('YYYY/MM/DD'));
          }

          sweetAlertService.modal({
            html: '提醒您，您已變更保期，新的保險生效日與原保險到期日不同，請確認保期無誤。'
          }).then(() => {
            if (msg) {
              sweetAlertService.modal({
                html: msg
              });
            }
          });

          checkTime = await apiCommonService.fetchSysTime();
        }
        setFieldValue('COMPULSORY_INS_EFFECTIVE_DATE_CHECK_TIME', checkTime);
      }

      if (effectiveType === VehiclePolicyType.Compulsory &&
        (effectiveStatus === VehiclePolicyStatus.Expired ||
          effectiveStatus === VehiclePolicyStatus.None ||
          effectiveStatus === VehiclePolicyStatus.UnExpiredMin)
      ) {
        this.setState({
          isCompulsoryDateError: false
        });

        return;
      }
    }

    // 未通過檢核，且狀態為 無保單資料 或 未過期，保期 90 天內
    // 提示訊息
    if (isLimit && (effectiveStatus === VehiclePolicyStatus.None || effectiveStatus === VehiclePolicyStatus.UnExpiredMin)) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W025)
      });

      switch (effectiveType) {
        case VehiclePolicyType.Compulsory:
          this.setState({
            isCompulsoryDateError: true
          });
          break;
        case VehiclePolicyType.Arbitrary:
          this.setState({
            isArbitraryDateError: true
          });
          break;
      }

      return;
    }

    // 超過限制日期，且為任意險，狀態 2 ，顯示提示訊息 W025，且不得繼續
    if (isLimit && effectiveType === VehiclePolicyType.Arbitrary && effectiveStatus === VehiclePolicyStatus.UnExpiredMax) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W025)
      });

      this.setState({
        isArbitraryDateError: true
      });

      return;
    }

    // 超過限制日期，且為狀態 3 ，顯示提示訊息 W026，且不得繼續
    if (isLimit && effectiveStatus === VehiclePolicyStatus.Expired) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W025)
      });

      // 設定對應項目限制
      if (effectiveType === VehiclePolicyType.Compulsory) {
        this.setState({
          isCompulsoryDateError: true
        });
      }

      if (effectiveType === VehiclePolicyType.Arbitrary) {
        this.setState({
          isArbitraryDateError: true
        });
      }
    }
  }

  /**
   * @description 判斷強制險年期是否為必填
   */
  handleCheckCompulsoryRequired = () => {
    if (this.props.insTypeId === InsType.Car) return;

    const element = document.querySelector('div[custom-attribute-checked-item-id="21"]') as HTMLDivElement;
    if (!element) return;

    const inputs = element.getElementsByTagName('input');
    if (!inputs || inputs.length === 0) return;

    const input = inputs[0] as HTMLInputElement;

    return input.checked;
  }

  /**
   * @description 投保年期更改事件
   */
  handleCompulsoryInsYearChange = (e: React.ChangeEvent<HTMLSelectElement>, preVal: string, policyItems: PolicyItemListContent[], setFieldValue: any, handleChange: any) => {
    const val = e.currentTarget.value;
    let newPolicyItems = [...policyItems];

    // 選取自由選方案，調整強制險年期
    if (this.state.activePlan === this.state.freePlanId) {
      handleChange('COMPULSORY_INS_YEAR')(e);
      // 選取二年期，僅顯示強制險項目
      if (val === '2') {
        newPolicyItems = _.filter(newPolicyItems, (item: PolicyItemListContent) => item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);
        setFieldValue('POLICY_ITEM', newPolicyItems);

        const attachedContractFoldsArr = this.handleGetAttachedContractFolds(newPolicyItems, true);
        this.setState(state => ({ ...state, attachedContractFoldsOpen: [...attachedContractFoldsArr] }));
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: commonService.getCodeMsg(this.props.UICodes, CodeId.W047)
        });
        return;
      }

      // 原本選取二年期，改為其他選項，附加回其他任意險選項
      if (preVal === '2' && val !== '2') {
        newPolicyItems = _.filter(newPolicyItems, (item: PolicyItemListContent) => item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);

        const attachItems = _.filter(this.state.policyItem, (item: PolicyItemListContent) => item.ITEM_TYPE !== VehicleItemType.ITEM_TYPE_CO);
        newPolicyItems = [...newPolicyItems, ...attachItems];
        setFieldValue('POLICY_ITEM', newPolicyItems);

        const attachedContractFoldsArr = this.handleGetAttachedContractFolds(newPolicyItems, true);
        this.setState(state => ({ ...state, attachedContractFoldsOpen: [...attachedContractFoldsArr] }));
        return;
      }
    }

    // 非自由選方案，且選取二年期，且方案內容包含任意險，不給選取
    if (val === '2' &&
      _.findIndex(newPolicyItems, (item: PolicyItemListContent) => item.ITEM_TYPE !== VehicleItemType.ITEM_TYPE_CO) !== -1) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W048)
      });
      return;
    }

    handleChange('COMPULSORY_INS_YEAR')(e);
  }

  // #endregion

  /**
   * @description 清除自由選方案內容
   */
  handleResetFreeItems = (compulsoryInsYear: string) => {
    let policyItems = [...this.state.policyItem];

    policyItems = this.handleFilterPolicyItem(policyItems, this.state.depreciateAmt);
    if (this.props.insTypeId === InsType.Moto && compulsoryInsYear === '2') {
      policyItems = _.filter(policyItems, (item: PolicyItemListContent) => item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);
    }

    const attachedContractFoldsArr = this.handleGetAttachedContractFolds(policyItems, false);

    this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);

    let isRenewalAndUnEdit = this.state.isRenewalAndUnEdit;
    if (isRenewalAndUnEdit) {
      isRenewalAndUnEdit = false;
    }

    this.setState({
      showCalcBtn: true,
      isRenewalAndUnEdit: isRenewalAndUnEdit,
      attachedContractFoldsOpen: [...attachedContractFoldsArr]
    });
  }

  /**
   * @description 選擇方案或商品 click 事件
   */
  handlePlanClick = (planId: string, prodId: string, planName: string) => {
    if (!this.formikRef || !this.formikRef.current) return;
    const tempVehicleInfoState = { ...this.props.tempVehicleInfo.tempVehicleInfoState } as IVehicleInfoState;

    commonService.setActiveProdId(this.props.insTypeId, prodId);

    let isRenewlaAndUnEdit = this.state.isRenewalAndUnEdit;
    if (planId === this.state.freePlanId && this.state.activePlan !== planId) {
      let policyItems = [...this.state.policyItem];

      policyItems = this.handleFilterPolicyItem(policyItems, this.state.depreciateAmt);
      let attachedContractFoldsArr: any;
      if (tempVehicleInfoState && tempVehicleInfoState.renewVehicle && Object.keys(tempVehicleInfoState.renewVehicle).length > 0) {
        const renewalPrem = tempVehicleInfoState.renewVehicle.Prem as RenewalPremContent[];
        // 設定續保件投保資料值
        policyItems = this.handleSetRenewalVal(renewalPrem, policyItems);
        // 核續保資料與當前保障項目是否有停賣、保額調整項目
        this.handleCheckRenewalContent(this.state.isEcarPlan, renewalPrem, policyItems);

        // 若為機車險、投保年期選擇 二年期，商品僅能選強制險
        if (this.props.insTypeId === InsType.Moto && this.formikRef.current.values.COMPULSORY_INS_YEAR === '2') {
          policyItems = _.filter(policyItems, (item: PolicyItemListContent) => item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);
        }

        isRenewlaAndUnEdit = true;
        attachedContractFoldsArr = this.handleGetAttachedContractFolds(policyItems, true);
        policyItems = this.handleSetAffectiveItem(policyItems, this.state.policyItem);
        this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
      } else {
        // 若為機車險、投保年期選擇 二年期，商品僅能選強制險
        if (this.props.insTypeId === InsType.Moto && this.formikRef.current.values.COMPULSORY_INS_YEAR === '2') {
          policyItems = _.filter(policyItems, (item: PolicyItemListContent) => item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);
        }
        attachedContractFoldsArr = this.handleGetAttachedContractFolds(policyItems, false);
        this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
      }

      this.setState(state => ({ ...state, attachedContractFoldsOpen: [...attachedContractFoldsArr] }));
    }

    if (planId !== this.state.freePlanId && this.state.activePlan !== planId && this.state.vehiclePlan) {
      let policyItems = this.handleSetPlanCheck(planId, this.state.vehiclePlan.VEHICLE_PLAN, [...this.state.policyItem]);
      policyItems = this.handleFilterCheckItem(policyItems);
      // 若為機車險、選擇商品包含任意險，投保年期僅能選一年
      if (this.props.insTypeId === InsType.Moto && this.formikRef.current.values.COMPULSORY_INS_YEAR === '2') {
        const index = _.findIndex(policyItems, (item: PolicyItemListContent) => item.ITEM_TYPE !== VehicleItemType.ITEM_TYPE_CO);
        if (index !== -1) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: commonService.getCodeMsg(this.props.UICodes, CodeId.W048)
          });
          this.formikRef.current.setFieldValue('COMPULSORY_INS_YEAR', '1');
        }
      }
      this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
      const attachedContractFoldsArr = this.handleGetAttachedContractFolds(policyItems, true);

      this.setState(state => ({ ...state, attachedContractFoldsOpen: [...attachedContractFoldsArr] }));
    }

    this.setState({
      activePlan: planId,
      activeProdId: prodId,
      activePlanName: planName,
      disableProduct: planId !== this.state.freePlanId,
      showCalcBtn: true,
      evalCarRes: {
        STARTDATE: '',
        ENDDATE: '',
        SUMPREMIUM: new Array(0),
        PROGRAM_ID: '',
        VEHICLE_DATA: {
          LICENSENO: '',
          CARKINDCODE: '',
          ENROLLDATE: '',
          MAKEDATE: '',
          MODELCODE: '',
          SEATCOUNT: 0,
          EXHAUSTSCALE: 0,
          PURCHASEPRICE: '',
          ACTUALVALUE: ''
        },
        POLICY_ITEM_LIST: new Array(0)
      },
      isRenewalAndUnEdit: isRenewlaAndUnEdit,
      depreciateAmt: this.state.depreciateAmt,
      planChange: !this.state.planChange
    });
  }

  /**
   * @description 選擇方案或商品 click 事件 (適用於行動方案)
   */
  handlePlanClickForEcar = (planId: string, prodId: string, planName: string) => {
    if (!this.formikRef || !this.formikRef.current) return;
    const tempVehicleInfoState = { ...this.props.tempVehicleInfo.tempVehicleInfoState } as IVehicleInfoState;
    const isRenewal = tempVehicleInfoState && tempVehicleInfoState.renewVehicle && Object.keys(tempVehicleInfoState.renewVehicle).length > 0;

    commonService.setActiveProdId(this.props.insTypeId, prodId);

    let targetPlanPolicyItems = this.state.policyItem;
    if (this.state.activePlan !== planId && this.state.vehiclePlan) {
      const targetPlan = this.state.vehiclePlan.VEHICLE_PLAN.find((plan) => plan.PLAN_ID === planId);
      targetPlanPolicyItems = targetPlan ? this.handleCombineVehicleItemListForEcar(targetPlan) : [];

      if (isRenewal) {
        const renewalPrem: RenewalPremContent[] = tempVehicleInfoState.renewVehicle.Prem;
        // 設定續保件投保資料值
        // targetPlanPolicyItems = this.handleSetRenewalVal(renewalPrem, targetPlanPolicyItems);
        // 核續保資料與當前保障項目是否有停賣、保額調整項目
        this.handleCheckRenewalContent(this.state.isEcarPlan, renewalPrem, targetPlanPolicyItems);
      }
      // 新保、續保走相同邏輯
      targetPlanPolicyItems = this.handleSetPolicyItemDefult(targetPlanPolicyItems);
      targetPlanPolicyItems = this.handleSetPlanCheckForEcar(planId, this.state.vehiclePlan.VEHICLE_PLAN, targetPlanPolicyItems);

      this.formikRef.current.setFieldValue('POLICY_ITEM', targetPlanPolicyItems);
    }

    const attachedContractFoldsArr = this.handleGetAttachedContractFolds(targetPlanPolicyItems, true);

    this.setState({
      activePlan: planId,
      activeProdId: prodId,
      activePlanName: planName,
      disableProduct: planId === this.state.activePlan,
      showCalcBtn: true,
      evalCarRes: {
        STARTDATE: '',
        ENDDATE: '',
        SUMPREMIUM: new Array(0),
        PROGRAM_ID: '',
        VEHICLE_DATA: {
          LICENSENO: '',
          CARKINDCODE: '',
          ENROLLDATE: '',
          MAKEDATE: '',
          MODELCODE: '',
          SEATCOUNT: 0,
          EXHAUSTSCALE: 0,
          PURCHASEPRICE: '',
          ACTUALVALUE: ''
        },
        POLICY_ITEM_LIST: new Array(0)
      },
      depreciateAmt: this.state.depreciateAmt,
      attachedContractFoldsOpen: [...attachedContractFoldsArr],
      policyItem: targetPlanPolicyItems
    });
  };

  /**
   * @description 設定續保件投保資料值
   */
  handleSetRenewalVal = (renewalPrem: RenewalPremContent[], policyItems: PolicyItemListContent[]) => {
    _.forEach(renewalPrem, (prem: RenewalPremContent) => {
      // 暫存子項目資訊用
      let childItemInfo = {
        // 險種契約類型，主、副約
        CONTRACT_TYPE: '',
        // 位置
        ITEM_INDEX: 0,
        PARENT_CONTRACT_TYPE: '',
        PARENT_ITEM_INDEX: 0,
        PARENT_ITEM_ID: ''
      };

      // 取得該筆續保件保障項目代碼與保障項目的對應 Index
      // 並記錄子項目資訊
      const policyItemIndex = _.findIndex(policyItems, (policyItem: PolicyItemListContent, index: number) => {
        let policyIndex;
        _.forEach(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent, mainItemIndex: number) => {
          if (mainItem.ADDITIONAL_TERM) {
            const mainAddIndex = _.findIndex(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
              return additionalTerm.ITEM_ID === prem.Iinstyp;
            });

            if (mainAddIndex !== -1) {
              policyIndex = index;
              childItemInfo = {
                CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN_ADD,
                ITEM_INDEX: mainAddIndex,
                PARENT_ITEM_INDEX: mainItemIndex,
                PARENT_CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN,
                PARENT_ITEM_ID: mainItem.ITEM_ID
              };
            }
          }
        });

        if (policyIndex) return policyIndex;

        _.forEach(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent, subItemIndex: number) => {
          if (subItem.ADDITIONAL_TERM) {
            const subAddIndex = _.findIndex(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
              return additionalTerm.ITEM_ID === prem.Iinstyp;
            });

            if (subAddIndex !== -1) {
              policyIndex = index;
              childItemInfo = {
                CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB_ADD,
                ITEM_INDEX: subAddIndex,
                PARENT_ITEM_INDEX: subItemIndex,
                PARENT_CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB,
                PARENT_ITEM_ID: subItem.ITEM_ID
              };
            }
          }
        });

        if (policyIndex) return policyIndex;

        const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
          return mainItem.ITEM_ID === prem.Iinstyp;
        });

        if (mainItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN,
            ITEM_INDEX: mainItemIndex,
            PARENT_ITEM_INDEX: 0,
            PARENT_CONTRACT_TYPE: '',
            PARENT_ITEM_ID: ''
          };
        }

        const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
          return subItem.ITEM_ID === prem.Iinstyp;
        });

        if (subItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB,
            ITEM_INDEX: subItemIndex,
            PARENT_ITEM_INDEX: 0,
            PARENT_CONTRACT_TYPE: '',
            PARENT_ITEM_ID: ''
          };
        }

        return mainItemIndex !== -1 || subItemIndex !== -1;
      });

      if (policyItemIndex === -1) return;

      let policyItem = { ...policyItems[policyItemIndex] };

      // 更新對應項目的保費資訊
      switch (childItemInfo.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN:
          {
            let mainItems = [...policyItem.MAIN_ITEMS];
            let mainItem = { ...mainItems[childItemInfo.ITEM_INDEX] };
            policyItems = this.handleItemChecked(mainItem, policyItems, VehicleItemType.CONTRACT_TYPE_MAIN, false) || policyItems;
            policyItem = { ...policyItems[policyItemIndex] };
            mainItems = [...policyItem.MAIN_ITEMS];
            mainItem = { ...mainItems[childItemInfo.ITEM_INDEX] };

            const itemOpt = mainItem.ITEM_OPTION && mainItem.ITEM_OPTION.length > 0
              ? [...mainItem.ITEM_OPTION]
              : [];
            const newMainItems: any = {
              ...mainItem,
              CHECKED: true,
              ITEM_OPTION: this.handeSetRenewalOptDefaultVal(itemOpt, prem.McotAmt, prem.Multiple, prem.IdutUnt)
            };

            mainItems[childItemInfo.ITEM_INDEX] = { ...newMainItems };

            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB:
          {
            let subItems = [...policyItem.SUB_ITEMS];
            let subItem = { ...subItems[childItemInfo.ITEM_INDEX] };

            policyItems = this.handleItemChecked(subItem, policyItems, VehicleItemType.CONTRACT_TYPE_SUB, false) || policyItems;
            policyItem = { ...policyItems[policyItemIndex] };
            subItems = [...policyItem.SUB_ITEMS];
            subItem = { ...subItems[childItemInfo.ITEM_INDEX] };

            const itemOpt = subItem.ITEM_OPTION && subItem.ITEM_OPTION.length > 0
              ? [...subItem.ITEM_OPTION]
              : [];
            const newSubItems = {
              ...subItem,
              CHECKED: true,
              ITEM_OPTION: this.handeSetRenewalOptDefaultVal(itemOpt, prem.McotAmt, prem.Multiple, prem.IdutUnt)
            };

            subItems[childItemInfo.ITEM_INDEX] = { ...newSubItems };
            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_MAIN_ADD:
          {
            let mainItems = [...policyItem.MAIN_ITEMS];
            let mainItem = { ...mainItems[childItemInfo.PARENT_ITEM_INDEX] };
            let additionals = mainItem.ADDITIONAL_TERM ? [...mainItem.ADDITIONAL_TERM] : new Array(0);

            policyItems = this.handleItemChecked(additionals[childItemInfo.ITEM_INDEX], policyItems, VehicleItemType.CONTRACT_TYPE_MAIN_ADD, false) || policyItems;
            policyItem = { ...policyItems[policyItemIndex] };
            mainItems = [...policyItem.MAIN_ITEMS];
            mainItem = { ...mainItems[childItemInfo.PARENT_ITEM_INDEX] };
            additionals = mainItem.ADDITIONAL_TERM ? [...mainItem.ADDITIONAL_TERM] : new Array(0);

            additionals[childItemInfo.ITEM_INDEX] = {
              ...additionals[childItemInfo.ITEM_INDEX],
              CHECKED: true
            };

            const newMainItems = {
              ...mainItem,
              CHECKED: true,
              ADDITIONAL_TERM: additionals
            };

            mainItems[childItemInfo.PARENT_ITEM_INDEX] = { ...newMainItems };

            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB_ADD:
          {
            let subItems = [...policyItem.SUB_ITEMS];
            let subItem = { ...subItems[childItemInfo.PARENT_ITEM_INDEX] };
            let additionals = subItem.ADDITIONAL_TERM ? [...subItem.ADDITIONAL_TERM] : new Array(0);

            policyItems = this.handleItemChecked(additionals[childItemInfo.ITEM_INDEX], policyItems, VehicleItemType.CONTRACT_TYPE_SUB_ADD, false) || policyItems;
            policyItem = { ...policyItems[policyItemIndex] };
            subItems = [...policyItem.SUB_ITEMS];
            subItem = { ...subItems[childItemInfo.PARENT_ITEM_INDEX] };
            additionals = subItem.ADDITIONAL_TERM ? [...subItem.ADDITIONAL_TERM] : new Array(0);

            additionals[childItemInfo.ITEM_INDEX] = {
              ...additionals[childItemInfo.ITEM_INDEX],
              CHECKED: true
            };

            const newSubItems = {
              ...subItem,
              CHECKED: true,
              ADDITIONAL_TERM: additionals
            };

            subItems[childItemInfo.PARENT_ITEM_INDEX] = { ...newSubItems };

            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
      }
      policyItems[policyItemIndex] = policyItem;
    });

    return policyItems;
  }

  /**
   * @description 檢核續保資料與當前保障項目是否有停賣、保額調整項目
   */
  handleCheckRenewalContent = (isUseEcarPlan: boolean, renewalPrem: RenewalPremContent[], policyItems: PolicyItemListContent[]) => {
    const suspendItems = new Array(0);
    const modifyItems = new Array(0);
    _.forEach(renewalPrem, (prem: RenewalPremContent) => {
      // 暫存子項目資訊用
      let childItemInfo = {
        // 險種契約類型，主、副約
        CONTRACT_TYPE: '',
        // 位置
        ITEM_INDEX: 0,
        // 附加條款位置
        ADDITIONAL_ITEM_INDEX: 0
      };

      // 取得該筆續保件保障項目代碼與保障項目的對應 Index
      // 並記錄子項目資訊
      const policyItemIndex = _.findIndex(policyItems, (policyItem: PolicyItemListContent) => {
        let mainAdditionalItemIndex = -1;
        let subAdditionalItemIndex = -1;
        const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
          if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
            mainAdditionalItemIndex =
              _.findIndex(mainItem.ADDITIONAL_TERM, (additional: PolicyBaseItemContent) => additional.ITEM_ID === prem.Iinstyp);

            if (mainAdditionalItemIndex !== -1) return true;
          }

          return mainItem.ITEM_ID === prem.Iinstyp;
        });

        if (mainItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: mainAdditionalItemIndex !== -1
              ? VehicleItemType.CONTRACT_TYPE_MAIN_ADD
              : VehicleItemType.CONTRACT_TYPE_MAIN,
            ITEM_INDEX: mainItemIndex,
            ADDITIONAL_ITEM_INDEX: mainAdditionalItemIndex
          };
        }

        const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
          if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
            subAdditionalItemIndex =
              _.findIndex(subItem.ADDITIONAL_TERM, (additional: PolicyBaseItemContent) => additional.ITEM_ID === prem.Iinstyp);

            if (subAdditionalItemIndex !== -1) return true;
          }

          return subItem.ITEM_ID === prem.Iinstyp;
        });

        if (subItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: subAdditionalItemIndex !== -1
              ? VehicleItemType.CONTRACT_TYPE_SUB_ADD
              : VehicleItemType.CONTRACT_TYPE_SUB,
            ITEM_INDEX: subItemIndex,
            ADDITIONAL_ITEM_INDEX: subAdditionalItemIndex
          };
        }

        return mainItemIndex !== -1 || subItemIndex !== -1;
      });

      if (policyItemIndex === -1) {
        suspendItems.push(prem.Iinstyp);
        return;
      }

      const policyItem = { ...policyItems[policyItemIndex] };

      // 更新對應項目的保費資訊
      switch (childItemInfo.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN:
          {
            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainItem = { ...mainItems[childItemInfo.ITEM_INDEX] };
            const itemOpt = mainItem.ITEM_OPTION && mainItem.ITEM_OPTION.length > 0
              ? [...mainItem.ITEM_OPTION]
              : [];
            modifyItems.push(...this.handeCheckRenewalOptVal(prem.Iinstyp, itemOpt, prem.McotAmt, prem.Multiple, prem.IdutUnt));
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB:
          {
            const subItems = [...policyItem.SUB_ITEMS];
            const subItem = { ...subItems[childItemInfo.ITEM_INDEX] };
            const itemOpt = subItem.ITEM_OPTION && subItem.ITEM_OPTION.length > 0
              ? [...subItem.ITEM_OPTION]
              : [];
            modifyItems.push(...this.handeCheckRenewalOptVal(prem.Iinstyp, itemOpt, prem.McotAmt, prem.Multiple, prem.IdutUnt));
          }
          break;
      }
    });

    const errorMsgs = new Array(0);
    const infoMsg = commonService.getCodeMsg(this.props.UICodes, CodeId.W038);

    _.forEach(suspendItems, (str: string) => {
      errorMsgs.push(`項目:${str}<br />${infoMsg}`);
    });

    _.forEach(modifyItems, (str: string) => {
      if (str.indexOf(',') !== -1) {
        const strArray = str.split(',');

        errorMsgs.push(`<div style="display: flex;justify-content: space-around;height: 0px" ><p>項目:${strArray[0]}</p><p>${strArray[1]}</p></div><br />${infoMsg}`);
      }
    });

    if (errorMsgs.length > 0) {
      // 若續保件有商品停買或變更，僅顯示一次通知即可。(2024/01/25)
      // const errorMessages = [...errorMsgs];
      const errorMessages = [infoMsg];
      const errorMessagesForEcar = [commonService.getCodeMsg(this.props.UICodes, CodeId.W075)];
      this.props.setRuleValidErrorModalVisible(true, !isUseEcarPlan ? errorMessages : errorMessagesForEcar);
    }
  }

  /**
   * @description 篩選自由選方案保障內容
   */
  handleFilterPolicyItem = (policyItems: PolicyItemListContent[], depreciateAmt: number) => {
    let newPolicyItems = [...policyItems];
    const vehicleInfoFormValue = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
    // const vehicleOwnerInfoState = { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState } as IVehicleOwnerInfoState;
    // const policyPeriodRes = { ...vehicleOwnerInfoState.policyPeriodRes };

    if (!vehicleInfoFormValue.VEHICAL_LOSS_THEFT) {
      newPolicyItems = _.filter(policyItems, (policyItem: PolicyItemListContent) => policyItem.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO || policyItem.ITEM_TYPE === VehicleItemType.ITEM_TYPE_TP);
    }

    const carBodyItemIndex = _.findIndex(newPolicyItems, (policyItem: PolicyItemListContent) => policyItem.ITEM_TYPE === VehicleItemType.ITEM_TYPE_BD);

    // 折舊金額小於 10 萬時，移除 07A7 項目
    if (carBodyItemIndex !== -1 && (depreciateAmt * 0.75) < 100000) {
      let carBodyItem = { ...newPolicyItems[carBodyItemIndex] };
      carBodyItem = {
        ...carBodyItem,
        MAIN_ITEMS: _.filter(carBodyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => mainItem.ITEM_ID !== '07A7')
      };

      newPolicyItems[carBodyItemIndex] = { ...carBodyItem };
    }

    // 強制險未過期，篩選掉 強制險項目
    // if (policyPeriodRes.COMPULSORY_EXP_STATUS === VehiclePolicyStatus.UnExpiredMax) {
    //   newPolicyItems = _.filter(newPolicyItems, (policyItem:PolicyItemListContent) => policyItem.ITEM_TYPE !== VehicleItemType.ITEM_TYPE_CO);
    // }

    // // 任意險未過期，僅篩選 強制險項目
    // if (policyPeriodRes.VOLUNTARY_EXP_STATUS === VehiclePolicyStatus.UnExpiredMax) {
    //   newPolicyItems = _.filter(newPolicyItems, (policyItem:PolicyItemListContent) => policyItem.ITEM_TYPE === VehicleItemType.ITEM_TYPE_CO);
    // }

    return newPolicyItems;
  }

  /**
   * @description 依選取的 PlanId 進行保障項目勾選與設值
   * @param planId 方案代碼
   * @param vehiclePlans 可選取的方案計畫資料
   * @param policyItems 篩選不可投保項目後的保障項目資料
   */
  handleSetPlanCheck = (planId: string, vehiclePlans: VehiclePlanContent[], policyItems: PolicyItemListContent[]) => {
    const vehiclePlan = _.find(vehiclePlans, (vehiclePlan: VehiclePlanContent) => vehiclePlan.PLAN_ID === planId);
    if (!vehiclePlan) return new Array(0);
    const itemList = [...vehiclePlan.ITEM_LIST];
    // 對要勾選的項目跑回圈
    _.forEach(itemList, (item: PlanItemListContent) => {
      const policyItemIndex = _.findIndex(policyItems, (policyItem: PolicyItemListContent) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
      if (policyItemIndex === -1) return;
      // 讀取 車險保障內容 對應項目資料
      let policyItem = { ...policyItems[policyItemIndex] };
      // 對子項目設值
      switch (item.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN:
          {
            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainIndex = _.findIndex(mainItems, (mainItem: PolicyBaseItemContent) => mainItem.ITEM_ID === item.ITEM_ID);
            const mainItem = { ...mainItems[mainIndex] };
            const newMainItems = {
              ...mainItem,
              CHECKED: true,
              ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTIONS)
            };
            mainItems[mainIndex] = { ...newMainItems };
            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB:
          {
            const subItems = [...policyItem.SUB_ITEMS];
            const subIndex = _.findIndex(subItems, (subItem: PolicyBaseItemContent) => subItem.ITEM_ID === item.ITEM_ID);
            const subItem = { ...subItems[subIndex] };
            const newSubItems = {
              ...subItem,
              CHECKED: true,
              ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTIONS)
            };
            subItems[subIndex] = { ...newSubItems };
            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
      }
      // 更新與 車險保障內容 對應的資料
      policyItems[policyItemIndex] = { ...policyItem };
    });
    return policyItems;
  }

  /**
   * @description 依選取的 PlanId 進行保障項目勾選與設值 (適用於電動車方案)
   * @param planId 方案代碼
   * @param vehiclePlans 可選取的方案計畫資料
   * @param policyItems 篩選不可投保項目後的保障項目資料
   */
  handleSetPlanCheckForEcar = (planId: string, vehiclePlans: VehiclePlanContent[], policyItems: PolicyItemListContent[]) => {
    const vehiclePlan = _.find(vehiclePlans, (vehiclePlan: VehiclePlanContent) => vehiclePlan.PLAN_ID === planId);
    if (!vehiclePlan) return new Array(0);
    const itemList = [...vehiclePlan.ITEM_LIST];
    // 對要勾選的項目跑回圈
    _.forEach(itemList, (item: PlanItemListContent) => {
      const policyItemIndex = _.findIndex(policyItems, (policyItem: PolicyItemListContent) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
      if (policyItemIndex === -1) return;
      // 讀取 車險保障內容 對應項目資料
      let policyItem = { ...policyItems[policyItemIndex] };
      // 對子項目設值
      switch (item.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN:
          {
            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainIndex = _.findIndex(mainItems, (mainItem: PolicyBaseItemContent) => mainItem.ITEM_ID === item.ITEM_ID);
            const mainItem = { ...mainItems[mainIndex] };
            const newMainItems = {
              ...mainItem,
              CHECKED: this.handleSetPolicyItemCheckedForEcar(item.ITEM_MANDATORY),
              ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTIONS),
              ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM
                ? mainItem.ADDITIONAL_TERM.map((additionalTermItem) => ({
                  ...additionalTermItem,
                  CHECKED: this.handleSetPolicyItemCheckedForEcar(item.ITEM_MANDATORY)
                }))
                : []
            };
            mainItems[mainIndex] = { ...newMainItems };
            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB:
          {
            const subItems = [...policyItem.SUB_ITEMS];
            const subIndex = _.findIndex(subItems, (subItem: PolicyBaseItemContent) => subItem.ITEM_ID === item.ITEM_ID);
            const subItem = { ...subItems[subIndex] };
            const newSubItems = {
              ...subItem,
              CHECKED: this.handleSetPolicyItemCheckedForEcar(item.ITEM_MANDATORY),
              ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTIONS),
              ADDITIONAL_TERM: subItem.ADDITIONAL_TERM
                ? subItem.ADDITIONAL_TERM.map((additionalTermItem) => ({
                  ...additionalTermItem,
                  CHECKED: this.handleSetPolicyItemCheckedForEcar(item.ITEM_MANDATORY)
                }))
                : []
            };
            subItems[subIndex] = { ...newSubItems };
            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
      }
      // 更新與 車險保障內容 對應的資料
      policyItems[policyItemIndex] = { ...policyItem };
    });
    return policyItems;
  }

  /**
   * @description 設置保障內容項目預設是否勾選 (適用於電動車方案)
   * @param mandatory 預設是否勾選之條件
   */
  handleSetPolicyItemCheckedForEcar = (mandatory?: string) => {
    if (!mandatory) return false;
    switch (mandatory) {
      case PolicyItemMandatory.M: { return true; }
      case PolicyItemMandatory.O: { return true; }
      case PolicyItemMandatory.N: { return false; }
      case PolicyItemMandatory.H: { return false; }
      default: { return false; }
    }
  }

  /**
   * @description 設置保障內容項目 Checkbox Disabled 狀態 (適用於電動車方案)
   * @param mandatory 預設是否勾選之條件
   */
  handleSetPolicyItemCheckboxDisabledForEcar = (mandatory?: string) => {
    if (!mandatory) return false;
    switch (mandatory) {
      case PolicyItemMandatory.M: { return true; }
      case PolicyItemMandatory.O: { return false; }
      case PolicyItemMandatory.N: { return false; }
      case PolicyItemMandatory.H: { return true; }
      default: { return false; }
    }
  }

  // #region 保障內容相關方法

  /**
   * @description 篩選顯示方案勾選項目
   */
  handleFilterCheckItem = (policyItems: PolicyItemListContent[]) => {
    const newPolicyItems = new Array(0);
    _.forEach(policyItems, (policyItem: PolicyItemListContent) => {
      const mainItems = new Array(0);
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        const additionalTrems = new Array(0);
        if (mainItem.CHECKED) {
          if (mainItem.ADDITIONAL_TERM) {
            _.forEach(mainItem.ADDITIONAL_TERM, (term: any) => {
              if (term.CHECKED) {
                additionalTrems.push(term);
              }
            });
          }
          mainItems.push({
            ...mainItem,
            ADDITIONAL_TERM: additionalTrems
          });
        }
      });

      const subItems = new Array(0);
      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        if (subItem.CHECKED) {
          const additionalTrems = new Array(0);
          if (subItem.ADDITIONAL_TERM) {
            _.forEach(subItem.ADDITIONAL_TERM, (term: any) => {
              if (term.CHECKED) {
                additionalTrems.push(term);
              }
            });
          }
          subItems.push({
            ...subItem,
            ADDITIONAL_TERM: additionalTrems
          });
        }
      });

      if (mainItems.length > 0) {
        newPolicyItems.push({
          ...policyItem,
          MAIN_ITEMS: [...mainItems],
          SUB_ITEMS: [...subItems]
        });
      }
    });

    return newPolicyItems;
  }

  /**
   * @description 將「電動車車險保障內容」資料組合成「原車險保障內容」資料格式 (適用於電動車方案)
   * @param vehiclePlan 車險方案資料
   */
  handleCombineVehicleItemListForEcar = (vehiclePlan: VehiclePlanContent): PolicyItemListContent[] => {
    // 說明：「原車險保障內容」資料格式為 API (/product/vehicle/itemlist) 回傳的格式，此處將「電動車車險保障內容」資料組合成「原車險保障內容」資料格式。
    const policyItems = vehiclePlan.ITEM_LIST;
    const policyItemsCombined = policyItems
      .reduce((acc: PolicyItemListContent[], curr) => {
        const itemTypes = Object.keys(VehicleItemTypeMatchesText);
        const hasItemType = !(itemTypes.includes(curr.ITEM_TYPE) && acc.every((accItem) => accItem.ITEM_TYPE !== curr.ITEM_TYPE));
        return !hasItemType
          ? acc.concat({
            ITEM_TYPE: curr.ITEM_TYPE,
            ITEM_TYPE_NAME: VehicleItemTypeMatchesText[curr.ITEM_TYPE],
            MAIN_ITEMS: [],
            SUB_ITEMS: []
          })
          : acc;
      }, [])
      .map((policyItem) => ({
        ...policyItem,
        MAIN_ITEMS: policyItems
          .filter((defaultPolicyItem) => policyItem.ITEM_TYPE === defaultPolicyItem.ITEM_TYPE && defaultPolicyItem.CONTRACT_TYPE === ContractType.Main)
          .map((defaultPolicyItem) => ({
            ..._.omit(defaultPolicyItem, 'ITEM_OPTIONS'),
            ITEM_OPTION: defaultPolicyItem.ITEM_OPTIONS,
            ADDITIONAL_TERM: defaultPolicyItem.ADDITIONAL_TERM ? defaultPolicyItem.ADDITIONAL_TERM.filter((additionalTermItem) => policyItems.some((item) => item.ITEM_ID === additionalTermItem.ITEM_ID)) : []
          })),
        SUB_ITEMS: policyItems
          .filter((defaultPolicyItem) => policyItem.ITEM_TYPE === defaultPolicyItem.ITEM_TYPE && defaultPolicyItem.CONTRACT_TYPE === ContractType.Attach)
          .map((defaultPolicyItem) => ({
            ..._.omit(defaultPolicyItem, 'ITEM_OPTIONS'),
            ITEM_OPTION: defaultPolicyItem.ITEM_OPTIONS,
            ADDITIONAL_TERM: defaultPolicyItem.ADDITIONAL_TERM ? defaultPolicyItem.ADDITIONAL_TERM.filter((additionalTermItem) => policyItems.some((item) => item.ITEM_ID === additionalTermItem.ITEM_ID)) : []
          }))
      }));
    return policyItemsCombined;
  }

  /**
   * @description 篩選不可投保的方案
   */
  handleFilterVehiclePlan = (vehiclePlan: VehiclePlan) => {
    let newVehiclePlan = { ...vehiclePlan };
    let vehiclePlanList = [...vehiclePlan.VEHICLE_PLAN];

    const vehicleInfoFormValue = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
    // const vehicleOwnerInfoState = { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState } as IVehicleOwnerInfoState;
    // const policyPeriodRes = { ...vehicleOwnerInfoState.policyPeriodRes };

    // 若未投保車體或竊盜險，篩選沒有車體、竊盜險的方案 (一般方案，非電動車方案)
    if (!vehicleInfoFormValue.VEHICAL_LOSS_THEFT) {
      vehiclePlanList = _.filter(vehiclePlanList, (planContent: VehiclePlanContent) => {
        const itemIndex = _.findIndex(planContent.ITEM_LIST, (item: PlanItemListContent) =>
          item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_BD || item.ITEM_TYPE === VehicleItemType.ITEM_TYPE_TF);
        return itemIndex === -1;
      });
    }
    // 若未投保車體或竊盜險，篩選沒有車體、竊盜險的方案 (電動車方案)
    if (this.state.isEcarPlan && !vehicleInfoFormValue.VEHICAL_LOSS_THEFT) {
      vehiclePlanList = _.filter(vehiclePlanList, (planContent: VehiclePlanContent) => planContent.HAS_DAMAGE_ITEM === YesNo.No && planContent.HAS_THIEFING_ITEM === YesNo.No);
    }

    //  // 若強制險狀態為 未過期，保期 大於 90 天，篩選沒有 強制險項目的方案、自由選方案
    //  if (policyPeriodRes.COMPULSORY_EXP_STATUS === VehiclePolicyStatus.UnExpiredMax) {
    //    vehiclePlanList = _.filter(vehiclePlanList, (planContent:VehiclePlanContent, index:number) => {
    //      return planContent.PLAN_TYPE === PlanType.FreePlan || (planContent.PLAN_TYPE === PlanType.Normal && planContent.WITH_CO_ITEM === '0');
    //    });
    //  }

    //  // 若任意險狀態為 未過期，保期 大於 90 天，篩選沒有 任意險項目的方案、自由選方案
    //  if (policyPeriodRes.VOLUNTARY_EXP_STATUS === VehiclePolicyStatus.UnExpiredMax) {
    //    vehiclePlanList = _.filter(vehiclePlanList, (planContent:VehiclePlanContent, index:number) => {
    //      return planContent.PLAN_TYPE === PlanType.FreePlan || (planContent.PLAN_TYPE === PlanType.Normal && planContent.WITH_VO_ITEM === '0');
    //    });
    //  }

    newVehiclePlan = {
      ...newVehiclePlan,
      VEHICLE_PLAN: [...vehiclePlanList]
    };

    return newVehiclePlan;
  }

  /**
   * @description 設定保障項目預設值
   */
  handleSetPolicyItemDefult = (policyItems: PolicyItemListContent[]) => {
    if (!this.props.tempVehicleInfo.tempVehicleInfoState) return new Array(0);

    //  const validLicenseRes =
    //   this.props.tempVehicleInfo.tempVehicleInfoState.validLicenseRes as ValidLicenseRes;

    //  const vehicleInfoFormValue = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;

    const newPolicyItems = [...policyItems];

    _.forEach(newPolicyItems, (policyItem: PolicyItemListContent) => {
      policyItem.MAIN_ITEMS = _.map(policyItem.MAIN_ITEMS, (item: PolicyBaseItemContent) => {
        const newItem = {
          ...item,
          ADDITIONAL_TERM: item.ADDITIONAL_TERM && item.ADDITIONAL_TERM.length > 0
            ? _.map(item.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent) => {
              return {
                ...additionalTerm,
                RULEPREMIUM: '-',
                PREMIUM: '-'
              };
            })
            : item.ADDITIONAL_TERM,
          RULEPREMIUM: '-',
          PREMIUM: '-',
          ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTION)
        };
        return newItem;
      });

      policyItem.SUB_ITEMS = _.map(policyItem.SUB_ITEMS, (item: PolicyBaseItemContent) => {
        const newItem = {
          ...item,
          ADDITIONAL_TERM: item.ADDITIONAL_TERM && item.ADDITIONAL_TERM.length > 0
            ? _.map(item.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent) => {
              return {
                ...additionalTerm,
                RULEPREMIUM: '-',
                PREMIUM: '-'
              };
            })
            : item.ADDITIONAL_TERM,
          RULEPREMIUM: '-',
          PREMIUM: '-',
          ITEM_OPTION: this.handeSetOptDefaultVal(item.ITEM_OPTION)
        };
        return newItem;
      });
    });

    return newPolicyItems;
  }

  /**
   * @description 設定保障內容下拉選單預設值
   */
  handeSetOptDefaultVal = (itemOpts: any) => {
    return _.map(itemOpts, (otp: any) => {
      switch (otp.TYPE) {
        case VehicleItemType.ITEM_OPTION_TEXT:
          return otp;
        case VehicleItemType.ITEM_OPTION_OPTION:
        case VehicleItemType.ITEM_OPTION_HOPTION:
        {
          const newOtp = {
            ...otp,
            SELECT_VALUE: String(otp.DEFAULT) ?? '',
            SELECT_TEXT: _.find(otp.OPTIONS, (optItems: any) => optItems.VALUE === otp.DEFAULT)?.TEXT
          };

          return newOtp;
        }
        default:
          return otp;
      }
    });
  }

  /**
   * @description 設定續保件保障內容下拉選單預設值
   */
  handeSetRenewalOptDefaultVal = (itemOpts: PolicyBaseItemOptContent[], amt: number, factor: number, deductVal: number) => {
    return _.map(itemOpts, (otp: any) => {
      switch (otp.FID) {
        case VehicleItemType.ITEM_FID_AMOUNT:
        {
          const newOtp = {
            ...otp,
            SELECT_VALUE: _.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +amt) !== -1 ? `${amt}` : '',
            SELECT_TEXT: _.find(otp.OPTIONS, (optItems: any) => optItems.VALUE === +amt)?.TEXT
          };

          return newOtp;
        }
        case VehicleItemType.ITEM_FID_FACTOR:
        {
          const newOtp = {
            ...otp,
            SELECT_VALUE: _.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +factor) !== -1 ? `${factor}` : '',
            SELECT_TEXT: _.find(otp.OPTIONS, (optItems: any) => optItems.VALUE === +factor)?.TEXT
          };

          return newOtp;
        }
        case VehicleItemType.ITEM_FID_DEDUCTIBLE:
        {
          const newOtp = {
            ...otp,
            SELECT_VALUE: _.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +deductVal) !== -1 ? `${deductVal}` : '',
            SELECT_TEXT: _.find(otp.OPTIONS, (optItems: any) => optItems.VALUE === +deductVal)?.TEXT
          };

          return newOtp;
        }
        default:
          return otp;
      }
    });
  }

  /**
   * @description 檢核選單內容是否有符合
   */
  handeCheckRenewalOptVal = (itemId: string, itemOpts: PolicyBaseItemOptContent[], amt: number, factor: number, deductVal: number) => {
    const errorMsgs = new Array(0);
    _.forEach(itemOpts, (otp: any) => {
      switch (otp.FID) {
        case VehicleItemType.ITEM_FID_AMOUNT:
          if (_.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +amt) === -1) {
            errorMsgs.push(`${itemId},保額: ${+amt >= 10000 ? `${+amt / 10000}萬` : amt}`);
          }
          break;
        case VehicleItemType.ITEM_FID_FACTOR:
          if (_.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +factor) === -1) {
            errorMsgs.push(`${itemId},倍數: ${factor}`);
          }
          break;
        case VehicleItemType.ITEM_FID_DEDUCTIBLE:
          if (_.findIndex(otp.OPTIONS, (optItems: any) => optItems.VALUE === +deductVal) === -1) {
            errorMsgs.push(`${itemId},保額: ${deductVal} `);
          }
          break;
      }
    });

    return errorMsgs;
  }

  /**
   * @description 取得有投保的保障內容資料
   */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        const constrainRes = this.handleItemConstrain(mainItem.CONSTRAIN);
        if (constrainRes === 'INVISIBLE') return;

        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        const constrainRes = this.handleItemConstrain(subItem.CONSTRAIN);
        if (constrainRes === 'INVISIBLE') return;

        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  /**
   * @description 顯示提示訊息
   */
  handleShowCheckedInfo = (item: any, policyItems: any) => {
    let msg: string = item.MSG || item.TEXT;

    if (item.CONSTRAIN && item.CONSTRAIN.OP && item.CONSTRAIN.FIELD === 'actualValue' && item.CONSTRAIN.ALERT_MSG) {
      switch (item.CONSTRAIN.OP) {
        case VehiclePowerValidationExpressionSymbols.GE:
          msg = this.state.depreciateAmt >= item.CONSTRAIN.FIELD_VALUE && item.CONSTRAIN.ALERT_MSG;
          break;
      }
    }

    if (!msg) return;

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: msg
    });
  };

  /**
   * @description 處理保障內容項目「擇一必選」之條件邏輯
   * @param policyItem 保障項目
   * @param policyItemList 所有保障項目
   */
  handlePolicyItemMustOneOf = (policyItem: PolicyBaseItemContent, policyItemList: PolicyItemListContent[]) => {
    // 說明：顯示提醒訊息，並回傳是否允許取消勾選。
    const constrainItems = policyItem.CONSTRAIN?.ITEMS ?? [];
    const constrainItemsRef = constrainItems.filter((item) => item !== policyItem.ITEM_ID);
    const allPolicyItem = policyItemList.reduce((acc: any[], curr) => acc.concat(curr.MAIN_ITEMS.concat(curr.SUB_ITEMS)), []);
    const isAllUnchecked = constrainItemsRef.every((refItemId) => !(allPolicyItem.find((item) => item.ITEM_ID === refItemId)?.CHECKED));
    const allowUncheck = !isAllUnchecked;
    if (isAllUnchecked) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: policyItem.CONSTRAIN?.TEXT ?? ''
      });
    }
    return allowUncheck;
  }

  /**
   * @description 保障項目 CheckBox onChange 事件
   * @param checked 勾選狀態
   * @param fieldName 欄位名稱
   * @param item 保障項目
   * @param policyItem 所有保障項目
   * @param itemType 勾選的保障項目險種別
   * @param nationalityType 車主身份別
   * @param constrainRes 檢核提示訊息
   */
  handleCheckboxOnChange = async (checked: boolean, fieldName: string, item: PolicyBaseItemContent, policyItem: any, itemType: string, nationalityType: string) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const setFieldValue = this.formikRef.current.setFieldValue;

    // 判斷勾選項目是否有檢核限制、投保類型限制是否為網投、且未登入狀態，詢問是否登入，不登入則取消勾選
    if (checked) {
      // setFieldValue(fieldName, false);
      const validWebInsuredErr = await this.handleValidWebInsuredItem(null, item);
      if (validWebInsuredErr) {
        setFieldValue(fieldName, false);
        return;
      }
    }

    // 判斷勾選項目是否有限制「擇一必選」之條件
    if (!checked && item.CONSTRAIN?.OP === 'ONEOF') {
      const allowUncheck = this.handlePolicyItemMustOneOf(item, policyItem);
      if (!allowUncheck) {
        setFieldValue(fieldName, true);
        return;
      }
    }

    await this.handleItemCheckChange(checked, item, policyItem, itemType, fieldName);

    let isRenewalAndUnedit = this.state.isRenewalAndUnEdit;
    if (isRenewalAndUnedit) {
      isRenewalAndUnedit = false;
    }

    this.setState({
      showCalcBtn: true,
      isRenewalAndUnEdit: isRenewalAndUnedit
    });
  }

  /**
   * @description 保障項目勾選事件
   */
  handleItemCheckChange = async (checked: boolean, item: any, policyItems: any[], itemType: string, fieldName: string) => {
    this.handleUpdateSelectItemClass();

    if (!checked) {
      // 1.取得要取消勾選的項目
      const resItems = this.handleItemUnChecked(item, policyItems, itemType);

      this.handleUpdateFoldToggle(resItems, policyItems, checked);

      let newPolicyItems = this.handleUpdateItem(resItems, false, [...policyItems], item, itemType);

      // 2. 若取消勾選項目包含主約，需要執行一次
      let unCheckItems = new Array(0);
      if (resItems && resItems.length > 0 && _.findIndex(resItems, (resItem: any) => resItem.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN) !== -1) {
        _.forEach(resItems, (resItem: any) => {
          const unCheckedArray = this.handleItemUnChecked(resItem, newPolicyItems, resItem.CONTRACT_TYPE);
          unCheckItems.push(...unCheckedArray);
        });

        this.handleUpdateFoldToggle(unCheckItems, policyItems, checked);
        newPolicyItems = this.handleUpdateItem(unCheckItems, false, [...newPolicyItems], item, itemType);
      }

      // 3.篩選與取消項目有相依關係的主約項目，也須取消勾選
      let dependencyMainItems = this.handleGetDependencyMainItem(resItems, policyItems);

      dependencyMainItems = _.filter(dependencyMainItems, (dependencyMainItem: any) => dependencyMainItem.CHECKED);

      if (dependencyMainItems && dependencyMainItems.length > 0) {
        unCheckItems = new Array(0);
        _.forEach(dependencyMainItems, (dependencyMainItem: any) => {
          const unCheckedArray = this.handleItemUnChecked(dependencyMainItem, newPolicyItems, dependencyMainItem.CONTRACT_TYPE);
          unCheckItems.push(...unCheckedArray);
        });

        this.handleUpdateFoldToggle(unCheckItems, policyItems, checked);
        newPolicyItems = this.handleUpdateItem(unCheckItems, false, [...newPolicyItems], item, itemType);
      }

      newPolicyItems = this.handleSetAffectiveItem(newPolicyItems, this.state.policyItem);

      this.formikRef.current.setFieldValue('POLICY_ITEM', newPolicyItems);

      this.setState(state => {
        return {
          ...state,
          hasWebInsuredItem: this.handleCheckWebInsuredItems(newPolicyItems)
        };
      });
    }

    if (checked) {
      let newPolicyItems = this.handleItemChecked(item, policyItems, itemType);

      newPolicyItems = this.handleSetAffectiveItem(newPolicyItems, this.state.policyItem);
      this.handleUpdateMainItemToggle(item, policyItems);

      // 勾選後的提示訊息
      this.handleShowCheckedInfo(item, newPolicyItems);
      // 檢核預定生效日是否需一致，有錯誤，用強制險預定生效日覆蓋任意險預定生效日
      const msg = this.handleCheckEffectDate(newPolicyItems, false, undefined, undefined, item);
      if (msg) {
        const formVal = this.formikRef.current.values as InprocessSelectFormValue;
        this.formikRef.current.setFieldValue('ARBITRARY_INS_EFFECTIVE_DATE', formVal.COMPULSORY_INS_EFFECTIVE_DATE);
      }

      this.formikRef.current.setFieldValue('POLICY_ITEM', newPolicyItems);

      this.setState(state => {
        return {
          ...state,
          hasWebInsuredItem: this.handleCheckWebInsuredItems(newPolicyItems)
        };
      });

      // 檢核勾選項目使否為限網投
      await this.handleCheckWebInsuredItem(item, fieldName);

      this.handleScrollToItem(item.ITEM_ID, checked);
    }
  }

  /**
   * @description 判斷所有內容是否有限網投項目
   */
  handleCheckWebInsuredItems = (policyItems: any) => {
    return _.some(policyItems, (policyItem: PolicyItemListContent) => {
      return _.some(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => mainItem.CONSTRAIN && mainItem.CONSTRAIN.FORCE_BCTYPE && mainItem.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured) ||
        _.some(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => subItem.CONSTRAIN && subItem.CONSTRAIN.FORCE_BCTYPE && subItem.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured);
    });
  }

  /**
   * @description 判斷保障項目是否為網投項目
   */
  handleCheckWebInsuredItem = async (item: any, fieldName: string) => {
    // 判斷若不為法人車，判斷是否登入，未登入-提示訊息是否登入 是-導致登入頁 否-取消勾選
    if (!this.props.fetchFavoriteComplete && item.CONSTRAIN && item.CONSTRAIN.FORCE_BCTYPE && item.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured) {
      const loginCheck = await sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '選擇的商品限制為網投，請先進行登入',
        showCancelButton: true
      }).then((res) => {
        if (res.value) {
          return true;
        }

        if (res.dismiss) {
          return false;
        }
      });

      if (loginCheck) {
        this.props.onSelectItemLogin();
        return;
      }

      this.formikRef.current.setFieldValue(fieldName, false);
    }
  }

  /**
   * @description 檢核預定生效日是否需一致
   */
  handleCheckEffectDate = (policyItems: any, isDateChange: boolean = false, compulsoryDate?: any, arbitraryDate?: any, item?: any) => {
    // 取得有投保的項目
    const insuredPolicys = this.handleFetchInsuredPolicys(policyItems);
    if (
      insuredPolicys.length > 0 &&
      this.formikRef &&
      this.formikRef.current
    ) {
      let itemIndex = _.findIndex(insuredPolicys, (insured: any) => insured.CONSTRAIN && insured.CONSTRAIN.ALIGN_DATE);
      if (item && (!item.CONSTRAIN || !item.CONSTRAIN.ALIGN_DATE)) {
        itemIndex = -1;
      }

      if (itemIndex === -1) return '';

      const formVal = this.formikRef.current.values as InprocessSelectFormValue;
      const compulsoryEffectDate = isDateChange
        ? compulsoryDate
        : formVal.COMPULSORY_INS_EFFECTIVE_DATE;

      const arbitraryEffectDate = isDateChange
        ? arbitraryDate
        : formVal.ARBITRARY_INS_EFFECTIVE_DATE;

      const codeMsg = commonService.getCodeMsg(this.props.UICodes, CodeId.W042);
      let msg = '';
      this.formikRef.current.setFieldTouched('ARBITRARY_INS_EFFECTIVE_DATE', true);
      if (compulsoryEffectDate && !arbitraryEffectDate) {
        msg = codeMsg;
      }

      if (compulsoryEffectDate && arbitraryEffectDate) {
        const isSameDate = moment(compulsoryEffectDate).format('YYYYMMDD') === moment(arbitraryEffectDate).format('YYYYMMDD');
        if (!isSameDate) {
          msg = codeMsg;
        }
      }

      if (msg) {
        this.props.setInfoModalVisible(true, '', msg);
      }

      return msg;
    }
  }

  /**
   * @description 清除保障項目 HighLight 項目
   */
  handleUpdateSelectItemClass = () => {
    const removeItemIds = ['31', '56', '57', '65', '07A7'];

    _.forEach(removeItemIds, (item: string) => {
      this.handleSetSelectItemCalss(item);
    });
  }

  /**
   * @description 移動至對應保障項目
   */
  handleScrollToItem = (itemId: string, isAdd?: boolean) => {
    let infoMsg;
    let infoMsg2: string = '';

    // 改用前端規則判斷，可擴充欲 highlight 的商品項目
    ['36A_HIGHLIGHT', '56M_57M_HIGHLIGHT', '65M_HIGHLIGHT'].forEach(ruleId => {
      const rule = commonService.getFrontendRule(ruleId);
      // 比對規則的附約欄位
      if (rule && rule.subItems.includes(itemId)) {
        // 滾動至主約位置
        rule.mainItems.forEach(itemId => {
          this.handleSetSelectItemCalss(itemId, isAdd);
        });
        // 處理第一則訊息
        if (rule.codeId01) {
          infoMsg = commonService.getCodeMsg(this.props.UICodes, rule.codeId01);
        }
        // 處理第二則訊息
        if (rule.codeId02) {
          infoMsg2 = commonService.getCodeMsg(this.props.UICodes, rule.codeId02);
        }
      }
    });

    if (infoMsg) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: infoMsg
      }).then(() => {
        if (infoMsg2) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: infoMsg2
          });
        }
      });
    }
  }

  /**
   * @description 更新主約的附加條款展開狀態
   */
  handleUpdateFoldToggle = (items: any, policyItems: any, checked: boolean) => {
    if (!items || items.length === 0) return;

    _.forEach(items, (item: any) => {
      if (item.CONTRACT_TYPE !== VehicleItemType.CONTRACT_TYPE_MAIN) return;

      const policyItemIndex = _.findIndex(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
      if (policyItemIndex === -1) return;

      if (policyItems[policyItemIndex].MAIN_ITEMS && policyItems[policyItemIndex].MAIN_ITEMS.length > 0) {
        this.handleCheckBoxFoldToggle(policyItemIndex, policyItems[policyItemIndex].MAIN_ITEMS.length - 1, checked);
      }

      const mainIndex = _.findIndex(policyItems[policyItemIndex].MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === item.ITEM_ID);
      if (mainIndex === -1) return;

      this.handleCheckBoxFoldToggle(policyItemIndex, mainIndex, checked);
    });
  }

  /**
   * @description 勾選的項目為主約，將副約開啟
   */
  handleUpdateMainItemToggle = (item: any, policyItems: any) => {
    if (!item || item.CONTRACT_TYPE !== VehicleItemType.CONTRACT_TYPE_MAIN) return;

    const policyItemIndex = _.findIndex(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
    if (policyItemIndex === -1) return;

    if (policyItems[policyItemIndex].MAIN_ITEMS && policyItems[policyItemIndex].MAIN_ITEMS.length > 0) {
      this.handleCheckBoxFoldToggle(policyItemIndex, policyItems[policyItemIndex].MAIN_ITEMS.length - 1, true);
    }
  }

  /**
   * @description 移動至對應項目，並將 select 項目邊框變紅
   */
  handleSetSelectItemCalss = (itemId: string, isAdd?: boolean) => {
    setTimeout(() => {
      const element = document.querySelector(`div[custom-attribute-item-id="${itemId}"]`) as HTMLDivElement;
      if (!element) return;

      const selects = element.getElementsByTagName('select');
      if (!selects || selects.length === 0) return;

      if (isAdd) {
        _.forEach(selects, (select: HTMLSelectElement) => {
          select.classList.add('element__select-highlight');
        });

        window.scroll({
          top: element.offsetTop + 100,
          behavior: 'smooth'
        });

        return;
      }

      _.forEach(selects, (select: HTMLSelectElement) => {
        select.classList.remove('element__select-highlight');
      });
    });
  }

  /**
   * @description 保障項目勾選狀態
   */
  handleItemChecked = (item: any, policyItems: any[], itemType: string, updateToggle: boolean = true) => {
    let newPolicyItems = new Array(0);

    // 取得 相關連(Related) 項目
    let relatedItems = this.handleGetRelatedItems(item, policyItems);
    relatedItems = _.filter(relatedItems, (relatedItem: any) => !relatedItem.CHECKED);
    // 勾選主約
    if (itemType === VehicleItemType.CONTRACT_TYPE_MAIN) {
      // 取得相依的附約子項目
      const dependencyItems = this.handleGetDependencyItem(relatedItems, policyItems);
      // 取得符合勾選規則的附約子項目 (2024/01/15)
      const checkItemsByRules = this.checkSelectSubItemsByRules(item, dependencyItems);
      // 篩選相依附約子項目其關聯項目是否有勾選，須一併勾選
      const checkChildItem = this.handleChildRelativeCheckItem(dependencyItems, policyItems);
      const checkItem = [...relatedItems, ...checkChildItem, ...checkItemsByRules];

      updateToggle && this.handleUpdateFoldToggle(checkItem, policyItems, true);

      // 更新勾選狀態
      newPolicyItems = this.handleUpdateItem(checkItem, true, [...policyItems]);

      // 篩選已勾選項目的互斥項目
      const excludeItems = this.handleGetExcludeItems(checkItem, policyItems);
      // excludeItems = this.handleGetDependencyMainItem(excludeItems, policyItems);

      // 篩選須取消勾選的項目
      let unCheckItems = new Array(0);
      _.forEach(excludeItems, (excludeItem: any) => {
        const unCheckedArray = this.handleItemUnChecked(excludeItem, newPolicyItems, excludeItem.CONTRACT_TYPE);
        unCheckItems.push(...unCheckedArray);
      });
      // 記錄需顯示提示刪除的項目
      let infoItems = [...unCheckItems];
      updateToggle && this.handleUpdateFoldToggle(unCheckItems, policyItems, false);
      // 更新勾選狀態
      newPolicyItems = this.handleUpdateItem(unCheckItems, false, [...newPolicyItems]);

      // 篩選與互斥項目有相依關係的主約項目，也須取消勾選
      unCheckItems = new Array(0);

      let dependencyMainItems = this.handleGetDependencyMainItem(excludeItems, policyItems);
      dependencyMainItems = _.filter(dependencyMainItems, (dependencyMainItem: any) => dependencyMainItem.CHECKED);

      dependencyMainItems = _.map(dependencyMainItems, (item: any) => {
        return this.handleCheckDependencyItem(dependencyMainItems, item, newPolicyItems);
      });

      _.forEach(dependencyMainItems, (dependencyMainItem: any) => {
        const unCheckedArray = this.handleItemUnChecked(dependencyMainItem, newPolicyItems, dependencyMainItem.CONTRACT_TYPE);
        unCheckItems.push(...unCheckedArray);
      });

      // 更新記錄需顯示提示刪除的項目
      infoItems = [...infoItems, ...unCheckItems];
      // 提示取消商品訊息
      this.handleShowExcludeInfo(infoItems);
      updateToggle && this.handleUpdateFoldToggle(unCheckItems, policyItems, false);
      return this.handleUpdateItem(unCheckItems, false, [...newPolicyItems]);
    }

    // 勾選附約
    if (itemType === VehicleItemType.CONTRACT_TYPE_SUB) {
      // 篩選相關連項目其主約項目已勾選的項目
      relatedItems = this.handleGetParentCheckItems(relatedItems, policyItems, true);
      const checkedItems = [...relatedItems];
      newPolicyItems = this.handleUpdateItem(checkedItems, true, [...policyItems]);

      // 篩選互斥項目
      let excludeItems = this.handleGetExcludeItems(checkedItems, policyItems);
      // 篩選有勾選的互斥項目
      excludeItems = _.filter(excludeItems, (excludeItem: any) => excludeItem.CHECKED);

      // 篩選互斥項目的附加條款
      let additionalItems = this.handleGetAdditionalItem(excludeItems);
      // 篩選有勾選的互斥項目附加條款
      additionalItems = _.filter(additionalItems, (additionalItem: any) => additionalItem.CHECKED);

      const unCkeckedItems = [...excludeItems, ...additionalItems];

      // 提示互斥商品訊息
      this.handleShowExcludeInfo(unCkeckedItems);
      return this.handleUpdateItem(unCkeckedItems, false, [...newPolicyItems]);
    }

    if (itemType === VehicleItemType.CONTRACT_TYPE_MAIN_ADD || itemType === VehicleItemType.CONTRACT_TYPE_SUB_ADD) {
      newPolicyItems = this.handleUpdateItem(relatedItems, true, [...policyItems], item, itemType);

      let excludeItems = this.handleGetExcludeItems(relatedItems, policyItems);

      excludeItems = _.filter(excludeItems, (excludeItem: any) => excludeItem.CHECKED);
      // 提示互斥商品訊息
      this.handleShowExcludeInfo(excludeItems);
      // newPolicyItems = this.handleUpdateItem(excludeItems, false, [...newPolicyItems]);

      return this.handleUpdateItem(excludeItems, false, [...newPolicyItems]);
    }
  }

  /**
   * @description 保障項目取消勾選狀態
   */
  handleItemUnChecked = (item: any, policyItems: any[], itemType: string) => {
    let resArray = new Array(0);

    // 取得 相關連(Related) 項目
    let relatedItems = this.handleGetRelatedItems(item, policyItems);
    // 篩選有勾選的關聯項目
    relatedItems = _.filter(relatedItems, (relatedItem: any) => relatedItem.CHECKED);
    resArray = [...resArray, ...relatedItems];

    // 主約取消
    if (itemType === VehicleItemType.CONTRACT_TYPE_MAIN) {
      // 取得本身與相關聯主約項目的相依附約子項目
      let dependencyItems = this.handleGetDependencyItem(relatedItems, policyItems);
      // 篩選選取狀態中的相依附約子項目
      dependencyItems = _.filter(dependencyItems, (dependencyItem: any) => dependencyItem.CHECKED);
      // 篩選可以取消勾選的相依附約子項目(相依的主約都是未勾選狀態才可取消)
      dependencyItems = this.handleCheckDependencyItem(dependencyItems, item, policyItems);
      // 篩選可以取消勾選相依附約子項目的相關連項目
      let childRelatedItems = new Array(0);
      _.forEach(dependencyItems, (dependencyItem: any) => {
        const relatedItems = this.handleGetRelatedItems(dependencyItem, policyItems);
        childRelatedItems.push(...relatedItems);
      });
      // 篩選附約子項目的相關連項目其主約為未勾選的項目(若其主約還是勾選狀態，不可取消勾選)
      childRelatedItems = this.handleGetParentCheckItems(childRelatedItems, policyItems, false);
      // 整合所有可取消的子項目
      dependencyItems = [...dependencyItems, ...childRelatedItems];
      // 取得子項目的附加條款
      const childAdditionalItems = this.handleGetAdditionalItem(dependencyItems);
      // 取得主約層的附加條款
      let additionalItems = this.handleGetAdditionalItem(relatedItems);
      // 篩選以勾選的附加條款
      additionalItems = _.filter(additionalItems, (additionalItem: any) => additionalItem.CHECKED);
      resArray = [...resArray, ...additionalItems, ...dependencyItems, ...childAdditionalItems];
    }

    // 附約取消
    if (itemType === VehicleItemType.CONTRACT_TYPE_SUB) {
      let dependencyItems = this.handleGetDependencyItem(relatedItems, policyItems);
      dependencyItems = _.filter(dependencyItems, (dependencyItem: any) => dependencyItem.CHECKED);

      // 取得子項目的附加條款項目
      let additionalItems = this.handleGetAdditionalItem(relatedItems);
      // 篩選以勾選項目
      additionalItems = _.filter(additionalItems, (additionalItem: any) => additionalItem.CHECKED);
      resArray = [...resArray, ...additionalItems, ...dependencyItems];
    }

    return resArray;
  }

  /**
   * @descriptiond 顯示要取消勾選的互斥項目
   */
  handleShowExcludeInfo = (excludeItems: any) => {
    if (!excludeItems || excludeItems.length === 0) return;

    const checkedItems = _.filter(excludeItems, (excludeItem: any) => excludeItem.CHECKED);
    const excludeItemIds = _.map(checkedItems, (checkItem: any) => checkItem.ITEM_ID);
    const resArray = new Array(0);
    _.forEach(excludeItemIds, (itemId: string) => {
      if (_.findIndex(resArray, (res: string) => res === itemId) === -1) {
        resArray.push(itemId);
      }
    });

    if (resArray.length > 0) {
      this.props.setInfoModalVisible(true, '選擇的商品包含互斥商品,將取消該等商品的選取', `商品代碼 : ${
        resArray.filter(item => !['88C1', '88C5', '88C7'].includes(item)).join(',')
      }`);
    }
  }

  /**
   * @description 取得關聯的保障項目資訊
   */
  handleGetRelatedItems = (item: any, policyItems: any[]) => {
    const relatedItems = [{ ...item }];
    if (!item.ITEM_RELATED || item.ITEM_RELATED.length === 0) return relatedItems;

    let relatedArray = [...item.ITEM_RELATED];
    let loop = true;
    while (loop) {
      // eslint-disable-next-line no-loop-func
      _.forEach(relatedArray, (relateds: any) => {
        _.forEach(relateds, (related: any) => {
          // 若已有新增過了，就停止迴圈離開
          if (_.findIndex(relatedItems, (relatedItem: any) => relatedItem.ITEM_ID === related.ITEM_ID) !== -1) {
            loop = false;
            return;
          }

          const relatedItem = { ...related };

          // eslint-disable-next-line no-loop-func
          const policyItem = _.find(policyItems, (policyItem: any) => relatedItem.ITEM_TYPE === policyItem.ITEM_TYPE);
          if (!policyItem) {
            loop = false;
            return;
          }

          switch (relatedItem.CONTRACT_TYPE) {
            case VehicleItemType.CONTRACT_TYPE_MAIN: {
              const mainItems = [...policyItem.MAIN_ITEMS];
              // eslint-disable-next-line no-loop-func
              const mainItem = _.find(mainItems, (mainItem: PolicyBaseItemContent) => mainItem.ITEM_ID === relatedItem.ITEM_ID);
              if (!mainItem) return;
              if (_.findIndex(relatedItems, (relatedItem: any) => relatedItem.ITEM_ID === mainItem.ITEM_ID) === -1) {
                relatedItems.push({
                  CHECKED: mainItem.CHECKED,
                  ITEM_TYPE: mainItem.ITEM_TYPE,
                  CONTRACT_TYPE: mainItem.CONTRACT_TYPE,
                  ITEM_ID: mainItem.ITEM_ID,
                  ITEM_DEPENDENCY: mainItem.ITEM_DEPENDENCY,
                  ITEM_EXCLUDED: mainItem.ITEM_EXCLUDED,
                  ITEM_RELATED: mainItem.ITEM_RELATED,
                  ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM,
                  AFFECTED_ITEM: mainItem.AFFECTED_ITEM,
                  PRECONDITION: relatedItem.PRECONDITION
                });
                relatedArray = mainItem.ITEM_RELATED && mainItem.ITEM_RELATED.length > 0
                  ? [...mainItem.ITEM_RELATED]
                  : new Array(0);
                loop = relatedArray.length > 0;
              } else {
                loop = false;
              }
            }
              break;
            case VehicleItemType.CONTRACT_TYPE_SUB: {
              const subItems = [...policyItem.SUB_ITEMS];
              // eslint-disable-next-line no-loop-func
              const subItem = _.find(subItems, (subItem: PolicyBaseItemContent) => subItem.ITEM_ID === relatedItem.ITEM_ID);
              if (!subItem) return;
              if (_.findIndex(relatedItems, (relatedItem: any) => relatedItem.ITEM_ID === subItem.ITEM_ID) === -1) {
                relatedItems.push({
                  CHECKED: subItem.CHECKED,
                  ITEM_TYPE: subItem.ITEM_TYPE,
                  CONTRACT_TYPE: subItem.CONTRACT_TYPE,
                  ITEM_ID: subItem.ITEM_ID,
                  ITEM_DEPENDENCY: subItem.ITEM_DEPENDENCY,
                  ITEM_EXCLUDED: subItem.ITEM_EXCLUDED,
                  ITEM_RELATED: subItem.ITEM_RELATED,
                  ADDITIONAL_TERM: subItem.ADDITIONAL_TERM,
                  AFFECTED_ITEM: subItem.AFFECTED_ITEM,
                  PRECONDITION: relatedItem.PRECONDITION
                });

                relatedArray = subItem.ITEM_RELATED && subItem.ITEM_RELATED.length > 0
                  ? [...subItem.ITEM_RELATED]
                  : new Array(0);
                loop = relatedArray.length > 0;
              } else {
                loop = false;
              }
            }
              break;
            case VehicleItemType.CONTRACT_TYPE_MAIN_ADD: {
              const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
                return Boolean(mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0 && _.findIndex(mainItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === relatedItem.ITEM_ID) !== -1);
              });

              if (mainItemIndex === -1) {
                loop = false;
                return;
              }

              const termItem = _.find(policyItem.MAIN_ITEMS[mainItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === relatedItem.ITEM_ID);
              if (!termItem) return;
              if (_.findIndex(relatedItems, (relatedItem: any) => relatedItem.ITEM_ID === termItem.ITEM_ID) === -1) {
                relatedItems.push({
                  CHECKED: termItem.CHECKED,
                  ITEM_TYPE: termItem.ITEM_TYPE,
                  CONTRACT_TYPE: termItem.CONTRACT_TYPE,
                  ITEM_ID: termItem.ITEM_ID,
                  ITEM_DEPENDENCY: termItem.ITEM_DEPENDENCY,
                  ITEM_EXCLUDED: termItem.ITEM_EXCLUDED,
                  ITEM_RELATED: termItem.ITEM_RELATED,
                  ADDITIONAL_TERM: termItem.ADDITIONAL_TERM,
                  AFFECTED_ITEM: termItem.AFFECTED_ITEM,
                  PRECONDITION: relatedItem.PRECONDITION
                });
                relatedArray = termItem.ITEM_RELATED && termItem.ITEM_RELATED.length > 0
                  ? [...termItem.ITEM_RELATED]
                  : new Array(0);
                loop = relatedArray.length > 0;
              } else {
                loop = false;
              }
            }
              break;
            case VehicleItemType.CONTRACT_TYPE_SUB_ADD: {
              const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
                return Boolean(subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0 && _.findIndex(subItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === relatedItem.ITEM_ID) !== -1);
              });

              if (subItemIndex === -1) {
                loop = false;
                return;
              }

              const termItem = _.find(policyItem.SUB_ITEMS[subItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === relatedItem.ITEM_ID);
              if (!termItem) return;
              if (_.findIndex(relatedItems, (relatedItem: any) => relatedItem.ITEM_ID === termItem.ITEM_ID) === -1) {
                relatedItems.push({
                  CHECKED: termItem.CHECKED,
                  ITEM_TYPE: termItem.ITEM_TYPE,
                  CONTRACT_TYPE: termItem.CONTRACT_TYPE,
                  ITEM_ID: termItem.ITEM_ID,
                  ITEM_DEPENDENCY: termItem.ITEM_DEPENDENCY,
                  ITEM_EXCLUDED: termItem.ITEM_EXCLUDED,
                  ITEM_RELATED: termItem.ITEM_RELATED,
                  ADDITIONAL_TERM: termItem.ADDITIONAL_TERM,
                  AFFECTED_ITEM: termItem.AFFECTED_ITEM,
                  PRECONDITION: relatedItem.PRECONDITION
                });
                relatedArray = termItem.ITEM_RELATED && termItem.ITEM_RELATED.length > 0
                  ? [...termItem.ITEM_RELATED]
                  : new Array(0);
                loop = relatedArray.length > 0;
              } else {
                loop = false;
              }
            }
              break;
          }
        });
      });
    }
    return relatedItems;
  }

  /**
   * @description 取得附加條款項目
   */
  handleGetAdditionalItem = (items: any) => {
    const additionalItems = new Array(0);

    _.forEach(items, (item: any) => {
      if (item.ADDITIONAL_TERM && item.ADDITIONAL_TERM.length > 0) {
        additionalItems.push(...item.ADDITIONAL_TERM);
      }
    });

    return additionalItems;
  }

  /**
   * @description 取得相依的子項目
   */
  handleGetDependencyItem = (items: any, policyItems: any[]) => {
    const dependencyItemRes = new Array(0);

    _.forEach(items, (item: any) => {
      _.forEach(policyItems, (policyItem: any) => {
        _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
          if (subItem.ITEM_DEPENDENCY && subItem.ITEM_DEPENDENCY.length > 0) {
            _.forEach(subItem.ITEM_DEPENDENCY, (dependencyItems: any) => {
              _.forEach(dependencyItems, (dependencyItem: any) => {
                // 取得對應的子項目
                const isTarget = dependencyItem.ITEM_TYPE === item.ITEM_TYPE &&
                  dependencyItem.CONTRACT_TYPE === item.CONTRACT_TYPE &&
                  dependencyItem.ITEM_ID === item.ITEM_ID;

                if (isTarget) {
                  if (_.findIndex(dependencyItemRes, (dependencyItem: any) => dependencyItem.ITEM_ID === subItem.ITEM_ID) === -1) {
                    dependencyItemRes.push({
                      CHECKED: subItem.CHECKED,
                      ITEM_TYPE: subItem.ITEM_TYPE,
                      CONTRACT_TYPE: subItem.CONTRACT_TYPE,
                      ITEM_ID: subItem.ITEM_ID,
                      ITEM_DEPENDENCY: subItem.ITEM_DEPENDENCY,
                      ITEM_EXCLUDED: subItem.ITEM_EXCLUDED,
                      ITEM_RELATED: subItem.ITEM_RELATED,
                      ADDITIONAL_TERM: subItem.ADDITIONAL_TERM,
                      AFFECTED_ITEM: subItem.AFFECTED_ITEM
                    });
                  }
                }
              });
            });
          }
        });
      });
    });

    return dependencyItemRes;
  }

  /**
   * @description 取得相依的父項目
   */
  handleGetDependencyMainItem = (items: any, policyItems: any[]) => {
    const dependencyItemRes = new Array(0);

    _.forEach(items, (item: any) => {
      if (item.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN) {
        _.forEach(policyItems, (policyItem: any) => {
          _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
            if (mainItem.ITEM_DEPENDENCY && mainItem.ITEM_DEPENDENCY.length > 0) {
              _.forEach(mainItem.ITEM_DEPENDENCY, (dependencyItems: any) => {
                _.forEach(dependencyItems, (dependencyItem: any) => {
                  // 取得對應的子項目
                  const isTarget = dependencyItem.ITEM_TYPE === item.ITEM_TYPE &&
                    dependencyItem.CONTRACT_TYPE === item.CONTRACT_TYPE &&
                    dependencyItem.ITEM_ID === item.ITEM_ID;

                  if (isTarget) {
                    if (_.findIndex(dependencyItemRes, (dependencyItem: any) => dependencyItem.ITEM_ID === mainItem.ITEM_ID) === -1) {
                      dependencyItemRes.push({
                        CHECKED: mainItem.CHECKED,
                        ITEM_TYPE: mainItem.ITEM_TYPE,
                        CONTRACT_TYPE: mainItem.CONTRACT_TYPE,
                        ITEM_ID: mainItem.ITEM_ID,
                        ITEM_DEPENDENCY: mainItem.ITEM_DEPENDENCY,
                        ITEM_EXCLUDED: mainItem.ITEM_EXCLUDED,
                        ITEM_RELATED: mainItem.ITEM_RELATED,
                        ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM,
                        AFFECTED_ITEM: mainItem.AFFECTED_ITEM
                      });
                    }
                  }
                });
              });
            }
          });
        });
      }
    });

    return dependencyItemRes;
  }

  /**
   * 執行「勾選規則」並取出應該勾選之附約
   * @param mainItem 主約
   * @param subItems 附約
   */
  checkSelectSubItemsByRules = (mainItem: any, subItems: any[]) => {
    // 若有緩存資料，則不執行自動勾選 (2024/03/14)
    const { tempSelectState } = this.props.tempSelect;
    if (tempSelectState && tempSelectState.policyItem.length > 0) return [];
    const selectItems = new Array(0);
    // 尋找匹配的勾選規則，若有則依規則取出附約
    const rules = this.selectRules.filter(it => it.mainItems.includes(mainItem.ITEM_ID));
    if (rules.length > 0) {
      rules.forEach(rule => {
        if (!rule.applied) {
          rule.applied = true;
          subItems.forEach((item) => {
            if (rule.subItems.includes(item.ITEM_ID)) selectItems.push(item);
          });
        }
      });
    }
    return selectItems;
  }

  // /**
  //  * @description 取得相依的父項目
  // */
  // handleGetParentDependencyItems = (items:any, policyItems:any[]) => {
  //   const dependencyItemRes = new Array(0);

  //   _.forEach(items, (item:any) => {
  //     if (item.ITEM_DEPENDENCY && item.ITEM_DEPENDENCY.length === 1) {
  //       _.forEach(item.ITEM_DEPENDENCY, (dependencyItems:any) => {
  //         _.forEach(dependencyItems, (dependencyItem:any) => {
  //           const policyItem = _.find(policyItems, (policyItem:any) => policyItem.ITEM_TYPE === dependencyItem.ITEM_TYPE);
  //           if (!policyItem) return;

  //           const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem:any) => mainItem.ITEM_ID === dependencyItem.ITEM_ID);
  //           if (!mainItem) return;
  //           if (_.findIndex(dependencyItemRes, (dependencyItem:any) => dependencyItem.ITEM_ID === mainItem.ITEM_ID) === -1) {
  //             dependencyItemRes.push({
  //               CHECKED: mainItem.CHECKED,
  //               ITEM_TYPE: mainItem.ITEM_TYPE,
  //               CONTRACT_TYPE: mainItem.CONTRACT_TYPE,
  //               ITEM_ID: mainItem.ITEM_ID,
  //               ITEM_DEPENDENCY: mainItem.ITEM_DEPENDENCY,
  //               ITEM_EXCLUDED: mainItem.ITEM_EXCLUDED,
  //               ITEM_RELATED: mainItem.ITEM_RELATED,
  //               ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM,
  //               AFFECTED_ITEM: mainItem.AFFECTED_ITEM
  //             });
  //           }
  //         });
  //       });
  //     }
  //   });

  //   return dependencyItemRes;
  // }

  /**
   * @description 篩選相依附約子項目其關聯項目是否有勾選，須一併勾選
   */
  handleChildRelativeCheckItem = (items: any, policyItems: any[]) => {
    const filtItems = new Array(0);
    _.forEach(items, (item: any) => {
      if (item.ITEM_RELATED && item.ITEM_RELATED.length > 0) {
        _.forEach(item.ITEM_RELATED, (relativeItems: any) => {
          _.forEach(relativeItems, (relativeItem: any) => {
            const policyItem = _.find(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === relativeItem.ITEM_TYPE);
            if (!policyItem) return;
            switch (relativeItem.CONTRACT_TYPE) {
              case VehicleItemType.CONTRACT_TYPE_MAIN: {
                const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === relativeItem.ITEM_ID);
                if (mainItem && mainItem.CHECKED) {
                  filtItems.push(item);
                }
                break;
              }
              case VehicleItemType.CONTRACT_TYPE_SUB: {
                const subItem = _.find(policyItem.SUB_ITEMS, (subItem: any) => subItem.ITEM_ID === relativeItem.ITEM_ID);
                if (subItem && subItem.CHECKED) {
                  filtItems.push(item);
                }
                break;
              }
            }
          });
        });
      }
    });
    return filtItems;
  }

  /**
   * @description 篩選相依項目其父項有勾選的項目才能勾選
   */
  handleGetParentCheckItems = (items: any, policyItems: any[], checkStatus: boolean) => {
    const filtItems = new Array(0);
    _.forEach(items, (item: any) => {
      if (item.PRECONDITION) {
        const policyItem = _.find(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === item.PRECONDITION.ITEM_TYPE);
        if (!policyItem) return;

        switch (item.PRECONDITION.CONTRACT_TYPE) {
          case VehicleItemType.CONTRACT_TYPE_MAIN: {
            const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === item.PRECONDITION.ITEM_ID);
            if (mainItem && mainItem.CHECKED === checkStatus) {
              filtItems.push(item);
            }
            break;
          }
          case VehicleItemType.CONTRACT_TYPE_SUB: {
            const subItem = _.find(policyItem.SUB_ITEMS, (subItem: any) => subItem.ITEM_ID === item.PRECONDITION.ITEM_ID);
            if (subItem && subItem.CHECKED === checkStatus) {
              filtItems.push(item);
            }
            break;
          }
        }
      } else {
        filtItems.push(item);
      }
    });

    return filtItems;
  }

  /**
   * @description 取得互斥的項目
   */
  handleGetExcludeItems = (items: any, policyItems: any[]) => {
    const excludeItemRes = new Array(0);
    _.forEach(items, (item: any) => {
      if (item.ITEM_EXCLUDED && item.ITEM_EXCLUDED.length > 0) {
        _.forEach(item.ITEM_EXCLUDED, (excludeItems: any) => {
          _.forEach(excludeItems, (excludeItem: any) => {
            const policyItem = _.find(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === excludeItem.ITEM_TYPE);
            if (!policyItem) return;

            switch (excludeItem.CONTRACT_TYPE) {
              case VehicleItemType.CONTRACT_TYPE_MAIN: {
                const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === excludeItem.ITEM_ID);
                if (!mainItem) return;
                if (_.findIndex(excludeItemRes, (excludeItem: any) => excludeItem.ITEM_ID === mainItem.ITEM_ID) === -1) {
                  excludeItemRes.push({
                    CHECKED: mainItem.CHECKED,
                    ITEM_TYPE: mainItem.ITEM_TYPE,
                    CONTRACT_TYPE: mainItem.CONTRACT_TYPE,
                    ITEM_ID: mainItem.ITEM_ID,
                    ITEM_DEPENDENCY: mainItem.ITEM_DEPENDENCY,
                    ITEM_EXCLUDED: mainItem.ITEM_EXCLUDED,
                    ITEM_RELATED: mainItem.ITEM_RELATED,
                    ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM,
                    AFFECTED_ITEM: mainItem.AFFECTED_ITEM
                  });
                }
              }
                break;
              case VehicleItemType.CONTRACT_TYPE_SUB: {
                const subItem = _.find(policyItem.SUB_ITEMS, (subItem: any) => subItem.ITEM_ID === excludeItem.ITEM_ID);
                if (!subItem) return;
                if (_.findIndex(excludeItemRes, (excludeItem: any) => excludeItem.ITEM_ID === subItem.ITEM_ID) === -1) {
                  excludeItemRes.push({
                    CHECKED: subItem.CHECKED,
                    ITEM_TYPE: subItem.ITEM_TYPE,
                    CONTRACT_TYPE: subItem.CONTRACT_TYPE,
                    ITEM_ID: subItem.ITEM_ID,
                    ITEM_DEPENDENCY: subItem.ITEM_DEPENDENCY,
                    ITEM_EXCLUDED: subItem.ITEM_EXCLUDED,
                    ITEM_RELATED: subItem.ITEM_RELATED,
                    ADDITIONAL_TERM: subItem.ADDITIONAL_TERM,
                    AFFECTED_ITEM: subItem.AFFECTED_ITEM
                  });
                }
              }
                break;
              case VehicleItemType.CONTRACT_TYPE_MAIN_ADD: {
                const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
                  return Boolean(mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0 && _.findIndex(mainItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === excludeItem.ITEM_ID) !== -1);
                });

                const termItem = _.find(policyItem.MAIN_ITEMS[mainItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === excludeItem.ITEM_ID);

                if (!termItem) return;
                if (_.findIndex(excludeItemRes, (excludeItem: any) => excludeItem.ITEM_ID === termItem.ITEM_ID) === -1) {
                  excludeItemRes.push({
                    CHECKED: termItem.CHECKED,
                    ITEM_TYPE: termItem.ITEM_TYPE,
                    CONTRACT_TYPE: termItem.CONTRACT_TYPE,
                    ITEM_ID: termItem.ITEM_ID,
                    ITEM_DEPENDENCY: termItem.ITEM_DEPENDENCY,
                    ITEM_EXCLUDED: termItem.ITEM_EXCLUDED,
                    ITEM_RELATED: termItem.ITEM_RELATED,
                    ADDITIONAL_TERM: termItem.ADDITIONAL_TERM,
                    AFFECTED_ITEM: termItem.AFFECTED_ITEM
                  });
                }
              }
                break;
              case VehicleItemType.CONTRACT_TYPE_SUB_ADD: {
                const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
                  return Boolean(subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0 && _.findIndex(subItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === excludeItem.ITEM_ID) !== -1);
                });

                const termItem = _.find(policyItem.SUB_ITEMS[subItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === excludeItem.ITEM_ID);

                if (!termItem) return;
                if (_.findIndex(excludeItemRes, (excludeItem: any) => excludeItem.ITEM_ID === termItem.ITEM_ID) === -1) {
                  excludeItemRes.push({
                    CHECKED: termItem.CHECKED,
                    ITEM_TYPE: termItem.ITEM_TYPE,
                    CONTRACT_TYPE: termItem.CONTRACT_TYPE,
                    ITEM_ID: termItem.ITEM_ID,
                    ITEM_DEPENDENCY: termItem.ITEM_DEPENDENCY,
                    ITEM_EXCLUDED: termItem.ITEM_EXCLUDED,
                    ITEM_RELATED: termItem.ITEM_RELATED,
                    ADDITIONAL_TERM: termItem.ADDITIONAL_TERM,
                    AFFECTED_ITEM: termItem.AFFECTED_ITEM
                  });
                }
              }
                break;
            }
          });
        });
      }
    });
    return excludeItemRes;
  }

  /**
   * @description 更新保障項目狀態
   */
  handleUpdateItem = (updateItems: any, checkedStatus: boolean, policyItems: any[], item?: any, itemType?: string) => {
    //  if (item) {
    //    updateItems.push({
    //      ITEM_TYPE: item.ITEM_TYPE,
    //      CONTRACT_TYPE: item.CONTRACT_TYPE,
    //      ITEM_ID: item.ITEM_ID
    //    });
    //  }
    _.forEach(updateItems, (updateItem: any) => {
      const policyItemIndex = _.findIndex(policyItems, (policyItemVal: PolicyItemListContent) => policyItemVal.ITEM_TYPE === updateItem.ITEM_TYPE);
      if (policyItemIndex !== -1) {
        let policyItem = { ...policyItems[policyItemIndex] };

        // 對子項目設值
        switch (updateItem.CONTRACT_TYPE) {
          case VehicleItemType.CONTRACT_TYPE_MAIN:
            {
              const mainItems = [...policyItem.MAIN_ITEMS];
              const mainIndex = _.findIndex(mainItems, (mainItem: PolicyBaseItemContent) => mainItem.ITEM_ID === updateItem.ITEM_ID);
              const mainItem = { ...mainItems[mainIndex] };
              const newMainItems = {
                ...mainItem,
                CHECKED: checkedStatus
              };

              mainItems[mainIndex] = { ...newMainItems };

              policyItem = {
                ...policyItem,
                MAIN_ITEMS: [...mainItems]
              };
            }
            break;
          case VehicleItemType.CONTRACT_TYPE_SUB:
            {
              const subItems = [...policyItem.SUB_ITEMS];
              const subIndex = _.findIndex(subItems, (subItem: PolicyBaseItemContent) => subItem.ITEM_ID === updateItem.ITEM_ID);
              const subItem = { ...subItems[subIndex] };
              const newSubItems = {
                ...subItem,
                CHECKED: checkedStatus
              };

              subItems[subIndex] = { ...newSubItems };
              policyItem = {
                ...policyItem,
                SUB_ITEMS: [...subItems]
              };
            }
            break;
          case VehicleItemType.CONTRACT_TYPE_MAIN_ADD: {
            const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
              return Boolean(mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0 && _.findIndex(mainItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === updateItem.ITEM_ID) !== -1);
            });

            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainItem = { ...mainItems[mainItemIndex] };
            const termIndex = _.findIndex(policyItem.MAIN_ITEMS[mainItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === updateItem.ITEM_ID);
            const terms = [...policyItem.MAIN_ITEMS[mainItemIndex].ADDITIONAL_TERM];
            const term = { ...terms[termIndex] };
            const newTerm = {
              ...term,
              CHECKED: checkedStatus
            };

            terms[termIndex] = { ...newTerm };

            const newMainItem = {
              ...mainItem,
              ADDITIONAL_TERM: terms
            };

            mainItems[mainItemIndex] = { ...newMainItem };
            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
            break;
          case VehicleItemType.CONTRACT_TYPE_SUB_ADD: {
            const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
              return Boolean(subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0 && _.findIndex(subItem.ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === updateItem.ITEM_ID) !== -1);
            });

            const subItems = [...policyItem.SUB_ITEMS];
            const subItem = { ...subItems[subItemIndex] };
            const termIndex = _.findIndex(policyItem.SUB_ITEMS[subItemIndex].ADDITIONAL_TERM, (term: PolicyBaseItemContent) => term.ITEM_ID === updateItem.ITEM_ID);
            const terms = [...policyItem.SUB_ITEMS[subItemIndex].ADDITIONAL_TERM];
            const term = { ...terms[termIndex] };
            const newTerm = {
              ...term,
              CHECKED: checkedStatus
            };

            terms[termIndex] = { ...newTerm };

            const newSubItems = {
              ...subItem,
              ADDITIONAL_TERM: terms
            };

            subItems[subItemIndex] = { ...newSubItems };
            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
            break;
          }
        }

        policyItems[policyItemIndex] = { ...policyItem };
      }
    });

    return policyItems;
  }

  /**
   * @description 判斷相依關係的是否都已取消勾選，判斷是否取消勾選
   */
  handleCheckDependencyItem = (subItems: any, item: any, policyItems: any) => {
    const resArray = new Array(0);

    _.forEach(subItems, (subItem: any) => {
      const checkedResult = new Array(0);
      _.forEach(subItem.ITEM_DEPENDENCY, (dependencyItems: any) => {
        const groupCheckRes = new Array(0);
        _.forEach(dependencyItems, (dependencyItem: any) => {
          if (dependencyItem.ITEM_ID === item.ITEM_ID) {
            groupCheckRes.push(false);
            return;
          }

          const policyItem = _.find(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === dependencyItem.ITEM_TYPE);
          if (!policyItem) return;

          switch (dependencyItem.CONTRACT_TYPE) {
            case VehicleItemType.CONTRACT_TYPE_MAIN: {
              const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === dependencyItem.ITEM_ID);
              if (mainItem) {
                groupCheckRes.push(mainItem.CHECKED);
              } else {
                groupCheckRes.push(false);
              }
            }
              break;
            case VehicleItemType.CONTRACT_TYPE_SUB: {
              const subItem = _.find(policyItem.SUB_ITEMS, (subItem: any) => subItem.ITEM_ID === dependencyItem.ITEM_ID);
              if (subItem) {
                groupCheckRes.push(subItem.CHECKED);
              } else {
                groupCheckRes.push(false);
              }
            }
              break;
          }
        });

        checkedResult.push(_.every(groupCheckRes, (res: any) => res));
      });

      if (_.every(checkedResult, (res: boolean) => !res)) {
        resArray.push(subItem);
      }
    });

    return resArray;
  }

  /**
   * @description 設定 AFFECTED_ITEM 項目
   */
  handleSetAffectiveItem = (policyItems: any, originalPolicyItem: any) => {
    const newPolicyItems = [...policyItems];
    let insuredPolicyItems = this.handleFetchInsuredPolicys(newPolicyItems);

    _.forEach(insuredPolicyItems, (insuredPolicyItem: any) => {
      const policyItemIndex = _.findIndex(newPolicyItems, (policyItemVal: PolicyItemListContent) => policyItemVal.ITEM_TYPE === insuredPolicyItem.ITEM_TYPE);
      const policyItem = { ...newPolicyItems[policyItemIndex] };
      switch (insuredPolicyItem.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN: {
          const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
            return mainItem.ITEM_ID === insuredPolicyItem.ITEM_ID;
          });
          const mainItem = { ...policyItem.MAIN_ITEMS[mainItemIndex] };
          const newMainItem = {
            ...mainItem,
            ITEM_OPTION: this.handleGetOriginalItemOption(mainItem, mainItemIndex, originalPolicyItem)
          };
          policyItem.MAIN_ITEMS[mainItemIndex] = { ...newMainItem };
        }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB: {
          const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
            return subItem.ITEM_ID === insuredPolicyItem.ITEM_ID;
          });

          const subItem = { ...policyItem.SUB_ITEMS[subItemIndex] };

          const newSubItem = {
            ...subItem,
            ITEM_OPTION: this.handleGetOriginalItemOption(subItem, subItemIndex, originalPolicyItem)
          };
          policyItem.SUB_ITEMS[subItemIndex] = { ...newSubItem };
        }
          break;
      }
      newPolicyItems[policyItemIndex] = { ...policyItem };
    });
    insuredPolicyItems = _.filter(insuredPolicyItems, (insuredPolicyItem: any) => insuredPolicyItem.AFFECTED_ITEM && insuredPolicyItem.AFFECTED_ITEM.length > 0);
    if (insuredPolicyItems.length === 0) return newPolicyItems;

    _.forEach(insuredPolicyItems, (insuredPolicyItem: any) => {
      _.forEach(insuredPolicyItem.AFFECTED_ITEM, (affectiveItem: AffectedItemContent) => {
        const policyItemIndex = _.findIndex(newPolicyItems, (policyItemVal: PolicyItemListContent) => policyItemVal.ITEM_TYPE === affectiveItem.ITEM_TYPE);
        const policyItem = { ...newPolicyItems[policyItemIndex] };
        switch (affectiveItem.CONTRACT_TYPE) {
          case VehicleItemType.CONTRACT_TYPE_MAIN: {
            const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
              return mainItem.ITEM_ID === affectiveItem.ITEM_ID;
            });
            const mainItem = { ...policyItem.MAIN_ITEMS[mainItemIndex] };
            const newMainItem = {
              ...mainItem,
              // TEXT: affectiveItem.TEXT || mainItem.TEXT,
              ITEM_OPTION: affectiveItem.ITEM_OPTION && affectiveItem.ITEM_OPTION.length > 0
                ? this.handleSetAffectiveOpts(mainItem, affectiveItem.ITEM_OPTION)
                : this.handleGetOriginalItemOption(mainItem, mainItemIndex, originalPolicyItem)
            };
            policyItem.MAIN_ITEMS[mainItemIndex] = { ...newMainItem };
          }
            break;
          case VehicleItemType.CONTRACT_TYPE_SUB: {
            const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
              return subItem.ITEM_ID === affectiveItem.ITEM_ID;
            });
            const subItem = { ...policyItem.SUB_ITEMS[subItemIndex] };
            const newSubItem = {
              ...subItem,
              // TEXT: affectiveItem.TEXT || subItem.TEXT,
              ITEM_OPTION: affectiveItem.ITEM_OPTION && affectiveItem.ITEM_OPTION.length > 0
                ? this.handleSetAffectiveOpts(subItem, affectiveItem.ITEM_OPTION)
                : this.handleGetOriginalItemOption(subItem, subItemIndex, originalPolicyItem)
            };
            policyItem.SUB_ITEMS[subItemIndex] = { ...newSubItem };
          }
            break;
        }
        newPolicyItems[policyItemIndex] = { ...policyItem };
      });
    });

    return newPolicyItems;
  }

  /**
   * @description 取得保障項目原始選單項目
   */
  handleGetOriginalItemOption = (item: any, targetIndex: number, originalPolicyItem: any) => {
    const policyItem = _.find(originalPolicyItem, (policyItemVal: PolicyItemListContent) => policyItemVal.ITEM_TYPE === item.ITEM_TYPE);

    if (!policyItem) return new Array(0);

    switch (item.CONTRACT_TYPE) {
      case VehicleItemType.CONTRACT_TYPE_MAIN:
        return _.map(policyItem.MAIN_ITEMS[targetIndex].ITEM_OPTION, (itemOpt: PolicyBaseItemOptContent) => {
          switch (itemOpt.TYPE) {
            case VehicleItemType.ITEM_OPTION_OPTION:
            case VehicleItemType.ITEM_OPTION_HOPTION: {
              const targetItem = _.find(item.ITEM_OPTION, (opt: any) => opt.FID === itemOpt.FID);
              if (!targetItem) return itemOpt;
              return {
                ...itemOpt,
                SELECT_TEXT: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_TEXT : '',
                SELECT_VALUE: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_VALUE : ''
              };
            }
            case VehicleItemType.ITEM_OPTION_TEXT:
            case VehicleItemType.ITEM_OPTION_CALCULATE:
            default:
              return itemOpt;
          }
        });
      case VehicleItemType.CONTRACT_TYPE_SUB:
        return _.map(policyItem.SUB_ITEMS[targetIndex].ITEM_OPTION, (itemOpt: PolicyBaseItemOptContent, index: number) => {
          switch (itemOpt.TYPE) {
            case VehicleItemType.ITEM_OPTION_OPTION:
            case VehicleItemType.ITEM_OPTION_HOPTION: {
              const targetItem = _.find(item.ITEM_OPTION, (opt: any) => opt.FID === itemOpt.FID);
              if (!targetItem) return itemOpt;
              return {
                ...itemOpt,
                SELECT_TEXT: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_TEXT : '',
                SELECT_VALUE: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_VALUE : ''
              };
            }
            case VehicleItemType.ITEM_OPTION_TEXT:
            case VehicleItemType.ITEM_OPTION_CALCULATE:
            default:
              return itemOpt;
          }
        });
      default:
        return new Array(0);
    }
  }

  /**
   * @description 判斷是否設定選單預設值
   */
  handleCheckSetSelectVal = (val: any, opts: any) => {
    if (!val) return false;

    return _.findIndex(opts, (opt: PolicyBaseItemOptAmtContent) => +opt.VALUE === +val) !== -1;
  }

  /**
   * @description 設定限制選單的預設值
   */
  handleSetAffectiveOpts = (item: any, itemOpts: any) => {
    return _.map(itemOpts, (itemOpt: any) => {
      switch (itemOpt.TYPE) {
        case VehicleItemType.ITEM_OPTION_OPTION:
        case VehicleItemType.ITEM_OPTION_HOPTION: {
          const targetItem = _.find(item.ITEM_OPTION, (opt: any) => opt.FID === itemOpt.FID);
          if (!targetItem) return itemOpt;
          return {
            ...itemOpt,
            SELECT_TEXT: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_TEXT : '',
            SELECT_VALUE: this.handleCheckSetSelectVal(targetItem.SELECT_VALUE, itemOpt.OPTIONS) ? targetItem.SELECT_VALUE : ''
          };
        }
        case VehicleItemType.ITEM_OPTION_TEXT:
        case VehicleItemType.ITEM_OPTION_CALCULATE:
        default:
          return itemOpt;
      }
    });
  }

  /**
   * @description 判斷相依項父是否勾選
   */
  handleRelativeChecked = (policyItem: any, policyItems: any[]) => {
    if (policyItem.ITEM_DEPENDENCY && policyItem.ITEM_DEPENDENCY.length === 0) return false;

    // 全部相依關係的檢查結果
    const checkedRes = new Array(0);
    // 讀取目標項目的相依關係資料
    _.forEach(policyItem.ITEM_DEPENDENCY, (relativeContents: ItemRelativeBaseContent[]) => {
      // 單一群組檢查結果
      const groupCheckRes = new Array(0);
      // 讀取單一相依群組資料
      _.forEach(relativeContents, (relativeContent: ItemRelativeBaseContent) => {
        // 讀取對應的保障內容項目資料
        const policyItem = _.find(policyItems, (policyItem: any) => {
          return policyItem.ITEM_TYPE === relativeContent.ITEM_TYPE;
        });
        if (!policyItem) return;
        // 根據相依項目的主、附約類型進行查詢
        switch (relativeContent.CONTRACT_TYPE) {
          case VehicleItemType.CONTRACT_TYPE_MAIN: {
            const mainItem = _.find(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === relativeContent.ITEM_ID);
            if (!mainItem) {
              groupCheckRes.push(false);
              return;
            }
            // 記錄勾選結果
            groupCheckRes.push(mainItem.CHECKED || false);
            break;
          }
          case VehicleItemType.CONTRACT_TYPE_SUB: {
            const subItem = _.find(policyItem.SUB_ITEMS, (subItem: any) => subItem.ITEM_ID === relativeContent.ITEM_ID);
            if (!subItem) {
              groupCheckRes.push(false);
              return;
            }
            // 記錄勾選結果
            groupCheckRes.push(subItem.CHECKED || false);
            break;
          }
        }
      });

      // 記錄群組勾選結果，只要有任一不符者即為有沒勾選的相依項目
      checkedRes.push(_.some(groupCheckRes, (res: any) => !res));
      // isDisabled = _.every(groupCheckRes, (val:any) => val);
    });

    // 回傳判斷結果，判斷群組是否都檢核失敗
    return _.every(checkedRes, (res: any) => res);
  }

  // #endregion

  handleGoBack = (values: InprocessSelectFormValue, resetForm: any) => {
    const formVal: InprocessSelectFormValue = {
      ...initFormVal,
      ENGINE_NUMBER: values.ENGINE_NUMBER,
      VEHICAL_BODY_NUMBER: values.VEHICAL_BODY_NUMBER,
      COMPULSORY_INS_YEAR: values.COMPULSORY_INS_YEAR
    };

    const activeProdId = this.state.activeProdId;

    // 返回上一頁，則清除連動規則 (2024/03/14)
    this.selectRules.map(it => {
      it.applied = false;
      return it;
    });

    this.setState({ ...initState });

    resetForm({
      values: {
        ...formVal
      }
    });

    this.props.onGoBack(formVal, initState, activeProdId);
  }

  /**
   * @description 表單 Submit 事件
   */
  handleFormSubmit = async (values: InprocessSelectFormValue, showCalc: boolean, action: any) => {
    // const constrainErrors = [...this.state.constrainErrors];
    // if (constrainErrors && constrainErrors.length > 0) {
    //   const errorMsgs = _.map(constrainErrors, (errors:any) => errors.msg);
    //   this.props.setRuleValidErrorModalVisible(true, errorMsgs);
    //   return;
    // }

    // todo 汽車險 試算
    if (showCalc) {
      await this.handleCalc(values, action);
      return;
    }

    // // 商品區塊項目資料
    // const planItems = [...values.POLICY_ITEM];
    // // 取得有投保的項目
    // const insuredPolicys = this.handleFetchInsuredPolicys(planItems);
    // // 檢核保障內容是否選取、填寫是否完整
    // const insuredError = this.handleValidInsuredPolicyError(insuredPolicys);
    // if (insuredError) return;

    // todo 汽車險 開始結帳
    this.props.onSelectSubmit(values, this.state);
  }

  /**
   * @description 試算按鈕 click 事件
   */
  handleCalc = async (values: InprocessSelectFormValue, action: any) => {
    if (!this.props.tempVehicleOwnerInfo || !this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue) return;
    if (!this.props.tempVehicleInfo || !this.props.tempVehicleInfo.tempVehicleInfoFormValue || !this.props.tempVehicleInfo.tempVehicleInfoState) return;

    const vehicleOwnerInfoFormVal = { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;
    const vehicleInfoFormVal = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
    const vehicleInfoState = { ...this.props.tempVehicleInfo.tempVehicleInfoState } as IVehicleInfoState;

    // 商品區塊項目資料
    const planItems = [...values.POLICY_ITEM];

    // 檢核預定生效日是否需一致，有錯誤，用強制險預定生效日覆蓋任意險預定生效日
    const msg = this.handleCheckEffectDate(planItems, true, values.COMPULSORY_INS_EFFECTIVE_DATE, values.ARBITRARY_INS_EFFECTIVE_DATE);
    if (msg && action && action.setFieldValue) {
      action.setFieldValue('ARBITRARY_INS_EFFECTIVE_DATE', values.COMPULSORY_INS_EFFECTIVE_DATE);
      return;
    }

    // 取得有投保的項目
    const insuredPolicys = this.handleFetchInsuredPolicys(planItems);

    // 檢核是否有網投項目，且未登入或已登入非本人
    const hasWebInsureErr = await this.handleValidWebInsuredItem(insuredPolicys, null);
    if (hasWebInsureErr) return;

    // 檢核保障內容是否選取、填寫是否完整
    const insuredPolicyError = this.handleValidInsuredPolicyError(insuredPolicys);
    if (insuredPolicyError) return;

    // 檢核是否有投保強制險項目，與生效日是否填寫
    const compulsoryComplete = this.handleValidProductAndDate(values.COMPULSORY_INS_EFFECTIVE_DATE, insuredPolicys, true);
    if (!compulsoryComplete) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '您有勾選強制險項目，但未填寫強制險預定生效日，請確認'
      }).then(() => {
        setTimeout(() => {
          this.handleScrollToInput();
        }, 100);
      });
      return;
    }

    // 檢核是否有投保任意險項目，與生效日是否填寫
    const arbitraryComplete = this.handleValidProductAndDate(values.ARBITRARY_INS_EFFECTIVE_DATE, insuredPolicys, false);
    if (!arbitraryComplete) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '您有勾選任意險項目，但未填寫任意險預定生效日，請確認'
      }).then(() => {
        setTimeout(() => {
          this.handleScrollToInput();
        }, 100);
      });
      return;
    }

    // 1.檢核車險保障內容API
    const validVehicleInsRes = await this.handleValidVehicleIns(insuredPolicys, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, values);
    if (!validVehicleInsRes) return;

    // 顯示錯誤訊息
    if (validVehicleInsRes && validVehicleInsRes.FAIL_ITEMS && validVehicleInsRes.FAIL_ITEMS.length > 0) {
      this.handleShowValidErrorMsg(validVehicleInsRes.FAIL_ITEMS);
      return;
    }

    let depreciateAmt = this.state.depreciateAmt;
    // 2.車險保費計算API
    const evalRes = await this.handleEvalCar(
      values, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, insuredPolicys,
      this.state.activePlan, this.state.activeProdId);
    if (!evalRes) return;

    if (evalRes.IS_MODEL_CODE_ERROR) {
      if (this.props.onGoBackAndCorrectVehicleInfo) {
          this.props.onGoBackAndCorrectVehicleInfo();
      }
      return;
    }

    // 檢核折舊金額
    depreciateAmt = +evalRes.VEHICLE_DATA.ACTUALVALUE || 0;
    const validActualValueErr = this.handleValidActualValue(values, depreciateAmt, insuredPolicys);
    if (validActualValueErr) return;

    // 3.車險保單規則檢核
    const validVehicleInsRuleRes = await this.handleValidVehicleInsRule(insuredPolicys, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, values);
    if (!validVehicleInsRuleRes) return;

    // 顯示錯誤訊息
    if (validVehicleInsRuleRes && validVehicleInsRuleRes.FAIL_ITEMS && validVehicleInsRuleRes.FAIL_ITEMS.length > 0) {
      this.handleShowValidErrorMsg(validVehicleInsRuleRes.FAIL_ITEMS);
      return;
    }

    // 檢核結果需要勘車，提示訊息
    if (validVehicleInsRuleRes && validVehicleInsRuleRes.REQUIRE_CAR_SURVEY) {
      sweetAlertService.modal({
        html: commonService.getCodeMsg(this.state.extenCode, CodeId.M020)
      });
    }

    // 更新原始保費、優惠保費欄位
    this.handleUpdatePolicyPrenium(values, evalRes.POLICY_ITEM_LIST);

    this.setState({
      showCalcBtn: false,
      depreciateAmt: depreciateAmt,
      evalCarRes: { ...evalRes },
      validVehicleInsRuleRes: { ...validVehicleInsRuleRes }
    });

    this.props.onSelectCale(values, this.state);

    //  // 滑動到試算結果區塊
    //  window.scroll({
    //    top: this.productAreaRef.current.offsetTop + 100
    //  });
  }

  /**
   * @description 檢核折舊金額項目
   */
  handleValidActualValue = (values: any, depreciateAmt: number, insuredPolicys: any) => {
    const itemIndex = _.findIndex(insuredPolicys, (policy: any) => policy.ITEM_ID === '07A7');
    if (itemIndex === -1) return;
    // 商品區塊項目資料
    const policyItems = [...values.POLICY_ITEM];

    const item = insuredPolicys[itemIndex];
    // 折舊金額小於 100000 移除 07A7  項目，並提示訊息
    if ((depreciateAmt * 0.75) < 100000) {
      const policyItemIndex = _.findIndex(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
      if (policyItemIndex === -1) return '執行錯誤';

      // 更新 07A7 取消勾選
      policyItems[policyItemIndex] = {
        ...policyItems[policyItemIndex],
        MAIN_ITEMS: _.filter(policyItems[policyItemIndex].MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID !== item.ITEM_ID)
      };

      this.setState({
        depreciateAmt: depreciateAmt
      });

      this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
      this.props.setInfoModalVisible(true, '', commonService.getCodeMsg(this.props.UICodes, CodeId.W056));

      return item.ITEM_ID;
    }

    const itemOpt = _.find(item.ITEM_OPTION, (opt: any) => opt.FID === VehicleItemType.ITEM_FID_AMOUNT);
    if (!itemOpt) return;

    if (depreciateAmt > +itemOpt.SELECT_VALUE) return;

    // 07A7 選取值若大於折舊金額，清除選取值，並提示訊息
    const policyItemIndex = _.findIndex(policyItems, (policyItem: any) => policyItem.ITEM_TYPE === item.ITEM_TYPE);
    if (policyItemIndex === -1) return '執行錯誤';

    const mainItemIndex = _.findIndex(policyItems[policyItemIndex].MAIN_ITEMS, (mainItem: any) => mainItem.ITEM_ID === item.ITEM_ID);
    if (mainItemIndex === -1) return '執行錯誤';

    // 更新 07A7 取消勾選
    policyItems[policyItemIndex].MAIN_ITEMS[mainItemIndex] = {
      ...policyItems[policyItemIndex].MAIN_ITEMS[mainItemIndex],
      ITEM_OPTION: _.map(policyItems[policyItemIndex].MAIN_ITEMS[mainItemIndex].ITEM_OPTION, (opt: any) => {
        if (opt.FID !== VehicleItemType.ITEM_FID_AMOUNT) return opt;

        return {
          ...opt,
          SELECT_VALUE: '',
          SELECT_TEXT: ''
        };
      })
    };

    this.setState({
      depreciateAmt: depreciateAmt
    });
    this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
    this.handleSetSelectItemCalss(item.ITEM_ID, true);
    this.props.setInfoModalVisible(true, '', commonService.getCodeMsg(this.props.UICodes, CodeId.W057));

    return item.ITEM_ID;
  }

  /**
   * @description 檢核投保項目是否包含限網投項目，判斷是否登入、法人
   */
  handleValidWebInsuredItem = async (items: any, item: any) => {
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    if (!tempVehicleOwnerInfoFormValue) return;

    let validWebInsured = false;

    if (item) {
      validWebInsured = item.CONSTRAIN && item.CONSTRAIN.FORCE_BCTYPE && item.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured;
    }

    if (!validWebInsured && items && items.length > 0) {
      validWebInsured = _.some(items, (item: any) => item.CONSTRAIN && item.CONSTRAIN.FORCE_BCTYPE && item.CONSTRAIN.FORCE_BCTYPE === ApplyType.WebInsured);
    }

    if (!validWebInsured) return;

    if (tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE === NationalType.Legal) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '此項目為限制網投，法人無法選取，請確認'
      });
      return true;
    }

    // 判斷若為登入狀態、判斷車主與登入者是否相同人，若不同，提示訊息並不可勾選
    if (this.props.fetchFavoriteComplete) {
      const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
      const memberId = storageService.getItem(storageKeys.MemberId);
      let insuredError = false;

      if (tempVehicleOwnerInfoFormValue && memberId) {
        insuredError = commonService.validOwnerMathLoginID(tempVehicleOwnerInfoFormValue.MEMBER_ID, memberId, commonService.getCodeMsg(this.props.UICodes, CodeId.W031));
      }
      return insuredError;
    }
  }

  /**
   * @description 檢核選取項目對應的生效日期是否填寫
   */
  handleValidProductAndDate = (date: any, insuredItems: any, isCompulsory: boolean) => {
    let targetItems = [...insuredItems];

    if (isCompulsory) {
      targetItems = _.filter(insuredItems, (item: any) => item.CV_TYPE === VehicleItemType.CV_TYPE_CI);
    } else {
      targetItems = _.filter(insuredItems, (item: any) => item.CV_TYPE === VehicleItemType.CV_TYPE_VI);
    }

    if (!date && targetItems.length > 0) return false;

    return true;
  }

  /**
   * @description 檢核保障內容是否選取、填寫是否完整
   */
  handleValidInsuredPolicyError = (insuredPolicys: any[]) => {
    // 檢核有無保障內容
    if (insuredPolicys.length === 0 || !this.state.activePlan) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '請先選取方案或商品'
      });

      return true;
    }

    // 檢核有無未選取投保金額的項目
    const noValItems = new Array(0);
    _.forEach(insuredPolicys, (policy: any) => {
      if (!policy.CHECKED) return;

      _.forEach(policy.ITEM_OPTION, (item: any) => {
        if (item.TYPE === VehicleItemType.ITEM_OPTION_OPTION && !item.SELECT_VALUE && noValItems.indexOf(policy.ITEM_ID) === -1) {
          noValItems.push(policy.ITEM_ID);
        }
      });
    });

    if (noValItems.length > 0) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: `保障內容代碼 ${noValItems} 尚未選擇投保金額`
      });

      return true;
    }

    return false;
  }

  // #region 檢核車險保障內容、車險保費計算 API 相關方法
  /**
   * @description 檢核車險保障內容 API
   */
  handleValidVehicleIns = async (
    insuredPolicys: any[],
    vehicleOwnerInfoFormVal: IVehicleOwnerInfoFormValue,
    vehicleInfoFormVal: IVehicleInfoFormValue,
    vehicleInfoState: IVehicleInfoState,
    formVal: InprocessSelectFormValue
  ) => {
    const req = this.handleGetValidVehicleReq(insuredPolicys, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, formVal);
    return await service.validVehicleInsContent(req);
  }

  /**
   * @description 車險保單規則檢核
   */
  handleValidVehicleInsRule = async (
    insuredPolicys: any[],
    vehicleOwnerInfoFormVal: IVehicleOwnerInfoFormValue,
    vehicleInfoFormVal: IVehicleInfoFormValue,
    vehicleInfoState: IVehicleInfoState,
    formVal: InprocessSelectFormValue
  ) => {
    const req = this.handleGetValidVehicleReq(insuredPolicys, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, formVal);
    return await service.validVehicleInsRule(req);
  }

  /**
   * @description 取得檢核車險保障內容 Req
   */
  handleGetValidVehicleReq = (
    insuredPolicys: any[],
    vehicleOwnerInfoFormVal: IVehicleOwnerInfoFormValue,
    vehicleInfoFormVal: IVehicleInfoFormValue,
    vehicleInfoState: IVehicleInfoState,
    values: InprocessSelectFormValue
  ) => {
    const req: ValidVehicleInsContentReq = {
      APPLICANT_ID: vehicleOwnerInfoFormVal.MEMBER_ID,
      APPLICANT_BIRTHDAY: moment(vehicleOwnerInfoFormVal.BIRTHDAY).format('YYYYMMDD'),
      LICENSE_PLATE_NO: `${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_FRONT}-${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_BACK}`,
      VEHICLECAT_ID: vehicleOwnerInfoFormVal.VEHICLE_TYPE,
      INS_TYPE_ID: this.props.insTypeId,
      TYPE_CODE: vehicleInfoFormVal.VEHICAL_MODEL ? vehicleInfoFormVal.VEHICAL_MODEL.split(',') : [],
      REPLACEMENT_PRICE: this.state.replacementPrice ? +this.state.replacementPrice : 0,
      MANUFACTURE_DATE: moment(vehicleInfoFormVal.MANUFACTUR_YEAR_MONTH).format('YYYYMM'),
      ISSUE_DATE: vehicleInfoFormVal.ORIGINAL_DATE_ISSUE,
      DISPLACEMENT: +vehicleInfoFormVal.ENGINE_DISPLACEMENT,
      QPT: +vehicleInfoFormVal.LIMIT,
      ENGINE_ID: values.ENGINE_NUMBER ? values.ENGINE_NUMBER : undefined,
      VEHICLE_ID: values.VEHICAL_BODY_NUMBER ? values.VEHICAL_BODY_NUMBER : undefined,
      COMPULSORY_SDATE: values.COMPULSORY_INS_EFFECTIVE_DATE
        ? moment(values.COMPULSORY_INS_EFFECTIVE_DATE).format('YYYYMMDD')
        : undefined,
      VOLUNTARY_SDATE: values.ARBITRARY_INS_EFFECTIVE_DATE
        ? moment(values.ARBITRARY_INS_EFFECTIVE_DATE).format('YYYYMMDD')
        : undefined,
      PLAN_ID: this.state.activePlan,
      PLAN_TYPE: this.state.vehiclePlan?.VEHICLE_PLAN.find((plan) => plan.PLAN_ID === this.state.activePlan)?.PLAN_TYPE ?? '',
      ITEM_LIST: this.handleGetVehicleInsuredItems(insuredPolicys)
    };
    return req;
  }

  /**
   * @description 取得車險有投保的保障項目
   */
  handleGetVehicleInsuredItems = (insuredPolicys: any[]) => {
    return _.map(insuredPolicys, (inusredItem: any) => {
      let medical = 0;
      let life = 0;
      let factor = 0;
      let amt = 0;

      _.forEach(inusredItem.ITEM_OPTION, (opt: any) => {
        switch (opt.FID) {
          case VehicleItemType.ITEM_FID_MEDICAL:
            medical = +opt.SELECT_VALUE;
            break;
          case VehicleItemType.ITEM_FID_LIFE:
            life = +opt.SELECT_VALUE;
            break;
          case VehicleItemType.ITEM_FID_FACTOR:
            factor = +opt.SELECT_VALUE;
            break;
          case VehicleItemType.ITEM_FID_AMOUNT:
            amt = +opt.SELECT_VALUE;
            break;
        }
      });

      return {
        ITEM_TYPE: inusredItem.ITEM_TYPE,
        ITEM_ID: inusredItem.ITEM_ID,
        CONTRACT_TYPE: inusredItem.CONTRACT_TYPE,
        ITEM_OPTION: {
          MEDICAL: medical,
          LIFE: life,
          FACTOR: factor,
          AMOUNT: amt
        }
      };
    });
  };

  /**
   * @description 車險保費計算 API
   */
  handleEvalCar = async (
    values: InprocessSelectFormValue,
    vehicleOwnerInfoFormVal: IVehicleOwnerInfoFormValue,
    vehicleInfoFormVal: IVehicleInfoFormValue,
    vehicleInfoState: IVehicleInfoState,
    insuredPolicys: any[],
    activePlanId: string,
    activeProdId: string
  ) => {
    const evalReq = this.handleGetEvalCarReq(values, vehicleOwnerInfoFormVal, vehicleInfoFormVal, vehicleInfoState, insuredPolicys, activePlanId, activeProdId);
    return await service.evalCar(evalReq, this.props.insTypeId);
  }

  handleGetRenewalPolicyNo = (ipolicy: string) => {
    if (!ipolicy) return '';

    const policies = ipolicy.split('#');
    for (let index = 0; index < policies.length; index += 1) {
      const policy = policies[index].trim();
      const upperPolicy = policy.toUpperCase();
      if (policy && upperPolicy.indexOf('PH') !== 0 && upperPolicy.indexOf('PB') !== 0) {
        return policy;
      }
    }

    return '';
  }

  /**
   * @description 取得保費試算用 Req
   */
  handleGetEvalCarReq = (
    values: InprocessSelectFormValue,
    vehicleOwnerInfoFormVal: IVehicleOwnerInfoFormValue,
    vehicleInfoFormVal: IVehicleInfoFormValue,
    vehicleInfoState: IVehicleInfoState,
    insuredPolicys: any[],
    activePlanId: string,
    activeProdId: string) => {
    let startDate = values.ARBITRARY_INS_EFFECTIVE_DATE
      ? moment(values.ARBITRARY_INS_EFFECTIVE_DATE)
      : moment(values.COMPULSORY_INS_EFFECTIVE_DATE);

    // 是否包含強制險項目
    const hasCompulsory = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_CI) !== -1;
    if (hasCompulsory) {
      startDate = moment(values.COMPULSORY_INS_EFFECTIVE_DATE);
    }

    // 是否包含任意險項目
    const hasArbitrary = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_VI) !== -1;
    if (hasArbitrary) {
      startDate = moment(values.ARBITRARY_INS_EFFECTIVE_DATE);
    }

    // if (hasCompulsory && hasArbitrary) {
    //   startDate = moment(values.COMPULSORY_INS_EFFECTIVE_DATE).isAfter(moment(values.ARBITRARY_INS_EFFECTIVE_DATE))
    //     ? moment(values.COMPULSORY_INS_EFFECTIVE_DATE)
    //     : moment(values.ARBITRARY_INS_EFFECTIVE_DATE);
    // }

    let insuredYear = 1;// values.COMPULSORY_INS_EFFECTIVE_DATE && values.COMPULSORY_INS_YEAR ? +values.COMPULSORY_INS_YEAR : 1;
    //  if (values.ARBITRARY_INS_EFFECTIVE_DATE && values.COMPULSORY_INS_EFFECTIVE_DATE) {
    //    insuredYear = 1;
    //  }
    if (this.props.insTypeId === InsType.Moto) {
      insuredYear = values.COMPULSORY_INS_YEAR ? +values.COMPULSORY_INS_YEAR : 1;
    }

    const nationalityType = vehicleOwnerInfoFormVal.NATIONALITY_TYPE;
    // 更新附加條款內容值與其主、副約相同
    insuredPolicys = this.handleUpdateSubItemOpt(insuredPolicys);
    // 檢查startDate
    if (!moment(startDate).isValid()) {
      startDate = moment(); // 如果無效，初始化為今天
    }
    
    // 取得續保保單號碼
    const contractNo = this.handleGetRenewalPolicyNo(vehicleInfoState.renewVehicle && vehicleInfoState.renewVehicle.Ipolicy);

    const req: EvalCarReq = {
      INS_TYPE_ID: this.props.insTypeId,
      PLAN_ID: activePlanId,
      PROD_ID: activeProdId,
      ...(contractNo && { CONTRACT_NO: contractNo }),
      VEHICLE_PREMIUM: {
        STARTDATE: startDate.format('YYYYMMDD'),
        ENDDATE: startDate.add(insuredYear, 'y').format('YYYYMMDD'),
        PROGRAM_ID: vehicleOwnerInfoFormVal.PROGRAM_ID
          ? vehicleOwnerInfoFormVal.PROGRAM_ID
          : environment.defaultProgramId,
        INSURED_LIST: [{
          // 客戶類型 1-自然人、2-法人
          INSUREDTYPE: nationalityType === NationalType.Legal ? '2' : '1',
          // 要被保險人名稱  不帶
          INSUREDNAME: 'Unknow',
          // 要被保險人標誌 1-被保人、2-要保人
          INSUREDFLAG: '1',
          // 證件類型 1-身份證、2-居留證、5-統編
          IDENTIFYTYPE: nationalityType === NationalType.National
            ? '1'
            : nationalityType === NationalType.Foreigner
              ? '2'
              : nationalityType === NationalType.Legal
                ? '5'
                : '',
          // ID
          IDENTIFYNUMBER: vehicleOwnerInfoFormVal.MEMBER_ID,
          // 生日
          BIRTHDAY: vehicleOwnerInfoFormVal.BIRTHDAY
            ? moment(vehicleOwnerInfoFormVal.BIRTHDAY).format('YYYYMMDD')
            : moment().format('YYYYMMDD')
        }],
        VEHICLE_DATA: {
          // 車牌
          LICENSENO: `${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_FRONT}-${vehicleOwnerInfoFormVal.LICENSE_PLATE_NUMBER_BACK}`,
          // 車型
          CARKINDCODE: `${vehicleOwnerInfoFormVal.VEHICLE_TYPE}`,
          // 原始發照日
          ENROLLDATE: `${+vehicleInfoFormVal.ORIGINAL_DATE_YEAR + 1911}${vehicleInfoFormVal.ORIGINAL_DATE_MONTH}${vehicleInfoFormVal.ORIGINAL_DATE_DATE}`,
          // 製造年月 固定帶 1 號
          MAKEDATE: `${moment(vehicleInfoFormVal.MANUFACTUR_YEAR_MONTH).format('YYYYMM')}01`,
          // 廠牌車型代號 待確認
          MODELCODE: vehicleInfoFormVal.VEHICAL_LOSS_THEFT && (this.props.insTypeId === InsType.Car || this.props.insTypeId === InsType.Moto)
            ? vehicleInfoFormVal.VEHICAL_MODEL.replace(/,/g, '')
            : vehicleInfoFormVal.ENGINE_DISPLACEMENT_UNIT === VehiclePowerType.CubicCm
              ? `${vehicleInfoState.activeBrand}000000`
              : `${vehicleInfoState.activeBrand}000001`,
          // 座位數/乘載人數
          SEATCOUNT: +vehicleInfoFormVal.LIMIT,
          // 排氣量
          EXHAUSTSCALE: +vehicleInfoFormVal.ENGINE_DISPLACEMENT,
          // 重置價格
          PURCHASEPRICE: this.state.replacementPrice
            ? +this.state.replacementPrice
            : vehicleInfoFormVal.REPLACEMENT_PRICE
              ? +vehicleInfoFormVal.REPLACEMENT_PRICE
              : 0
        },
        POLICY_ITEM_LIST: _.map(insuredPolicys, (policy: any) => {
          let modelOne = 0;
          let deductible = 0;
          let modelMultiple = 0;
          let factor = 0;
          _.forEach(policy.ITEM_OPTION, (itemOpt: any) => {
            switch (itemOpt.FID) {
              case VehicleItemType.ITEM_FID_AMOUNT:
              case VehicleItemType.ITEM_FID_MEDICAL:
                modelOne = +itemOpt.SELECT_VALUE;
                break;
              case VehicleItemType.ITEM_FID_DEDUCTIBLE:
                deductible = +itemOpt.SELECT_VALUE;
                break;
              case VehicleItemType.ITEM_FID_FACTOR:
                factor = +itemOpt.SELECT_VALUE;
                break;
              case VehicleItemType.ITEM_FID_LIFE:
                modelMultiple = +itemOpt.SELECT_VALUE;
                break;
            }
          });
          const policyStartDate = this.handleGetPolicyInsuredDate(policy.CV_TYPE, values.COMPULSORY_INS_EFFECTIVE_DATE, values.ARBITRARY_INS_EFFECTIVE_DATE);
          const policyAddYear = this.handleGetPolicyInsuredAddYear(policy.CV_TYPE, values.COMPULSORY_INS_EFFECTIVE_DATE, values.COMPULSORY_INS_YEAR);
          return {
            // 保障內容代碼
            KINDCODE: policy.ITEM_ID,
            // 強制、生效日
            STARTDATE: policyStartDate.format('YYYYMMDD'),
            ENDDATE: policyStartDate.add(policyAddYear, 'y').format('YYYYMMDD'),
            // 人數/日數 固定帶 0
            QUANTITY: 0,
            // 保額  =  第一個選單值 * 倍數基本 = 1
            AMOUNT: factor ? modelOne * factor : modelOne,
            // 自負額 竊盜主險 10 % OR 20 % FID = DEDUCTIBLE
            DEDUCTIBLE: deductible,
            // 強制險優惠 固定帶 0
            DISCOUNTCHARGE: 0,
            // 前保額一 = 第一個選單值
            MODELONE: modelOne,
            // 保額二 = 第二選單值 = 第一個選單值 * 倍數(FID FACTOR 值) 倍數基本 = 1
            MODELMULTIPLE: modelMultiple || modelOne * factor
          };
        })
      }
    };

    return req;
  }

  /**
   * @description 更新附加條款 ItemOpt 內容
   */
  handleUpdateSubItemOpt = (insuredPolicys: any) => {
    const targetItems = _.filter(insuredPolicys, (policy: any) => policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN || policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_SUB);
    const resArray = new Array(0);
    _.forEach(insuredPolicys, (policy: any) => {
      // 若為主約或副約不做任何動作
      if (policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_MAIN || policy.CONTRACT_TYPE === VehicleItemType.CONTRACT_TYPE_SUB) {
        resArray.push(policy);
      } else {
        // 若為附加條款，篩選對應的主、附約，來更新 ITEM_OPTION
        const item = _.find(targetItems, (target: any) => policy.ITEM_ID.indexOf(target.ITEM_ID) !== -1);
        if (item) {
          const res = {
            ...policy,
            ITEM_OPTION: [...item.ITEM_OPTION]
          };
          resArray.push(res);
        } else {
          resArray.push(policy);
        }
      }
    });

    return resArray;
  }

  /**
   * @description 取得保障項目投保日期
   * @param cvType 險種類型
   * @param compulsoryDate 強制險生效日
   * @param arbitraryDate 任意險生效日
   */
  handleGetPolicyInsuredDate = (cvType: string, compulsoryDate: any, arbitraryDate: any) => {
    // 強制險以強制險為主，無值再以任意險為主
    if (cvType === VehicleItemType.CV_TYPE_CI) {
      return compulsoryDate ? moment(compulsoryDate) : moment(arbitraryDate);
    }

    // 任意險以任意險為主，無值再以強制險為主
    return arbitraryDate ? moment(arbitraryDate) : moment(compulsoryDate);
  }

  /**
   * @description 取得投保年期
   */
  handleGetPolicyInsuredAddYear = (cvType: string, compulsoryDate: any, compulsoryInsYear: any) => {
    if (this.props.insTypeId === InsType.Moto) {
      return compulsoryInsYear ? +compulsoryInsYear : 1;
    }

    return 1;
  }

  /**
   * @description 更新原始保費、優惠保費欄位
   */
  handleUpdatePolicyPrenium = (values: InprocessSelectFormValue, evalCarResPolicyItems: EvalCarResPolicyItemContent[]) => {
    // 商品區塊項目資料
    let policyItems = [...values.POLICY_ITEM];

    policyItems = _.map(policyItems, (policyItem: PolicyItemListContent) => {
      return {
        ...policyItem,
        MAIN_ITEMS: _.map(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent) => {
          return {
            ...mainItem,
            ADDITIONAL_TERM: mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0
              ? _.map(mainItem.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent) => {
                return {
                  ...additionalTerm,
                  PREMIUM: '-',
                  RULEPREMIUM: '-'
                };
              })
              : mainItem.ADDITIONAL_TERM,
            PREMIUM: '-',
            RULEPREMIUM: '-'
          };
        }),
        SUB_ITEMS: _.map(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent) => {
          return {
            ...subItem,
            ADDITIONAL_TERM: subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0
              ? _.map(subItem.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent) => {
                return {
                  ...additionalTerm,
                  PREMIUM: '-',
                  RULEPREMIUM: '-'
                };
              })
              : subItem.ADDITIONAL_TERM,
            PREMIUM: '-',
            RULEPREMIUM: '-'
          };
        })
      };
    });

    // 對保費試算的結果跑迴圈
    _.forEach(evalCarResPolicyItems, (evalCarResPolicyItem: EvalCarResPolicyItemContent) => {
      // 暫存子項目資訊用
      let childItemInfo = {
        // 險種契約類型，主、副約
        CONTRACT_TYPE: '',
        // 位置
        ITEM_INDEX: 0,
        PARENT_CONTRACT_TYPE: '',
        PARENT_ITEM_INDEX: 0,
        PARENT_ITEM_ID: ''
      };

      // 取得該筆試算結果與保障項目的對應 Index
      // 並記錄子項目資訊
      const policyItemIndex = _.findIndex(policyItems, (policyItem: PolicyItemListContent, index: number) => {
        let policyIndex;
        _.forEach(policyItem.MAIN_ITEMS, (mainItem: PolicyBaseItemContent, mainItemIndex: number) => {
          if (mainItem.ADDITIONAL_TERM) {
            const mainAddIndex = _.findIndex(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
              return additionalTerm.CHECKED && additionalTerm.ITEM_ID === evalCarResPolicyItem.KINDCODE;
            });

            if (mainAddIndex !== -1) {
              policyIndex = index;
              childItemInfo = {
                CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN_ADD,
                ITEM_INDEX: mainAddIndex,
                PARENT_ITEM_INDEX: mainItemIndex,
                PARENT_CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN,
                PARENT_ITEM_ID: mainItem.ITEM_ID
              };
            }
          }
        });

        if (policyIndex) return policyIndex;

        _.forEach(policyItem.SUB_ITEMS, (subItem: PolicyBaseItemContent, subItemIndex: number) => {
          if (subItem.ADDITIONAL_TERM) {
            const subAddIndex = _.findIndex(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
              return additionalTerm.CHECKED && additionalTerm.ITEM_ID === evalCarResPolicyItem.KINDCODE;
            });

            if (subAddIndex !== -1) {
              policyIndex = index;
              childItemInfo = {
                CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB_ADD,
                ITEM_INDEX: subAddIndex,
                PARENT_ITEM_INDEX: subItemIndex,
                PARENT_CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB,
                PARENT_ITEM_ID: subItem.ITEM_ID
              };
            }
          }
        });

        if (policyIndex) return policyIndex;

        const mainItemIndex = _.findIndex(policyItem.MAIN_ITEMS, (mainItem: any) => {
          return mainItem.CHECKED && mainItem.ITEM_ID === evalCarResPolicyItem.KINDCODE;
        });

        if (mainItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_MAIN,
            ITEM_INDEX: mainItemIndex,
            PARENT_ITEM_INDEX: 0,
            PARENT_CONTRACT_TYPE: '',
            PARENT_ITEM_ID: ''
          };
        }

        const subItemIndex = _.findIndex(policyItem.SUB_ITEMS, (subItem: any) => {
          return subItem.CHECKED && subItem.ITEM_ID === evalCarResPolicyItem.KINDCODE;
        });

        if (subItemIndex !== -1) {
          childItemInfo = {
            CONTRACT_TYPE: VehicleItemType.CONTRACT_TYPE_SUB,
            ITEM_INDEX: subItemIndex,
            PARENT_ITEM_INDEX: 0,
            PARENT_CONTRACT_TYPE: '',
            PARENT_ITEM_ID: ''
          };
        }

        return mainItemIndex !== -1 || subItemIndex !== -1;
      });

      if (policyItemIndex === -1) return;

      let policyItem = { ...policyItems[policyItemIndex] };
      // 更新對應項目的保費資訊
      switch (childItemInfo.CONTRACT_TYPE) {
        case VehicleItemType.CONTRACT_TYPE_MAIN:
          {
            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainItem = { ...mainItems[childItemInfo.ITEM_INDEX] };
            const newMainItems = {
              ...mainItem,
              CHECKED: true,
              RULEPREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[0].PREMIUM}`),
              PREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[1].PREMIUM}`)
            };

            mainItems[childItemInfo.ITEM_INDEX] = { ...newMainItems };

            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB:
          {
            const subItems = [...policyItem.SUB_ITEMS];
            const subItem = { ...subItems[childItemInfo.ITEM_INDEX] };
            const newSubItems = {
              ...subItem,
              CHECKED: true,
              RULEPREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[0].PREMIUM}`),
              PREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[1].PREMIUM}`)
            };

            subItems[childItemInfo.ITEM_INDEX] = { ...newSubItems };
            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_MAIN_ADD:
          {
            const mainItems = [...policyItem.MAIN_ITEMS];
            const mainItem = { ...mainItems[childItemInfo.PARENT_ITEM_INDEX] };
            const additionals = mainItem.ADDITIONAL_TERM ? [...mainItem.ADDITIONAL_TERM] : new Array(0);
            additionals[childItemInfo.ITEM_INDEX] = {
              ...additionals[childItemInfo.ITEM_INDEX],
              CHECKED: true,
              RULEPREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[0].PREMIUM}`),
              PREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[1].PREMIUM}`)
            };

            const newMainItems = {
              ...mainItem,
              CHECKED: true,
              ADDITIONAL_TERM: additionals
            };

            mainItems[childItemInfo.PARENT_ITEM_INDEX] = { ...newMainItems };

            policyItem = {
              ...policyItem,
              MAIN_ITEMS: [...mainItems]
            };
          }
          break;
        case VehicleItemType.CONTRACT_TYPE_SUB_ADD:
          {
            const subItems = [...policyItem.SUB_ITEMS];
            const subItem = { ...subItems[childItemInfo.PARENT_ITEM_INDEX] };
            const additionals = subItem.ADDITIONAL_TERM ? [...subItem.ADDITIONAL_TERM] : new Array(0);
            additionals[childItemInfo.ITEM_INDEX] = {
              ...additionals[childItemInfo.ITEM_INDEX],
              CHECKED: true,
              RULEPREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[0].PREMIUM}`),
              PREMIUM: commonService.thousandFormat(`${evalCarResPolicyItem.PREMIUM[1].PREMIUM}`)
            };

            const newSubItems = {
              ...subItem,
              CHECKED: true,
              ADDITIONAL_TERM: additionals
            };

            subItems[childItemInfo.PARENT_ITEM_INDEX] = { ...newSubItems };

            policyItem = {
              ...policyItem,
              SUB_ITEMS: [...subItems]
            };
          }
          break;
      }
      policyItems[policyItemIndex] = policyItem;
    });

    this.formikRef.current.setFieldValue('POLICY_ITEM', policyItems);
  }

  /**
   * @description 顯示檢核錯誤訊息
   */
  handleShowValidErrorMsg = (items: ValidVehicleInsFailItem[]) => {
    const errorMsgs = _.map(items, (item: ValidVehicleInsFailItem) => {
      const errorIdArray = item.ITEM_ID.indexOf(',') !== -1 ? item.ITEM_ID.split(',') : [item.ITEM_ID];
      // const errorNameArray = item.ITEM_NAME.indexOf('、') !== -1 ? item.ITEM_NAME.split('、') : [item.ITEM_NAME];
      const formatMsg = _.map(errorIdArray, (idStr: string, index) => {
        return `項目${idStr}<br />`;
      });

      return `${formatMsg.join(' ')}<br />${item.ERROR_MSG}${item.ITEM_ID_MISMATCH ? `(${item.ITEM_ID_MISMATCH})` : ''}<br />`;
    });

    if (errorMsgs.length > 0) {
      this.props.setRuleValidErrorModalVisible(true, errorMsgs);
    }
  }

  // #endregion

  /**
   * @description 建立商品保障內容
   * @param policyItemType 險種類別
   * @param contractType 主/副約
   * @param itemId 保障內容代號
   * @param itemName 保障內容名稱
   * @param itemOpt 保障內容資料
   */
  handleFormatPolicyContent = (policyItemIndex: number, parentIndex: number, contractType: string, item: any, activeStatus: boolean, disabledStatus: boolean, checkBoxVal: boolean) => {
    if (!this.formikRef || !this.formikRef.current) return;
    const handleChange = this.formikRef.current.handleChange;
    const setFieldValue = this.formikRef.current.setFieldValue;
    const formatContent = _.map(item.ITEM_OPTION, (itemOpt: PolicyBaseItemOptContent, itemIndex: number) => {
      if (!itemOpt) return;
      switch (itemOpt.TYPE) {
        case VehicleItemType.ITEM_OPTION_TEXT:
        case VehicleItemType.ITEM_OPTION_CALCULATE:
          return itemOpt.VALUE;
        case VehicleItemType.ITEM_OPTION_OPTION:
        case VehicleItemType.ITEM_OPTION_HOPTION:
        {
          const className = itemOpt.TYPE === VehicleItemType.ITEM_OPTION_HOPTION ? 'element__select display-none' : 'element__select';
          const fieldName = `POLICY_ITEM.[${policyItemIndex}].${contractType}[${parentIndex}].ITEM_OPTION[${itemIndex}].SELECT_VALUE`;
          const fieldTextName = `POLICY_ITEM.[${policyItemIndex}].${contractType}[${parentIndex}].ITEM_OPTION[${itemIndex}].SELECT_TEXT`;
          return (
            <Field
              as="select"
              disabled={this.state.disableProduct || activeStatus || disabledStatus || !checkBoxVal}
              className={className}
              id={`POLICY_ITEM.[${policyItemIndex}].${contractType}[${parentIndex}].ITEM_OPTION[${itemIndex}]`}
              key={itemIndex}
              name={fieldName}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                handleChange(e);
                setFieldValue(fieldTextName, e.currentTarget.selectedOptions.item(0)?.text);
                this.handleSelectItemChange(e.currentTarget.value, item, itemOpt.FID || '', policyItemIndex, parentIndex, contractType, setFieldValue);
                // const msg = this.handleItemConstrain(item.CONSTRAIN, itemOpt.FID, item, e.currentTarget.value);
                // const constrainErrors = this.handleShowConstrain(fieldName, msg);

                this.setState({
                  showCalcBtn: true
                  // ,constrainErrors: [...constrainErrors]
                });
              }}
            >
              <option value="">請選擇</option>
              {
                this.handleGetItemOps(item, itemOpt)
              }
            </Field>
          );
        }
        case VehicleItemType.ITEM_OPTION_SUM: {
          if (item.CHECKED) {
            return this.handleGetPolicyContentSumVal(item.ITEM_OPTION);
          }

          return '';
        }
      }
    });

    return (
      <>
        <p>
          {`${item.ITEM_ID}.${item.ITEM_NAME}`}
          {formatContent}
          {this.handleFormatContent(item)}
          {this.handleGetDepreciateText(item.ITEM_ID)}
          {
            item.ITEM_NOTE && (
              <span className="select-products__item-note">{item.ITEM_NOTE}</span>
            )
          }
        </p>
      </>
    );
  }

  /**
   * @description 取得顯示折舊金額文字（車體/竊盜險）
   */
  handleGetDepreciateText = (itemId: string) => {
    const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
    const mainItems = hiddenRule ? hiddenRule.mainItems : [];
    if (mainItems.indexOf(itemId) === -1 || !this.state.depreciateAmt) return;

    return `，車輛保險金額:${this.state.depreciateAmt}`;
  }

  /**
   * @description 格式化顯示內容
   */
  handleFormatContent = (item: any) => {
    if ((item.ITEM_ID === '33A' || item.ITEM_ID === '33B') && item.CHECKED) {
      const opt: any = _.find(item.ITEM_OPTION, (opt: any) => opt.SELECT_VALUE);
      if (!opt) return '';

      if (isNaN(+opt.SELECT_VALUE)) return '';

      const sum = +opt.SELECT_VALUE * 2;

      // const res = sum >= 10000 ? `${sum / 10000} 萬` : `${sum}`;

      return ` ${sum} 元`;
    }
  }

  /**
   * @description 取得保障項目下拉選單
   */
  handleGetItemOps = (item: any, itemOpt: any) => {
    if (!itemOpt.OPTIONS) return;

    return _.map(itemOpt.OPTIONS, (opt: PolicyBaseItemOptAmtContent, amtIndex: number) => {
      // 07A7 不顯示大於折舊金額的項目
      // 07A7 的 折舊價值 指( 07 的保額 * 0.75 )
      if (item.ITEM_ID === '07A7' && +opt.VALUE > this.state.depreciateAmt * 0.75) return;

      const limitVals: any = this.handleGetLimitVal(item, itemOpt.FID);
      if (limitVals && limitVals.indexOf(+opt.VALUE) === -1) return;

      return <option value={opt.VALUE} key={amtIndex}>{opt.TEXT}</option>;
    });
  }

  /**
   * @description 依條件取得可使用的選單值範圍
   */
  handleGetLimitVal = (item: any, fidType: string, val?: any) => {
    if (!item.CONSTRAIN || !item.ITEM_OPTION) return;
    let res;
    if (
      item.CONSTRAIN.LIMITATION &&
      item.CONSTRAIN.LIMITATION.length > 0 &&
      item.ITEM_OPTION &&
      item.ITEM_OPTION.length > 0 &&
      fidType === VehicleItemType.ITEM_FID_FACTOR
    ) {
      _.forEach(item.CONSTRAIN.LIMITATION, (limitContent: LimitationContent) => {
        let sourceVal = +val;
        if (!sourceVal) {
          const sourceOpt: any = _.find(item.ITEM_OPTION, (opt: PolicyBaseItemOptContent) => opt.FID === limitContent.SOURCE);
          if (!sourceOpt) return;
          sourceVal = +sourceOpt.SELECT_VALUE;
        }

        if (sourceVal >= limitContent.FROM && sourceVal <= limitContent.TO) res = limitContent.VALUE;
      });
      // const amtVal = _.fiind;
    }
    return res;
  }

  /**
   * @description 下拉選單切換事件
   */
  handleSelectItemChange = (
    val: any, item: any, fidType: string, policyItemIndex: number, parentIndex: number, contractType: string, setFieldValue: any
  ) => {
    // 項目 31 有選擇值時，根據比對條件判斷 倍數 選單的值是否需要清除
    const clearRule = commonService.getFrontendRule('31_31E0_CLEAR_CHECKING');
    const mainItems = clearRule ? clearRule.mainItems : [];
    if (val && mainItems.includes(item.ITEM_ID) && fidType === VehicleItemType.ITEM_FID_AMOUNT) {
      const limitVals: any = this.handleGetLimitVal(item, VehicleItemType.ITEM_FID_FACTOR, val);
      if (!limitVals) return;

      const factorIndex = _.findIndex(item.ITEM_OPTION, (opt: PolicyBaseItemOptContent) => opt.FID === VehicleItemType.ITEM_FID_FACTOR);
      if (factorIndex === -1) return;

      const factorVal = item.ITEM_OPTION && item.ITEM_OPTION.length > 0
        ? item.ITEM_OPTION[factorIndex].SELECT_VALUE
        : '';

      if (limitVals.indexOf(+factorVal) !== -1) return;

      setFieldValue(`POLICY_ITEM.[${policyItemIndex}].${contractType}[${parentIndex}].ITEM_OPTION[${factorIndex}].SELECT_VALUE`, '');
      setFieldValue(`POLICY_ITEM.[${policyItemIndex}].${contractType}[${parentIndex}].ITEM_OPTION[${factorIndex}].SELECT_TEXT`, '');
    }
  }

  /**
   * @description 取得保障內容顯示文字用總保額
   */
  handleGetPolicyContentSumVal = (opts: PolicyBaseItemOptContent[]) => {
    const { tempVehicleInfoFormValue } = this.props.tempVehicleInfo;
    if (!tempVehicleInfoFormValue) return '';

    const opt: any = _.find(opts, (opt: PolicyBaseItemOptContent) => opt.FID === VehicleItemType.ITEM_FID_AMOUNT);
    if (!opt) return '';

    if (isNaN(+opt.SELECT_VALUE)) return '';

    const sum = (+tempVehicleInfoFormValue.LIMIT - 1) * +opt.SELECT_VALUE;

    const res = sum >= 10000 ? `${sum / 10000} 萬` : `${sum}`;

    return res;
  }

  /**
   * @description 保障項目限制內容設定
   */
  handleItemConstrain = (
    constrain?: ConstrainContent, fidType?: string, item?: any, selevtVal?: any) => {
    if (!constrain) return '';

    if (constrain.CRITERIA) {
      const vehicleInfoFormValue = { ...this.props.tempVehicleInfo.tempVehicleInfoFormValue } as IVehicleInfoFormValue;
      // const diffYear = moment().diff(moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH), 'y');
      const diffYear = moment().year() - moment(vehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).year();

      let res = '';

      let criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear < criteria.MAX && !criteria.MIN && criteria.ACTION === 'INVISIBLE');
      if (criteria) {
        res = criteria.ACTION;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && diffYear < criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      criteria = _.find(constrain.CRITERIA, (criteria: CriteriaContent) => diffYear >= criteria.MIN && !criteria.MAX && criteria.ACTION === 'ALERT');
      if (criteria) {
        res = criteria.TEXT;
      }

      return res;
    }

    return '';
  }

  /**
   * @description 開啟/關閉 車籍資料詳細資訊
   */
  handleVehicleInfoDetailsToggle = () => {
    this.setState(state => ({ ...state, vehicleInfoDetailsOpen: !this.state.vehicleInfoDetailsOpen }));
  }

  // /**
  //  * @description 初始化 開啟/關閉附約 的開啟狀態
  //  */
  // setInitAttachedContractFoldsOpen = () => {
  //   if (formInitialValues.POLICY_ITEM) {
  //     const attachedContractFoldsArr = this.handleGetAttachedContractFolds(formInitialValues.POLICY_ITEM, true);

  //     this.setState(state => ({ ...state, attachedContractFoldsOpen: [...attachedContractFoldsArr] }));
  //   }
  // }

  handleGetAttachedContractFolds = (policyItems: PolicyItemListContent[], initOpenStatus: boolean) => {
    // const initOpenStatus: boolean = true; // 初始開啟狀態變數
    const attachedContractFoldsArr = _.map(policyItems, (policyItem: PolicyItemListContent) => {
      // 方案 Fold 開啟/關閉附約狀態 (Array)
      // 說明：每個方案區塊(險種)有一個 Array 存每個方案項目的開啟/關閉附約狀態。
      const schemeFoldsStatus = _.map(policyItem.MAIN_ITEMS, (mainItem: any) => {
        // 判斷若方案項目有「附加」，則設置為 true (代表有 "開啟/關閉附約" 按鈕)
        return mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0
          ? mainItem.CHECKED && initOpenStatus
            ? initOpenStatus
            : false
          : null;
      });

      // 判斷方案區塊若有附約，且有主約勾選，則將 array 最後一個 index 設置為 true (代表有 "開啟/關閉附約" 按鈕)
      // 說明："方案區塊的附約" 和 "方案項目最後一項目的附約" 使用同一區塊。
      if (_.has(policyItem, 'SUB_ITEMS') &&
        policyItem.SUB_ITEMS.length > 0 &&
        _.some(policyItem.MAIN_ITEMS, (mainItem: any) => mainItem.CHECKED)
      ) {
        schemeFoldsStatus[schemeFoldsStatus.length - 1] = initOpenStatus;
      }

      return schemeFoldsStatus;
    });

    return attachedContractFoldsArr;
  }

  /**
   * @description 切換 "開啟/關閉附約"，Fold 組件開啟/關閉
   * @param foldIndex 資料中使用 Fold 組件的 index
   */
  handleAttachedContractFoldToggle = (schemeFoldsIndex: number, foldIndex: number) => {
    const updatedAttachedContractFoldsOpen = [...this.state.attachedContractFoldsOpen];
    updatedAttachedContractFoldsOpen[schemeFoldsIndex][foldIndex] = !updatedAttachedContractFoldsOpen[schemeFoldsIndex][foldIndex];
    this.setState(state => ({ ...state, attachedContractFoldsOpen: [...updatedAttachedContractFoldsOpen] }));
  }

  /**
   * @description 切換 "開啟/關閉附約"，Fold 組件開啟/關閉
   * @param foldIndex 資料中使用 Fold 組件的 index
   * @param checked 項目勾選狀態
   */
  handleCheckBoxFoldToggle = (schemeFoldsIndex: number, foldIndex: number, checked: boolean) => {
    const updatedAttachedContractFoldsOpen = [...this.state.attachedContractFoldsOpen];

    updatedAttachedContractFoldsOpen[schemeFoldsIndex][foldIndex] = checked;

    this.setState(state => ({ ...state, attachedContractFoldsOpen: [...updatedAttachedContractFoldsOpen] }));
  }

  /**
   * @description 取得不可選取日期
   */
  handleGetDisabledDate = (current: any) => {
    // 改以系統時間判斷，並將時區已校準至台灣時區
    const dayShift = moment.unix(this.state.sysTime).hour() >= 12 ? 0 : -1;
    return current <= moment.unix(this.state.sysTime).add(dayShift, 'd') || current < moment('1911/01/01') || current > moment.unix(this.state.sysTime).add(2, 'M').add(-1, 'd');
  }

  /**
   * @description 檢核錯誤時滾到填寫區塊
   */
  handleScrollToInput = () => {
    // 滑動到試算結果區塊
    window.scroll({
      top: this.inputAreaRef.current.offsetTop + 100
    });
  }

  /**
   * @description 計算特定商品 (父商品與子商品) 原始保費加總
   */
  handleCalcTargetParentProdAndChildProdRulePremiumTotal = (policyItemIndex: number, mainItemIndex: number, currentChildProdFieldName: string) => {
    const parentProdRulePremiumDisplayElem = document.querySelector(`.policy-item-${policyItemIndex}-main-items-${mainItemIndex}-rule-premium`);
    const parentProdRulePremium = (document.querySelector(`input[name="POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainItemIndex}].RULEPREMIUM"]`) as HTMLInputElement)?.value.replace(',', '');
    const childProdRulePremium = (document.querySelector(`input[name="${currentChildProdFieldName}"]`) as HTMLInputElement)?.value.replace(',', '');
    if (parentProdRulePremiumDisplayElem) {
      const premium = (parentProdRulePremium.includes('-') || childProdRulePremium.includes('-')) ? '-' : commonService.thousandFormat(String(+parentProdRulePremium + +childProdRulePremium));
      parentProdRulePremiumDisplayElem.textContent = premium;
    }
  }

  /**
   * @description 計算特定商品 (父商品與子商品) 優惠保費加總
   */
  handleCalcTargetParentProdAndChildProdPremiumTotal = (policyItemIndex: number, mainItemIndex: number, currentChildProdFieldName: string) => {
    const parentProdPremiumDisplayElem = document.querySelector(`.policy-item-${policyItemIndex}-main-items-${mainItemIndex}-premium`);
    const parentProdPremium = (document.querySelector(`input[name="POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainItemIndex}].PREMIUM"]`) as HTMLInputElement)?.value.replace(',', '');
    const childProdPremium = (document.querySelector(`input[name="${currentChildProdFieldName}"]`) as HTMLInputElement)?.value.replace(',', '');
    if (parentProdPremiumDisplayElem) {
      const premium = (parentProdPremium.includes('-') || childProdPremium.includes('-')) ? '-' : commonService.thousandFormat(String(+parentProdPremium + +childProdPremium));
      parentProdPremiumDisplayElem.textContent = premium;
    }
  }

  /**
   * @description 從 server 取得時間
   */
  getSysTime = async () => {
    const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
    this.setState(prevState => {
      return {
        ...prevState,
        sysTime: sysTime
      };
    });
  }

  render () {
    const { type, tempVehicleOwnerInfo, tempVehicleInfo } = this.props;
    const vehicleInfoDetailsElemHeight = (this.state.vehicleInfoDetailsOpen && this.vehicleInfoDetailsRef && this.vehicleInfoDetailsRef.current) ? this.vehicleInfoDetailsRef.current?.clientHeight : 0;
    // #region 產生選擇方案或商品區塊

    const productOpt = new Array(0);
    if (this.state.vehiclePlan && this.state.vehiclePlan.VEHICLE_PLAN && this.state.vehiclePlan.VEHICLE_PLAN.length > 0) {
      _.forEach(this.state.vehiclePlan.VEHICLE_PLAN, (vehiclePlan: VehiclePlanContent, index: number) => {
        const className = this.state.activePlan === vehiclePlan.PLAN_ID
          ? 'select-products__scheme-list-item-btn select-products__scheme-list-item-btn--active'
          : 'select-products__scheme-list-item-btn select-products__scheme-list-item-btn';

        productOpt.push(
          <div className="select-products__scheme-list-item" key={index}>
            <div className="select-products__scheme-list-item-title">{vehiclePlan.PLAN_NAME}</div>
            <button
              type="button"
              className={className}
              onClick={() => {
                !this.state.isEcarPlan
                  ? this.handlePlanClick(vehiclePlan.PLAN_ID, vehiclePlan.PROD_ID, vehiclePlan.PLAN_NAME)
                  : this.handlePlanClickForEcar(vehiclePlan.PLAN_ID, vehiclePlan.PROD_ID, vehiclePlan.PLAN_NAME);
              }}
            >
              我要保這個
            </button>
            {
              this.state.activePlan === this.state.freePlanId && vehiclePlan.PLAN_ID === this.state.freePlanId && this.state.isRenewalAndUnEdit && (
                <p className="select-products__highlight-text">
                  {commonService.getCodeMsg(this.props.UICodes, CodeId.U023)}
                </p>
              )
            }
          </div>
        );
      });
    }

    // #endregion

    let motoCoprdOpts: any;
    if (this.state.motoCoprdSysOpts.length > 0) {
      motoCoprdOpts = _.map(this.state.motoCoprdSysOpts, (sysOpt: SysOption, index: number) => {
        return <option value={sysOpt.PARAM_VALUE} key={index}>{sysOpt.PARAM_TEXT}</option>;
      });
    }

    // #endregion
    /**
     * @description 取得會員 ID 類別對應的顯示名稱
     */
    const handleGetMemberIdType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.Foreigner:
          return '居留證號';
        case NationalType.Legal:
          return '統一編號';
        case NationalType.National:
        default:
          return '身份證字號';
      }
    };

    /**
     * @description 取得生日 類別對應的顯示名稱
     */
    const handleGetBirthdayType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.National:
        case NationalType.Foreigner:
        default:
          return '生日';
        case NationalType.Legal:
          return '公司登記日期';
      }
    };

    const { tempVehicleOwnerInfoState } = this.props.tempVehicleOwnerInfo;

    return (
      <div className="insure-process-select">
        <Formik
          initialValues={formInitialValues}
          onSubmit={(values: InprocessSelectFormValue, action: any) => this.handleFormSubmit(values, this.state.showCalcBtn, action)}
          enableReinitialize
          innerRef={this.formikRef}
        >
          {
            ({ errors, touched, handleChange, setFieldValue, setFieldTouched, values, resetForm }) => (
              <Form>
                <div className="insure-process-select__content">
                  {/* 投保資訊 (Fixed) */}
                  {
                    tempVehicleOwnerInfo && tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue &&
                    tempVehicleInfo && tempVehicleInfo.tempVehicleInfoFormValue &&
                    (
                      <div className={`insurance-info-fixed ${this.state.vehicleOwnerInfoFixedVisible ? ' insurance-info-fixed--active' : ''}`}>
                        <div className="template-container">
                          <div className="template-content">
                            <div className="element__list-group">
                              <div className="element__list-group-title">{handleGetMemberIdType(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE)}</div>
                              <div className="element__list-group-content">{commonService.hiddenStringLastCharacter(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.MEMBER_ID, 5)}</div>
                            </div>
                            {
                              tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE !== NationalType.Legal && (
                                <div className="element__list-group">
                                  <div className="element__list-group-title">{handleGetBirthdayType(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE)}</div>
                                  <div className="element__list-group-content">{moment(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.BIRTHDAY).format('YYYY/MM/DD')}</div>
                                </div>
                              )
                            }
                            <div className="element__list-group">
                              <div className="element__list-group-title">車牌號碼</div>
                              <div className="element__list-group-content">
                                {`${tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`}
                              </div>
                            </div>
                            <div className="element__list-group">
                              <div className="element__list-group-title">廠牌</div>
                              <div className="element__list-group-content">{tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MAKER}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {/* 投保資訊 */}
                  {
                    tempVehicleOwnerInfo && tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue &&
                    tempVehicleInfo && tempVehicleInfo.tempVehicleInfoFormValue &&
                    (
                      <div className="insurance-info">
                        <div className="insurance-info__container">
                          <div className="element__list-group">
                            <div className="element__list-group-title">{handleGetMemberIdType(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE)}</div>
                            <div className="element__list-group-content">{commonService.hiddenStringLastCharacter(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.MEMBER_ID, 5)}</div>
                          </div>
                          {
                            tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE !== NationalType.Legal && (
                              <div className="element__list-group">
                                <div className="element__list-group-title">{handleGetBirthdayType(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE)}</div>
                                <div className="element__list-group-content">{moment(tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.BIRTHDAY).format('YYYY/MM/DD')}</div>
                              </div>
                            )
                          }
                          <div className="element__list-group">
                            <div className="element__list-group-title">車牌號碼</div>
                            <div className="element__list-group-content">
                              {`${tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`}
                            </div>
                          </div>
                          <div className="element__list-group">
                            <div className="element__list-group-title">廠牌</div>
                            <div className="element__list-group-content">{tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MAKER}</div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {/* 車籍資料 */}
                  {
                    tempVehicleInfo && tempVehicleInfo.tempVehicleInfoFormValue && (
                      <div className="vehical-info" ref={this.vehicalInfoRef}>
                        <div className="vehical-info__title">
                          <span>車籍資料</span>
                          <button
                            type="button"
                            className={'element__icon-button' + (this.state.vehicleInfoDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                            onClick={this.handleVehicleInfoDetailsToggle}
                          >
                            {this.state.vehicleInfoDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button>
                        </div>
                        <div className="vehical-info__content">
                          <div className="vehical-info__details" style={{ height: vehicleInfoDetailsElemHeight }}>
                            <div className="vehical-info__list" ref={this.vehicleInfoDetailsRef}>
                              <div className="vehical-info__list-background">
                                <div className="vehical-info__list-container">
                                  <div className="element__list-group">
                                    <div className="element__list-group-title">廠牌</div>
                                    <div className="element__list-group-content">{tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MAKER}</div>
                                  </div>
                                  {type === InsTypeDefinesEN[InsTypeEnum.Car] && (
                                    <>
                                      <div className="element__list-group">
                                        <div className="element__list-group-title">車型</div>
                                        <div className="element__list-group-content">{tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_MODEL_NAME}</div>
                                      </div>
                                      <div className="element__list-group">
                                        <div className="element__list-group-title">車款</div>
                                        <div className="element__list-group-content">{tempVehicleInfo.tempVehicleInfoFormValue.VEHICAL_BRAND_NAME}</div>
                                      </div>
                                      <div className="element__list-group">
                                        <div className="element__list-group-title">重置價格</div>
                                        <div className="element__list-group-content">
                                          {commonService.thousandFormat(this.state.replacementPrice)}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <div className="element__list-group">
                                    <div className="element__list-group-title">製造年月</div>
                                    <div className="element__list-group-content">{moment(tempVehicleInfo.tempVehicleInfoFormValue.MANUFACTUR_YEAR_MONTH).format('YYYY年MM月')}</div>
                                  </div>
                                  <div className="element__list-group">
                                    <div className="element__list-group-title">原始發照日</div>
                                    <div className="element__list-group-content">
                                      {`${+tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_YEAR}年${tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_MONTH}月${tempVehicleInfo.tempVehicleInfoFormValue.ORIGINAL_DATE_DATE}日`}
                                    </div>
                                  </div>
                                  <div className="element__list-group">
                                    <div className="element__list-group-title">排氣量或馬力</div>
                                    <div className="element__list-group-content">
                                      {`${tempVehicleInfo.tempVehicleInfoFormValue.ENGINE_DISPLACEMENT}${commonService.getSysOptText(this.props.tempVehicleInfo.tempVehicleInfoState?.vehiclePowerSysOpts || new Array(0), this.props.tempVehicleInfo.tempVehicleInfoFormValue?.ENGINE_DISPLACEMENT_UNIT || '')}`}
                                    </div>
                                  </div>
                                  <div className="element__list-group">
                                    <div className="element__list-group-title">乘載限制</div>
                                    <div className="element__list-group-content">{`${tempVehicleInfo.tempVehicleInfoFormValue.LIMIT}人`}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="vehical-info__container">
                            <div className="vehical-info__container-left">
                              <div className="vehical-info__row" ref={this.inputAreaRef}>
                                {/* 引擎號碼 */}
                                <div className={'element__form-group' + (errors.ENGINE_NUMBER && touched.ENGINE_NUMBER ? ' element__form-group--invalid' : '')}>
                                  <div className="element__form-group-title">{this.props.insTypeId === InsType.Moto ? '引擎號碼*' : '引擎號碼'}</div>
                                  <Field
                                    component={InputWithRegex}
                                    regex={NumAndEnglishDashRegex}
                                    name="ENGINE_NUMBER"
                                    data-fieldname="ENGINE_NUMBER"
                                    tabIndex={1}
                                    maxLength={20}
                                    autoComplete="off"
                                    className="element__input"
                                    validate={(val: any) => {
                                      if (this.props.insTypeId === InsType.Moto && !val) return '此為必填欄位';
                                      if (this.props.insTypeId === InsType.Car && !val && !values.VEHICAL_BODY_NUMBER) return '引擎號碼與車身號碼至少擇一填寫';
                                      if (val.includes(' ')) return '引擎號碼不得包含空白字元';
                                      return '';
                                    }}
                                    onBlur={() => {
                                      setFieldTouched('ENGINE_NUMBER', true);
                                    }}
                                    placeholder={type === InsTypeDefinesEN[InsTypeEnum.Car] && '國產車請填引擎號碼'}
                                  />
                                  <div className="element__error-message">
                                    <ErrorMessage name="ENGINE_NUMBER" />
                                  </div>
                                </div>
                              </div>
                              {/* 車身號碼 */}
                              {type === InsTypeDefinesEN[InsTypeEnum.Car] && (
                                <div className="vehical-info__row">
                                  <div className={'element__form-group' + (errors.VEHICAL_BODY_NUMBER && touched.VEHICAL_BODY_NUMBER ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">車身號碼</div>
                                    <Field
                                      component={InputWithRegex}
                                      regex={NumAndEnglishDashRegex}
                                      maxLength={20}
                                      autoComplete="off"
                                      name="VEHICAL_BODY_NUMBER"
                                      data-fieldname="VEHICAL_BODY_NUMBER"
                                      tabIndex={2}
                                      className="element__input"
                                      validate={(val: any) => {
                                        if (this.props.insTypeId === InsType.Car && !val && !values.ENGINE_NUMBER) return '引擎號碼與車身號碼至少擇一填寫';
                                        if (val.includes(' ')) return '車身號碼不得包含空白字元';
                                        return '';
                                      }}
                                      onBlur={() => {
                                        setFieldTouched('VEHICAL_BODY_NUMBER', true);
                                      }}
                                      placeholder={type === InsTypeDefinesEN[InsTypeEnum.Car] && '進口車請填車身號碼'}
                                    />
                                    <div className="element__error-message">
                                      <ErrorMessage name="VEHICAL_BODY_NUMBER" />
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* {type === InsTypeDefinesEN[InsTypeEnum.Car] && (
                                <p className="vehical-info__reminder">國產車請填引擎號碼，進口車請填車身號碼</p>
                              )} */}
                            </div>
                            <div className="vehical-info__container-right">
                              <VehicleReg>
                                {this.props.insTypeId === InsType.Car &&
                                  <VehicleReg.CarReg
                                    infoData={this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue}
                                    vehicleData={this.props.tempVehicleInfo.tempVehicleInfoFormValue}
                                    selectData={values}
                                  />}
                                {this.props.insTypeId === InsType.Moto &&
                                  <VehicleReg.MotoReg
                                    infoData={this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue}
                                    vehicleData={this.props.tempVehicleInfo.tempVehicleInfoFormValue}
                                    selectData={values}
                                  />}
                              </VehicleReg>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {/* 保險期間 */}
                  <div className="insurance-period">
                    <div className="insurance-period__title">保險期間</div>
                    <div className="insurance-period__content">
                      {type === InsTypeDefinesEN[InsTypeEnum.Moto] && (
                        <div className="insurance-period__row">
                          <div className={'element__form-group' + (errors.COMPULSORY_INS_YEAR && touched.COMPULSORY_INS_YEAR ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-title">{`強制險保險年期${this.handleCheckCompulsoryRequired() ? '*' : ''}`}</div>
                            <div className="element__form-group-content">
                              <Field
                                as="select"
                                name="COMPULSORY_INS_YEAR"
                                data-fieldname="COMPULSORY_INS_YEAR"
                                tabIndex={3}
                                className="element__select"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  this.handleCompulsoryInsYearChange(e, values.COMPULSORY_INS_YEAR, values.POLICY_ITEM, setFieldValue, handleChange);
                                  this.setState({ showCalcBtn: true });
                                }}
                                validate={(val: any) => {
                                  if (!val && this.handleCheckCompulsoryRequired()) return '此為必填欄位';

                                  return '';
                                }}
                              >
                                <option value="">請選擇</option>
                                {motoCoprdOpts}
                              </Field>
                              <span className="insurance-period__highlight-reminder">(請注意：任意險險期間為一年期)</span>
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="COMPULSORY_INS_YEAR" />
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="insurance-period__row">
                        <div className={'element__form-group' + (errors.COMPULSORY_INS_EFFECTIVE_DATE && touched.COMPULSORY_INS_EFFECTIVE_DATE && !values.ARBITRARY_INS_EFFECTIVE_DATE ? ' element__form-group--invalid' : '')}>
                          <div className="element__form-group-title">強制險預定生效日<span className="ant-picker-exam-info">範例： 2020/01/01</span></div>
                          <div className="element__form-group-content">
                            <DatePicker
                              name="COMPULSORY_INS_EFFECTIVE_DATE"
                              data-fieldname="COMPULSORY_INS_EFFECTIVE_DATE"
                              tabIndex={4}
                              className="element__input"
                              format="YYYY/MM/DD"
                              showToday={false}
                              validate={(val: any) => {
                                if (!val && !values.ARBITRARY_INS_EFFECTIVE_DATE) return '強制險預定生效日與任意險預定生效日至少擇一填寫';

                                return '';
                              }}
                              disabledDate={(current) => {
                                const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), this.state.sysTime);
                                return this.handleGetDisabledDate(nzDate);
                              }}
                              onClick={() => {
                                this.getSysTime();
                              }}
                              onChange={(val: any) => {
                                const nzDate = val && commonService.normalizeTime(val.format('YYYY-MM-DD'), this.state.sysTime);
                                this.handleEffectiveDateChange(
                                  nzDate,
                                  VehiclePolicyType.Compulsory,
                                  tempVehicleOwnerInfoState?.policyPeriodRes.COMPULSORY_EXP_STATUS as string,
                                  tempVehicleOwnerInfoState?.policyPeriodRes.COMPULSORY_EDATE,
                                  setFieldValue,
                                  values
                                );
                                setFieldValue('COMPULSORY_INS_EFFECTIVE_DATE', nzDate);
                                this.setState({ showCalcBtn: true });
                                // 檢核預定生效日是否需一致，有錯誤，用強制險預定生效日覆蓋任意險預定生效日
                                const msg = this.handleCheckEffectDate(values.POLICY_ITEM, true, nzDate, values.ARBITRARY_INS_EFFECTIVE_DATE);
                                if (msg) {
                                  setFieldValue('ARBITRARY_INS_EFFECTIVE_DATE', nzDate);
                                }
                              }}
                            />
                            <span className="insurance-period__reminder">
                              {
                                `中午12時起，保期${!values.COMPULSORY_INS_YEAR || values.COMPULSORY_INS_YEAR === '1' ? '一' : '二'}年`
                              }
                            </span>
                          </div>
                          <div className="element__error-message">
                            {
                              values.ARBITRARY_INS_EFFECTIVE_DATE || values.COMPULSORY_INS_EFFECTIVE_DATE
                                ? ''
                                : '強制險預定生效日與任意險預定生效日至少擇一填寫'
                            }
                          </div>
                        </div>
                      </div>
                      <div className="insurance-period__row">
                        <div className={'element__form-group' + ((errors.ARBITRARY_INS_EFFECTIVE_DATE && touched.ARBITRARY_INS_EFFECTIVE_DATE && !values.COMPULSORY_INS_EFFECTIVE_DATE && !values.ARBITRARY_INS_EFFECTIVE_DATE) ? ' element__form-group--invalid' : '')}>
                          <div className="element__form-group-title">任意險預定生效日<span className="ant-picker-exam-info">範例： 2020/01/01</span></div>
                          <div className="element__form-group-content">
                            <DatePicker
                              name="ARBITRARY_INS_EFFECTIVE_DATE"
                              data-fieldname="ARBITRARY_INS_EFFECTIVE_DATE"
                              tabIndex={5}
                              className="element__input"
                              format="YYYY/MM/DD"
                              showToday={false}
                              validate={(val: any) => {
                                if (!val && !values.COMPULSORY_INS_EFFECTIVE_DATE) return '強制險預定生效日與任意險預定生效日至少擇一填寫';

                                return '';
                              }}
                              disabledDate={(current) => {
                                const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), this.state.sysTime);
                                return this.handleGetDisabledDate(nzDate);
                              }}
                              onClick={() => { this.getSysTime(); }}
                              onChange={(val: any) => {
                                const nzDate = val && commonService.normalizeTime(val.format('YYYY-MM-DD'), this.state.sysTime);
                                this.handleEffectiveDateChange(
                                  nzDate,
                                  VehiclePolicyType.Arbitrary,
                                  tempVehicleOwnerInfoState?.policyPeriodRes.VOLUNTARY_EXP_STATUS as string,
                                  tempVehicleOwnerInfoState?.policyPeriodRes.VOLUNTARY_EDATE,
                                  setFieldValue,
                                  values
                                );

                                // 車險重新查詢重置價格
                                this.props.insTypeId === InsType.Car && this.handleUpdareReplacePrice(nzDate);

                                setFieldValue('ARBITRARY_INS_EFFECTIVE_DATE', nzDate);
                                this.setState({ showCalcBtn: true });
                                // 檢核預定生效日是否需一致，有錯誤，用強制險預定生效日覆蓋任意險預定生效日
                                const msg = this.handleCheckEffectDate(values.POLICY_ITEM, true, values.COMPULSORY_INS_EFFECTIVE_DATE, nzDate);
                                if (msg) {
                                  setFieldValue('ARBITRARY_INS_EFFECTIVE_DATE', values.COMPULSORY_INS_EFFECTIVE_DATE);
                                }
                              }}
                            />
                            <span className="insurance-period__reminder">
                              {
                                `中午12時起，保期${!values.COMPULSORY_INS_YEAR || values.COMPULSORY_INS_YEAR === '1' || !values.ARBITRARY_INS_EFFECTIVE_DATE ? '一' : '二'}年`
                              }
                            </span>
                          </div>
                          <div className="element__error-message">
                            {
                              values.COMPULSORY_INS_EFFECTIVE_DATE || values.ARBITRARY_INS_EFFECTIVE_DATE
                                ? ''
                                : '強制險預定生效日與任意險預定生效日至少擇一填寫'
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 選擇方案或商品 */}
                  <div className="select-products">
                    <div className="select-products__title">選擇方案或商品</div>
                    <div className="select-products__content">
                      <div className="select-products__scheme-list">
                        {productOpt}
                      </div>
                      <div className="select-products__scheme-table">
                        {
                          this.state.activePlan && this.state.activePlan === this.state.freePlanId && (
                            <div className="select-products__scheme-table-controls">
                              <button onClick={() => this.handleResetFreeItems(values.COMPULSORY_INS_YEAR)} type="button" className="select-products__scheme-table-favorite-btn">清除</button>
                            </div>
                          )
                        }
                        <div className="select-products__scheme-table-title">
                          <div className="select-products__scheme-table-col">保障內容</div>
                          <div className="select-products__scheme-table-col">原始保費</div>
                          <div className="select-products__scheme-table-col">優惠保費</div>
                        </div>
                        <div className="select-products__scheme-table-content" ref={this.productAreaRef}>
                          <FieldArray name="POLICY_ITEM">
                            {
                              () => (
                                <>
                                  {
                                    values.POLICY_ITEM.length > 0 && (
                                      _.map(values.POLICY_ITEM, (policyItemContent: PolicyItemListContent, policyItemIndex: number) => {
                                        return (
                                          <div className="select-products__scheme-table-part" key={policyItemIndex}>
                                            <div className="select-products__scheme-table-part-title">{policyItemContent.ITEM_TYPE_NAME}</div>
                                            <div className="select-products__scheme-table-part-content">
                                              {
                                                _.map(policyItemContent.MAIN_ITEMS, (mainBaseContent: PolicyBaseItemContent, mainIndex: number) => {
                                                  const activeStatus = this.handleRelativeChecked(mainBaseContent, values.POLICY_ITEM);
                                                  const disabledStatus = this.state.isEcarPlan ? this.handleSetPolicyItemCheckboxDisabledForEcar(mainBaseContent.ITEM_MANDATORY) : false;
                                                  const constrainRes = this.handleItemConstrain(mainBaseContent.CONSTRAIN);

                                                  // 說明：判斷商品 ID 為 01、05、07、11 則「原始保費」、「優惠保費」隱藏 input 使用 span 顯示保費 (保費會與特定子商品做加總)
                                                  const hiddenRule = commonService.getFrontendRule('88C_SERIES_ITEM_HIDDEN');
                                                  const mainItems = hiddenRule ? hiddenRule.mainItems : [];
                                                  const mapping = hiddenRule ? hiddenRule.mapping : [];
                                                  const isTargetParentProd = mainItems.includes(mainBaseContent.ITEM_ID);
                                                  const isHiddenFolderBtn = (mainBaseContent: PolicyBaseItemContent) => {
                                                    const item = mapping.find(it => it.mainId === mainBaseContent.ITEM_ID);
                                                    if (item) {
                                                      return (mainBaseContent.ITEM_ID === item.mainId && mainBaseContent.ADDITIONAL_TERM?.every((subItem) => subItem.ITEM_ID === item.additionalId));
                                                    }
                                                    // 不符合隱藏規則，則顯示收合按鈕
                                                    return false;
                                                  };
                                                  const hiddenFoldBtn = isHiddenFolderBtn(mainBaseContent);
                                                  // ::: End

                                                  if (constrainRes === 'INVISIBLE') return;

                                                  if (mainBaseContent.ITEM_TYPE === VehicleItemType.ITEM_TYPE_SEPARATOR) {
                                                    return (
                                                      React.cloneElement(
                                                        <>
                                                          <div className="select-products__scheme-table-part-item select-products__scheme-table-part-item--button-row">
                                                            <div className="select-products__scheme-table-col">
                                                              {
                                                                ((policyItemContent.MAIN_ITEMS.length - 1 === mainIndex && policyItemContent.SUB_ITEMS.length > 0) || (mainBaseContent.ADDITIONAL_TERM && mainBaseContent.ADDITIONAL_TERM.length > 0)) && (
                                                                  <button
                                                                    type="button"
                                                                    className={'element__icon-button' + (this.state.attachedContractFoldsOpen[policyItemIndex][mainIndex] ? ' element__icon-button--close' : ' element__icon-button--add')}
                                                                    onClick={() => this.handleAttachedContractFoldToggle(policyItemIndex, mainIndex)}
                                                                    style={{ display: hiddenFoldBtn ? 'none' : 'inline-block' }}
                                                                  >
                                                                    {this.state.attachedContractFoldsOpen[policyItemIndex][mainIndex] ? '關閉附約' : '開啟附約'}
                                                                  </button>
                                                                )
                                                              }
                                                            </div>
                                                            <div className="select-products__scheme-table-col">
                                                              <Field
                                                                type="text"
                                                                name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].SEPARATOR`}
                                                                className="select-products__scheme-price-input"
                                                                disabled
                                                              />
                                                            </div>
                                                            <div className="select-products__scheme-table-col">
                                                              <Field
                                                                type="text"
                                                                name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].SEPARATOR`}
                                                                className="select-products__scheme-price-input"
                                                                disabled
                                                              />
                                                            </div>
                                                          </div>
                                                        </>
                                                        , { key: mainIndex })
                                                    );
                                                  }

                                                  return (
                                                    React.cloneElement(
                                                      <>
                                                        <div className="select-products__scheme-table-part-item">
                                                          <div className="select-products__scheme-table-col">
                                                            <div className="element__checkbox-group">
                                                              <label htmlFor={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}]-checkbox`}>
                                                                <div className="element__checkbox" custom-attribute-checked-item-id={mainBaseContent.ITEM_ID}>
                                                                  <Field
                                                                    disabled={this.state.disableProduct || activeStatus || disabledStatus || !this.state.activePlan}
                                                                    type="checkbox"
                                                                    name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].CHECKED`}
                                                                    id={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}]-checkbox`}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                      handleChange(e);
                                                                      this.handleCheckboxOnChange(
                                                                        e.currentTarget.checked, `POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].CHECKED`, mainBaseContent, values.POLICY_ITEM,
                                                                        VehicleItemType.CONTRACT_TYPE_MAIN, tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '');
                                                                    }}
                                                                  />
                                                                  <div className="element__checkbox-btn" />
                                                                </div>
                                                              </label>
                                                              <div className="element__checkbox-group-content" custom-attribute-item-id={mainBaseContent.ITEM_ID}>
                                                                {
                                                                  this.handleFormatPolicyContent(policyItemIndex, mainIndex, 'MAIN_ITEMS', mainBaseContent, activeStatus, disabledStatus, getIn(values, `POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].CHECKED`))
                                                                }
                                                              </div>
                                                            </div>
                                                            {
                                                              ((policyItemContent.MAIN_ITEMS.length - 1 === mainIndex && policyItemContent.SUB_ITEMS.length > 0) || (mainBaseContent.ADDITIONAL_TERM && mainBaseContent.ADDITIONAL_TERM.length > 0)) && (
                                                                <button
                                                                  type="button"
                                                                  className={'element__icon-button' + (this.state.attachedContractFoldsOpen[policyItemIndex][mainIndex] ? ' element__icon-button--close' : ' element__icon-button--add')}
                                                                  onClick={() => this.handleAttachedContractFoldToggle(policyItemIndex, mainIndex)}
                                                                  style={{ display: hiddenFoldBtn ? 'none' : 'inline-block' }}
                                                                >
                                                                  {this.state.attachedContractFoldsOpen[policyItemIndex][mainIndex] ? '關閉附約' : '開啟附約'}
                                                                </button>
                                                              )
                                                            }
                                                          </div>
                                                          <div className="select-products__scheme-table-col">
                                                            {isTargetParentProd && (
                                                              <span className={`policy-item-${policyItemIndex}-main-items-${mainIndex}-rule-premium`}>
                                                                {(values.POLICY_ITEM[policyItemIndex].MAIN_ITEMS[mainIndex] as any).RULEPREMIUM}
                                                              </span>
                                                            )}
                                                            <Field
                                                              type="text"
                                                              name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].RULEPREMIUM`}
                                                              className="select-products__scheme-price-input"
                                                              style={{ display: isTargetParentProd ? 'none' : 'inline-block' }}
                                                              disabled
                                                            />
                                                          </div>
                                                          <div className="select-products__scheme-table-col">
                                                            {isTargetParentProd && (
                                                              <span className={`policy-item-${policyItemIndex}-main-items-${mainIndex}-premium`}>
                                                                {(values.POLICY_ITEM[policyItemIndex].MAIN_ITEMS[mainIndex] as any).PREMIUM}
                                                              </span>
                                                            )}
                                                            <Field
                                                              type="text"
                                                              name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].PREMIUM`}
                                                              className="select-products__scheme-price-input"
                                                              style={{ display: isTargetParentProd ? 'none' : 'inline-block' }}
                                                              disabled
                                                            />
                                                          </div>
                                                        </div>
                                                        {
                                                          mainBaseContent.ADDITIONAL_TERM && (
                                                            <div className="select-products__scheme-table-sub-part">
                                                              <Fold planChange={this.state.planChange} isOpen={this.state.attachedContractFoldsOpen[policyItemIndex][mainIndex] as boolean}>
                                                                {
                                                                  _.map(mainBaseContent.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent, additionalIndex: number) => {
                                                                    const activeStatus = this.handleRelativeChecked(additionalTerm, values.POLICY_ITEM);
                                                                    const disabledStatus = this.state.isEcarPlan ? this.handleSetPolicyItemCheckboxDisabledForEcar(additionalTerm.ITEM_MANDATORY) : false;

                                                                    // 說明：判斷商品 ID 為 88C1、88C5、88C7 則隱藏商品項目，並且與對應的父商品的「原始保費」、「優惠保費」做加總。
                                                                    // 補充：電動車車體險 01E0、05E0、07E0 亦同樣適用，不需調整。(2024/07/30)
                                                                    const isHidden =
                                                                      additionalTerm.ITEM_ID === '88C1' ||
                                                                      additionalTerm.ITEM_ID === '88C5' ||
                                                                      additionalTerm.ITEM_ID === '88C7';
                                                                    if (isHidden) {
                                                                      this.handleCalcTargetParentProdAndChildProdRulePremiumTotal(policyItemIndex, mainIndex, `POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].RULEPREMIUM`);
                                                                      this.handleCalcTargetParentProdAndChildProdPremiumTotal(policyItemIndex, mainIndex, `POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].PREMIUM`);
                                                                    }
                                                                    // ::: End

                                                                    return (
                                                                      <div className="select-products__scheme-table-part-item" style={{ display: isHidden ? 'none' : 'flex' }} key={additionalIndex}>
                                                                        <div className="select-products__scheme-table-col">
                                                                          <div className="element__checkbox-group">
                                                                            <label htmlFor={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}]-checkbox`}>
                                                                              <div className="element__checkbox" custom-attribute-checked-item-id={additionalTerm.ITEM_ID}>
                                                                                <Field
                                                                                  disabled={this.state.disableProduct || activeStatus || disabledStatus || !this.state.activePlan}
                                                                                  type="checkbox"
                                                                                  name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].CHECKED`}
                                                                                  id={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}]-checkbox`}
                                                                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                    handleChange(e);
                                                                                    this.handleCheckboxOnChange(
                                                                                      e.currentTarget.checked, `POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].CHECKED`, additionalTerm, values.POLICY_ITEM,
                                                                                      VehicleItemType.CONTRACT_TYPE_MAIN_ADD, tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '');
                                                                                  }}
                                                                                />
                                                                                <div className="element__checkbox-btn" />
                                                                              </div>
                                                                            </label>
                                                                            <div className="element__checkbox-group-content" custom-attribute-item-id={additionalTerm.ITEM_ID}>
                                                                              {`${additionalTerm.ITEM_ID}.${additionalTerm.ITEM_NAME}`}
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                        <div className="select-products__scheme-table-col">
                                                                          <Field
                                                                            type="text"
                                                                            name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].RULEPREMIUM`}
                                                                            className="select-products__scheme-price-input"
                                                                            disabled
                                                                          />
                                                                        </div>
                                                                        <div className="select-products__scheme-table-col">
                                                                          <Field
                                                                            type="text"
                                                                            name={`POLICY_ITEM[${policyItemIndex}].MAIN_ITEMS[${mainIndex}].ADDITIONAL_TERM[${additionalIndex}].PREMIUM`}
                                                                            className="select-products__scheme-price-input"
                                                                            disabled
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                    );
                                                                  })
                                                                }
                                                              </Fold>
                                                            </div>
                                                          )
                                                        }
                                                      </>
                                                      , { key: mainIndex })
                                                  );
                                                })
                                              }
                                            </div>
                                            <div className="select-products__scheme-table-sub-part">
                                              <Fold 
                                                isOpen={
                                                  this.state.attachedContractFoldsOpen[policyItemIndex][policyItemContent.MAIN_ITEMS.length - 1] as boolean
                                                }
                                                planChange={this.state.planChange}
                                              >
                                                {
                                                  _.map(policyItemContent.SUB_ITEMS, (subBaseContent: PolicyBaseItemContent, subIndex: number) => {
                                                    const activeStatus = this.handleRelativeChecked(subBaseContent, values.POLICY_ITEM);
                                                    const disabledStatus = this.state.isEcarPlan ? this.handleSetPolicyItemCheckboxDisabledForEcar(subBaseContent.ITEM_MANDATORY) : false;
                                                    const constrainRes = this.handleItemConstrain(subBaseContent.CONSTRAIN);
                                                    if (constrainRes === 'INVISIBLE') return;

                                                    // 車體險 87 系列商品顯示邏輯處理
                                                    // 邏輯說明：
                                                    // 01、05、07、07A7 商品未選取 => 87 商品顯示，87A1、87A5、87A7 商品隱藏。
                                                    // 01 商品選取 => 87 商品隱藏，87A1 商品顯示。
                                                    // 05 商品選取 => 87 商品隱藏，87A5 商品顯示。
                                                    // 07、07A7 商品選取 => 87 商品隱藏，87A7 商品顯示。
                                                    if (subBaseContent.ITEM_ID === '87' && !activeStatus) return;
                                                    if ((subBaseContent.ITEM_ID === '87A1' || subBaseContent.ITEM_ID === '87A5' || subBaseContent.ITEM_ID === '87A7') && (this.state.disableProduct || activeStatus || !this.state.activePlan)) return;
                                                    // ::: End

                                                    // 說明：判斷商品 ID 為 17C 則隱藏商品項目，並且與對應的父商品的「原始保費」、「優惠保費」做加總。
                                                    const isHidden = subBaseContent.ITEM_ID === '17C';
                                                    if (isHidden) {
                                                      const mainItemIndex = policyItemContent.MAIN_ITEMS.findIndex((mainItem) => mainItem.ITEM_TYPE === VehicleItemType.ITEM_TYPE_TF);
                                                      this.handleCalcTargetParentProdAndChildProdRulePremiumTotal(policyItemIndex, mainItemIndex, `POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].RULEPREMIUM`);
                                                      this.handleCalcTargetParentProdAndChildProdPremiumTotal(policyItemIndex, mainItemIndex, `POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].PREMIUM`);
                                                    }
                                                    // ::: End

                                                    return (
                                                      React.cloneElement(
                                                        <>
                                                          <div className="select-products__scheme-table-part-item" style={{ display: isHidden ? 'none' : 'flex' }} key={subIndex}>
                                                            <div className="select-products__scheme-table-col">
                                                              <div className="element__checkbox-group">
                                                                <label htmlFor={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}]-checkbox`}>
                                                                  <div className="element__checkbox" custom-attribute-checked-item-id={subBaseContent.ITEM_ID}>
                                                                    <Field
                                                                      disabled={this.state.disableProduct || activeStatus || disabledStatus || !this.state.activePlan}
                                                                      type="checkbox"
                                                                      name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].CHECKED`}
                                                                      id={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}]-checkbox`}
                                                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                        handleChange(e);
                                                                        this.handleCheckboxOnChange(
                                                                          e.currentTarget.checked, `POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].CHECKED`, subBaseContent, values.POLICY_ITEM,
                                                                          VehicleItemType.CONTRACT_TYPE_SUB, tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '');
                                                                        if (e.currentTarget.checked && constrainRes) {
                                                                          sweetAlertService.modal({
                                                                            icon: SweetAlertIcon.Info,
                                                                            html: constrainRes
                                                                          });
                                                                        }
                                                                      }}
                                                                    />
                                                                    <div className="element__checkbox-btn" />
                                                                  </div>
                                                                </label>
                                                                <div className="element__checkbox-group-content" custom-attribute-item-id={subBaseContent.ITEM_ID}>
                                                                  {
                                                                    this.handleFormatPolicyContent(policyItemIndex, subIndex, 'SUB_ITEMS', subBaseContent, activeStatus, disabledStatus, getIn(values, `POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].CHECKED`))
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="select-products__scheme-table-col">
                                                              <Field
                                                                type="text"
                                                                name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].RULEPREMIUM`}
                                                                className="select-products__scheme-price-input"
                                                                disabled
                                                              />
                                                            </div>
                                                            <div className="select-products__scheme-table-col">
                                                              <Field
                                                                type="text"
                                                                name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].PREMIUM`}
                                                                className="select-products__scheme-price-input"
                                                                disabled
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="select-products__scheme-table-additional-part">
                                                            {
                                                              subBaseContent.ADDITIONAL_TERM && (
                                                                _.map(subBaseContent.ADDITIONAL_TERM, (additionalTerm: PolicyBaseItemContent, additionIndex: number) => {
                                                                  const activeStatus = this.handleRelativeChecked(additionalTerm, values.POLICY_ITEM);
                                                                  const disabledStatus = this.state.isEcarPlan ? this.handleSetPolicyItemCheckboxDisabledForEcar(additionalTerm.ITEM_MANDATORY) : false;
                                                                  return (
                                                                    <div className="select-products__scheme-table-part-item" key={additionIndex}>
                                                                      <div className="select-products__scheme-table-col">
                                                                        <div className="element__checkbox-group">
                                                                          <label htmlFor={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}]-checkbox`}>
                                                                            <div className="element__checkbox" custom-attribute-checked-item-id={additionalTerm.ITEM_ID}>
                                                                              <Field
                                                                                disabled={this.state.disableProduct || activeStatus || disabledStatus || !this.state.activePlan}
                                                                                type="checkbox"
                                                                                name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}].CHECKED`}
                                                                                id={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}]-checkbox`}
                                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                  handleChange(e);
                                                                                  this.handleCheckboxOnChange(
                                                                                    e.currentTarget.checked, `POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}].CHECKED`, additionalTerm, values.POLICY_ITEM,
                                                                                    VehicleItemType.CONTRACT_TYPE_SUB_ADD, tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '');
                                                                                }}
                                                                              />
                                                                              <div className="element__checkbox-btn" />
                                                                            </div>
                                                                          </label>
                                                                          <div className="element__checkbox-group-content" custom-attribute-item-id={additionalTerm.ITEM_ID}>
                                                                            {`${additionalTerm.ITEM_ID}.${additionalTerm.ITEM_NAME}`}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="select-products__scheme-table-col">
                                                                        <Field
                                                                          type="text"
                                                                          name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}].RULEPREMIUM`}
                                                                          className="select-products__scheme-price-input"
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                      <div className="select-products__scheme-table-col">
                                                                        <Field
                                                                          type="text"
                                                                          name={`POLICY_ITEM[${policyItemIndex}].SUB_ITEMS[${subIndex}].ADDITIONAL_TERM[${additionIndex}].PREMIUM`}
                                                                          className="select-products__scheme-price-input"
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })
                                                              )
                                                            }
                                                          </div>
                                                        </>
                                                        , { key: subIndex })
                                                    );
                                                  })
                                                }
                                              </Fold>
                                            </div>
                                          </div>
                                        );
                                      })
                                    )
                                  }
                                </>
                              )
                            }
                          </FieldArray>
                        </div>
                        <div className="select-products__scheme-table-total">
                          <div className="select-products__scheme-table-col">{`NT$ ${commonService.thousandFormat(`${commonService.getVehiclePrenium(this.state.evalCarRes?.SUMPREMIUM[0]?.SUMPREMIUM, this.state.evalCarRes?.SUMPREMIUM[0]?.SUMPREMIUMCI)}`)}`}</div>
                          <div className="select-products__scheme-table-col">{`NT$ ${commonService.thousandFormat(`${commonService.getVehiclePrenium(this.state.evalCarRes?.SUMPREMIUM[1]?.SUMPREMIUM, this.state.evalCarRes?.SUMPREMIUM[1]?.SUMPREMIUMCI)}`)}`}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="insure-process-select__controls">
                  <button type="button" className="element__button element__button--red-border" onClick={() => this.handleGoBack(values, resetForm)}>返回上一頁</button>
                  {
                    this.state.showCalcBtn ? (
                      <button
                        type="submit"
                        className="element__button element__button--red"
                        disabled={this.state.isReplanementPriceError || this.state.isCompulsoryDateError || this.state.isArbitraryDateError}
                      >
                        試算
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="element__button element__button--red"
                        disabled={this.state.isReplanementPriceError || this.state.isCompulsoryDateError || this.state.isArbitraryDateError}
                      >
                        下一步
                      </button>
                    )
                  }
                </div>
                <FormikFocusError />
              </Form>
            )
          }
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: any[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
    setInfoModalVisible: (visible: boolean, title?: string, content?: string) => dispatch(setInfoModalVisibleAction(visible, title, content))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(InsureProcessSelect);
